webpackJsonp(["1"],{

/***/ "./node_modules/antd/dist/antd.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/antd/es/icon/style/css.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css__ = __webpack_require__("./node_modules/antd/es/style/index.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_css__);


/***/ }),

/***/ "./node_modules/antd/es/input/style/css.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css__ = __webpack_require__("./node_modules/antd/es/style/index.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__("./node_modules/antd/es/input/style/index.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);



/***/ }),

/***/ "./node_modules/antd/es/input/style/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/antd/es/layout/style/css.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css__ = __webpack_require__("./node_modules/antd/es/style/index.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__("./node_modules/antd/es/layout/style/index.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);



/***/ }),

/***/ "./node_modules/antd/es/layout/style/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/antd/es/locale-provider/style/css.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css__ = __webpack_require__("./node_modules/antd/es/locale-provider/style/index.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_css__);


/***/ }),

/***/ "./node_modules/antd/es/locale-provider/style/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/antd/es/menu/style/css.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css__ = __webpack_require__("./node_modules/antd/es/style/index.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__("./node_modules/antd/es/menu/style/index.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tooltip_style_css__ = __webpack_require__("./node_modules/antd/es/tooltip/style/css.js");


// style dependencies


/***/ }),

/***/ "./node_modules/antd/es/menu/style/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/antd/es/message/style/css.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css__ = __webpack_require__("./node_modules/antd/es/style/index.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__("./node_modules/antd/es/message/style/index.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);



/***/ }),

/***/ "./node_modules/antd/es/message/style/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/antd/es/style/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/antd/es/tooltip/style/css.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css__ = __webpack_require__("./node_modules/antd/es/style/index.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__("./node_modules/antd/es/tooltip/style/index.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);



/***/ }),

/***/ "./node_modules/antd/es/tooltip/style/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/antd/lib/calendar/locale/en_US.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _en_US = __webpack_require__("./node_modules/antd/lib/date-picker/locale/en_US.js");

var _en_US2 = _interopRequireDefault(_en_US);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _en_US2['default'];
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/antd/lib/date-picker/locale/en_US.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _en_US = __webpack_require__("./node_modules/rc-calendar/lib/locale/en_US.js");

var _en_US2 = _interopRequireDefault(_en_US);

var _en_US3 = __webpack_require__("./node_modules/antd/lib/time-picker/locale/en_US.js");

var _en_US4 = _interopRequireDefault(_en_US3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Merge into a locale object
var locale = {
    lang: (0, _extends3['default'])({ placeholder: 'Select date', rangePlaceholder: ['Start date', 'End date'] }, _en_US2['default']),
    timePickerLocale: (0, _extends3['default'])({}, _en_US4['default'])
};
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
exports['default'] = locale;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/antd/lib/locale-provider/en_US.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__("./node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

var _en_US = __webpack_require__("./node_modules/rc-pagination/lib/locale/en_US.js");

var _en_US2 = _interopRequireDefault(_en_US);

var _en_US3 = __webpack_require__("./node_modules/antd/lib/date-picker/locale/en_US.js");

var _en_US4 = _interopRequireDefault(_en_US3);

var _en_US5 = __webpack_require__("./node_modules/antd/lib/time-picker/locale/en_US.js");

var _en_US6 = _interopRequireDefault(_en_US5);

var _en_US7 = __webpack_require__("./node_modules/antd/lib/calendar/locale/en_US.js");

var _en_US8 = _interopRequireDefault(_en_US7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_moment2['default'].locale('en');
exports['default'] = {
    locale: 'en',
    Pagination: _en_US2['default'],
    DatePicker: _en_US4['default'],
    TimePicker: _en_US6['default'],
    Calendar: _en_US8['default'],
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        notFoundContent: 'Not Found',
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items'
    },
    Select: {
        notFoundContent: 'Not Found'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file'
    }
};
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/antd/lib/time-picker/locale/en_US.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    placeholder: 'Select time'
};
exports['default'] = locale;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-runtime/regenerator/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/regenerator-runtime/runtime-module.js");


/***/ }),

/***/ "./node_modules/draft-js/dist/Draft.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/font-awesome/css/font-awesome.min.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./node_modules/history/cjs/history.min.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__("./node_modules/resolve-pathname/esm/resolve-pathname.js")),valueEqual=_interopDefault(__webpack_require__("./node_modules/value-equal/esm/value-equal.js"));__webpack_require__("./node_modules/tiny-warning/dist/tiny-warning.esm.js");var invariant=_interopDefault(__webpack_require__("./node_modules/tiny-invariant/dist/tiny-invariant.esm.js"));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),

/***/ "./node_modules/history/createBrowserHistory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("./node_modules/history/warnAboutDeprecatedCJSRequire.js")('createBrowserHistory');
module.exports = __webpack_require__("./node_modules/history/index.js").createBrowserHistory;


/***/ }),

/***/ "./node_modules/history/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__("./node_modules/history/cjs/history.min.js");
} else {
  module.exports = require('./cjs/history.js');
}


/***/ }),

/***/ "./node_modules/history/warnAboutDeprecatedCJSRequire.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var printWarning = function() {};

if (false) {
  printWarning = function(format, subs) {
    var index = 0;
    var message =
      'Warning: ' +
      (subs.length > 0
        ? format.replace(/%s/g, function() {
            return subs[index++];
          })
        : format);

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging history ---
      // This error was thrown as a convenience so that you can use the
      // stack trace to find the callsite that triggered this warning.
      throw new Error(message);
    } catch (e) {}
  };
}

module.exports = function(member) {
  printWarning(
    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
      'Support for the latter will be removed in the next major release.',
    [member, member]
  );
};


/***/ }),

/***/ "./node_modules/moment-timezone/data/packed/latest.json":
/***/ (function(module, exports) {

module.exports = {"version":"2018g","zones":["Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6"],"links":["Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane"]}

/***/ }),

/***/ "./node_modules/moment-timezone/index.js":
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__("./node_modules/moment-timezone/moment-timezone.js");
moment.tz.load(__webpack_require__("./node_modules/moment-timezone/data/packed/latest.json"));


/***/ }),

/***/ "./node_modules/moment-timezone/moment-timezone.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.46
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(__webpack_require__("./node_modules/moment/moment.js")); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("./node_modules/moment/moment.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.46",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	function closest (num, arr) {
		var len = arr.length;
		if (num < arr[0]) {
			return 0;
		} else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) {
			return len - 1;
		} else if (num >= arr[len - 1]) {
			return -1;
		}

		var mid;
		var lo = 0;
		var hi = len - 1;
		while (hi - lo > 1) {
			mid = Math.floor((lo + hi) / 2);
			if (arr[mid] <= num) {
				lo = mid;
			} else {
				hi = mid;
			}
		}
		return hi;
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			i = closest(target, untils);
			if (i >= 0) {
				return i;
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			lastOffset = last.offset,
			offsets = [last],
			change, next, nextOffset, i;

		for (i = 1; i < 48; i++) {
			nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
			if (nextOffset !== lastOffset) {
				// Create OffsetAt here to avoid unnecessary abbr parsing before checking offsets
				next = new OffsetAt(new Date(startYear, i, 1));
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				last = next;
				lastOffset = nextOffset;
			}
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			checkedOffsets = {},
			i, j, offset, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			offset = offsets[i].offset;
			if (checkedOffsets.hasOwnProperty(offset)) {
				continue;
			}
			guessesOffset = guesses[offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
			checkedOffsets[offset] = true;
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			out  = moment.utc.apply(null, args),
			zone;

		if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),

/***/ "./node_modules/polished/dist/polished.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export adjustHue */
/* unused harmony export animation */
/* unused harmony export backgroundImages */
/* unused harmony export backgrounds */
/* unused harmony export borderColor */
/* unused harmony export borderRadius */
/* unused harmony export borderStyle */
/* unused harmony export borderWidth */
/* unused harmony export buttons */
/* unused harmony export clearFix */
/* unused harmony export complement */
/* unused harmony export darken */
/* unused harmony export desaturate */
/* unused harmony export directionalProperty */
/* unused harmony export ellipsis */
/* unused harmony export em */
/* unused harmony export fontFace */
/* unused harmony export getLuminance */
/* unused harmony export grayscale */
/* unused harmony export invert */
/* unused harmony export hideText */
/* unused harmony export hideVisually */
/* unused harmony export hiDPI */
/* unused harmony export hsl */
/* unused harmony export hsla */
/* unused harmony export lighten */
/* unused harmony export margin */
/* unused harmony export mix */
/* unused harmony export modularScale */
/* unused harmony export normalize */
/* unused harmony export opacify */
/* unused harmony export padding */
/* unused harmony export parseToHsl */
/* unused harmony export parseToRgb */
/* unused harmony export placeholder */
/* unused harmony export position */
/* unused harmony export radialGradient */
/* unused harmony export readableColor */
/* unused harmony export rem */
/* unused harmony export retinaImage */
/* unused harmony export rgb */
/* unused harmony export rgba */
/* unused harmony export saturate */
/* unused harmony export selection */
/* unused harmony export setHue */
/* unused harmony export setLightness */
/* unused harmony export setSaturation */
/* unused harmony export shade */
/* unused harmony export size */
/* unused harmony export stripUnit */
/* unused harmony export textInputs */
/* unused harmony export timingFunctions */
/* unused harmony export tint */
/* unused harmony export toColorString */
/* unused harmony export transitions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curriedTransparentize; });
/* unused harmony export triangle */
/* unused harmony export wordWrap */
//      

// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

//      
var positionMap = ['Top', 'Right', 'Bottom', 'Left'];

function generateProperty(property, position) {
  if (!property) return position.toLowerCase();
  var splitProperty = property.split('-');
  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position);
    return splitProperty.reduce(function (acc, val) {
      return '' + acc + capitalizeString(val);
    });
  }
  var joinedProperty = property.replace(/([a-z])([A-Z])/g, '$1' + position + '$2');
  return property === joinedProperty ? '' + property + position : joinedProperty;
}

function generateStyles(property, valuesWithDefaults) {
  var styles = {};
  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      styles[generateProperty(property, positionMap[i])] = valuesWithDefaults[i];
    }
  }
  return styles;
}

/**
 * A helper that enables shorthand for direction based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */

function directionalProperty(property) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  //  prettier-ignore
  var firstValue = values[0],
      _values$ = values[1],
      secondValue = _values$ === undefined ? firstValue : _values$,
      _values$2 = values[2],
      thirdValue = _values$2 === undefined ? firstValue : _values$2,
      _values$3 = values[3],
      fourthValue = _values$3 === undefined ? secondValue : _values$3;

  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property, valuesWithDefaults);
}

//      

function endsWith (string, suffix) {
  return string.substr(-suffix.length) === suffix;
}

//      

/**
 * Strip the unit from a given CSS value, returning just the number. (or the original value if an invalid string was passed)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */

function stripUnit(value) {
  var unitlessValue = parseFloat(value);
  if (isNaN(unitlessValue)) return value;
  return unitlessValue;
}

//      

/**
 * Factory function that creates pixel-to-x converters
 * @private
 */
var pxtoFactory = function pxtoFactory(to) {
  return function (pxval) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16px';

    var newPxval = pxval;
    var newBase = base;
    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
      }
      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base + '" instead.');
      }
      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
    }

    if (typeof newBase === 'string') {
      throw new Error('Passed invalid base value ("' + base + '") to ' + to + '(), please pass a value like "12px" or 12.');
    }

    return '' + newPxval / newBase + to;
  };
};

//      
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */

var em = /*#__PURE__*/pxtoFactory('em');

//      

var ratioNames = {
  minorSecond: 1.067,
  majorSecond: 1.125,
  minorThird: 1.2,
  majorThird: 1.25,
  perfectFourth: 1.333,
  augFourth: 1.414,
  perfectFifth: 1.5,
  minorSixth: 1.6,
  goldenSection: 1.618,
  majorSixth: 1.667,
  minorSeventh: 1.778,
  majorSeventh: 1.875,
  octave: 2,
  majorTenth: 2.5,
  majorEleventh: 2.667,
  majorTwelfth: 3,
  doubleOctave: 4

  /** */

  /**
   * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables, see below.
   * @example
   * // Styles as object usage
   * const styles = {
   *    // Increment two steps up the default scale
   *   'fontSize': modularScale(2)
   * }
   *
   * // styled-components usage
   * const div = styled.div`
   *    // Increment two steps up the default scale
   *   fontSize: ${modularScale(2)}
   * `
   *
   * // CSS in JS Output
   *
   * element {
   *   'fontSize': '1.77689em'
   * }
   */
};function modularScale(steps) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1em';
  var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perfectFourth';

  if (typeof steps !== 'number') {
    throw new Error('Please provide a number of steps to the modularScale helper.');
  }
  if (typeof ratio === 'string' && !ratioNames[ratio]) {
    throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
  }

  var realBase = typeof base === 'string' ? stripUnit(base) : base;
  var realRatio = typeof ratio === 'string' ? ratioNames[ratio] : ratio;

  if (typeof realBase === 'string') {
    throw new Error('Invalid value passed as base to modularScale, expected number or em string but got "' + base + '"');
  }

  return realBase * Math.pow(realRatio, steps) + 'em';
}

//      

/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */

var rem = /*#__PURE__*/pxtoFactory('rem');

//      

/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */

function clearFix() {
  var _ref;

  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';

  var pseudoSelector = parent + '::after';
  return _ref = {}, _ref[pseudoSelector] = {
    clear: 'both',
    content: '""',
    display: 'table'
  }, _ref;
}

//      

/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */

function ellipsis() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';

  return {
    display: 'inline-block',
    maxWidth: width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
}

//      

/** */

function generateFileReferences(fontFilePath, fileFormats) {
  var fileFontReferences = fileFormats.map(function (format) {
    return 'url("' + fontFilePath + '.' + format + '")';
  });
  return fileFontReferences.join(', ');
}

function generateLocalReferences(localFonts) {
  var localFontReferences = localFonts.map(function (font) {
    return 'local("' + font + '")';
  });
  return localFontReferences.join(', ');
}

function generateSources(fontFilePath, localFonts, fileFormats) {
  var fontReferences = [];
  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));
  if (fontFilePath) {
    fontReferences.push(generateFileReferences(fontFilePath, fileFormats));
  }
  return fontReferences.join(', ');
}

/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro'
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * injectGlobal`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro'
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */

function fontFace(_ref) {
  var fontFamily = _ref.fontFamily,
      fontFilePath = _ref.fontFilePath,
      fontStretch = _ref.fontStretch,
      fontStyle = _ref.fontStyle,
      fontVariant = _ref.fontVariant,
      fontWeight = _ref.fontWeight,
      _ref$fileFormats = _ref.fileFormats,
      fileFormats = _ref$fileFormats === undefined ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
      localFonts = _ref.localFonts,
      unicodeRange = _ref.unicodeRange;

  // Error Handling
  if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
  if (!fontFilePath && !localFonts) {
    throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
  }
  if (localFonts && !Array.isArray(localFonts)) {
    throw new Error('fontFace expects localFonts to be an array.');
  }
  if (!Array.isArray(fileFormats)) {
    throw new Error('fontFace expects fileFormats to be an array.');
  }

  var fontFaceDeclaration = {
    '@font-face': {
      fontFamily: fontFamily,
      src: generateSources(fontFilePath, localFonts, fileFormats),
      unicodeRange: unicodeRange,
      fontStretch: fontStretch,
      fontStyle: fontStyle,
      fontVariant: fontVariant,
      fontWeight: fontWeight
    }

    // Removes undefined fields for cleaner css object.
  };return JSON.parse(JSON.stringify(fontFaceDeclaration));
}

//      

/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */

function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

//      

/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */

function hideVisually() {
  return {
    border: '0',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  };
}

//      

/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */

function hiDPI() {
  var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.3;

  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



























var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

var _opinionatedRules;
var _abbrTitle;
var _unopinionatedRules;

//      
var opinionatedRules = (_opinionatedRules = {
  html: {
    fontFamily: 'sans-serif'
  },

  body: {
    margin: '0'
  }

}, _opinionatedRules['a:active,\n  a:hover'] = {
  outlineWidth: '0'
}, _opinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
  fontFamily: 'sans-serif',
  fontSize: '100%',
  lineHeight: '1.15'
}, _opinionatedRules);

var unopinionatedRules = (_unopinionatedRules = {
  html: {
    lineHeight: '1.15',
    textSizeAdjust: '100%'
  }

}, _unopinionatedRules['article,\n  aside,\n  footer,\n  header,\n  nav,\n  section'] = {
  display: 'block'
}, _unopinionatedRules.h1 = {
  fontSize: '2em',
  margin: '0.67em 0'
}, _unopinionatedRules['figcaption,\n  figure,\n  main'] = {
  display: 'block'
}, _unopinionatedRules.figure = {
  margin: '1em 40px'
}, _unopinionatedRules.hr = {
  boxSizing: 'content-box',
  height: '0',
  overflow: 'visible'
}, _unopinionatedRules.pre = {
  fontFamily: 'monospace, monospace',
  fontSize: '1em'
}, _unopinionatedRules.a = {
  'background-color': 'transparent',
  '-webkit-text-decoration-skip': 'objects'
}, _unopinionatedRules['abbr[title]'] = (_abbrTitle = {
  borderBottom: 'none',
  textDecoration: 'underline'
}, _abbrTitle['textDecoration'] = 'underline dotted', _abbrTitle), _unopinionatedRules['b,\n  strong'] = {
  fontWeight: 'inherit'
}, _unopinionatedRules['code,\n  kbd,\n  samp'] = {
  fontFamily: 'monospace, monospace',
  fontSize: '1em'
}, _unopinionatedRules.dfn = {
  fontStyle: 'italic'
}, _unopinionatedRules.mark = {
  backgroundColor: '#ff0',
  color: '#000'
}, _unopinionatedRules.small = {
  fontSize: '80%'
}, _unopinionatedRules['sub,\n  sup'] = {
  fontSize: '75%',
  lineHeight: '0',
  position: 'relative',
  verticalAlign: 'baseline'
}, _unopinionatedRules.sub = {
  bottom: '-0.25em'
}, _unopinionatedRules.sup = {
  top: '-0.5em'
}, _unopinionatedRules['audio,\n  video'] = {
  display: 'inline-block'
}, _unopinionatedRules['audio:not([controls])'] = {
  display: 'none',
  height: '0'
}, _unopinionatedRules.img = {
  borderStyle: 'none'
}, _unopinionatedRules['svg:not(:root)'] = {
  overflow: 'hidden'
}, _unopinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
  margin: '0'
}, _unopinionatedRules['button,\n  input'] = {
  overflow: 'visible'
}, _unopinionatedRules['button,\n  select'] = {
  textTransform: 'none'
}, _unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]'] = {
  '-webkit-appearance': 'button'
}, _unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner'] = {
  borderStyle: 'none',
  padding: '0'
}, _unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring'] = {
  outline: '1px dotted ButtonText'
}, _unopinionatedRules.fieldset = {
  border: '1px solid #c0c0c0',
  margin: '0 2px',
  padding: '0.35em 0.625em 0.75em'
}, _unopinionatedRules.legend = {
  boxSizing: 'border-box',
  color: 'inherit',
  display: 'table',
  maxWidth: '100%',
  padding: '0',
  whiteSpace: 'normal'
}, _unopinionatedRules.progress = {
  display: 'inline-block',
  verticalAlign: 'baseline'
}, _unopinionatedRules.textarea = {
  overflow: 'auto'
}, _unopinionatedRules['[type="checkbox"],\n  [type="radio"]'] = {
  boxSizing: 'border-box',
  padding: '0'
}, _unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button'] = {
  height: 'auto'
}, _unopinionatedRules['[type="search"]'] = {
  '-webkit-appearance': 'textfield',
  outlineOffset: '-2px'
}, _unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration'] = {
  '-webkit-appearance': 'none'
}, _unopinionatedRules['::-webkit-file-upload-button'] = {
  '-webkit-appearance': 'button',
  font: 'inherit'
}, _unopinionatedRules['details,\n  menu'] = {
  display: 'block'
}, _unopinionatedRules.summary = {
  display: 'list-item'
}, _unopinionatedRules.canvas = {
  display: 'inline-block'
}, _unopinionatedRules.template = {
  display: 'none'
}, _unopinionatedRules['[hidden]'] = {
  display: 'none'
}, _unopinionatedRules);

function mergeRules(baseRules, additionalRules) {
  var mergedRules = _extends({}, baseRules);
  Object.keys(additionalRules).forEach(function (key) {
    if (mergedRules[key]) {
      mergedRules[key] = _extends({}, mergedRules[key], additionalRules[key]);
    } else {
      mergedRules[key] = _extends({}, additionalRules[key]);
    }
  });
  return mergedRules;
}

/**
 * CSS to normalize abnormalities across browsers (normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * injectGlobal`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   fontFamily: 'sans-serif',
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */
function normalize(excludeOpinionated) {
  if (excludeOpinionated) return unopinionatedRules;
  return mergeRules(unopinionatedRules, opinionatedRules);
}

//      

/**
 * CSS to style the placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */

function placeholder(styles) {
  var _ref;

  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';

  return _ref = {}, _ref[parent + '::-webkit-input-placeholder'] = _extends({}, styles), _ref[parent + ':-moz-placeholder'] = _extends({}, styles), _ref[parent + '::-moz-placeholder'] = _extends({}, styles), _ref[parent + ':-ms-input-placeholder'] = _extends({}, styles), _ref;
}

var _templateObject = /*#__PURE__*/ taggedTemplateLiteralLoose(['radial-gradient(', '', '', '', ')'], ['radial-gradient(', '', '', '', ')']);

//      

/** */

function parseFallback(colorStops) {
  return colorStops[0].split(' ')[0];
}

function constructGradientValue(literals) {
  var template = '';
  for (var i = 0; i < literals.length; i += 1) {
    template += literals[i];
    // Adds leading coma if properties preceed color-stops
    if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
      template = template.slice(0, -1);
      template += ', ' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
      // No trailing space if color-stops is the only param provided
    } else if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) {
      template += '' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
      // Only adds substitution if it is defined
    } else if (arguments.length <= i + 1 ? undefined : arguments[i + 1]) {
      template += (arguments.length <= i + 1 ? undefined : arguments[i + 1]) + ' ';
    }
  }
  return template.trim();
}

/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */

function radialGradient(_ref) {
  var colorStops = _ref.colorStops,
      extent = _ref.extent,
      fallback = _ref.fallback,
      position = _ref.position,
      shape = _ref.shape;

  if (!colorStops || colorStops.length < 2) {
    throw new Error('radialGradient requries at least 2 color-stops to properly render.');
  }
  return {
    backgroundColor: fallback || parseFallback(colorStops),
    backgroundImage: constructGradientValue(_templateObject, position, shape, extent, colorStops.join(', '))
  };
}

//      

/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */
function retinaImage(filename, backgroundSize) {
  var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';

  var _ref;

  var retinaFilename = arguments[3];
  var retinaSuffix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '_2x';

  if (!filename) {
    throw new Error('Please supply a filename to retinaImage() as the first argument.');
  }
  // Replace the dot at the beginning of the passed extension if one exists
  var ext = extension.replace(/^\./, '');
  var rFilename = retinaFilename ? retinaFilename + '.' + ext : '' + filename + retinaSuffix + '.' + ext;

  return _ref = {
    backgroundImage: 'url(' + filename + '.' + ext + ')'
  }, _ref[hiDPI()] = {
    backgroundImage: 'url(' + rFilename + ')',
    backgroundSize: backgroundSize
  }, _ref;
}

//      

/**
 * CSS to style the selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */

function selection(styles) {
  var _ref;

  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return _ref = {}, _ref[parent + '::-moz-selection'] = _extends({}, styles), _ref[parent + '::selection'] = _extends({}, styles), _ref;
}

//      

/* eslint-disable key-spacing */
var functionsMap = {
  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',

  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',

  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
  /* eslint-enable key-spacing */

  /** */

  /**
   * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
   *
   * @example
   * // Styles as object usage
   * const styles = {
   *   'transitionTimingFunction': timingFunctions('easeInQuad')
   * }
   *
   * // styled-components usage
   *  const div = styled.div`
   *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
   * `
   *
   * // CSS as JS Output
   *
   * 'div': {
   *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
   * }
   */

};function timingFunctions(timingFunction) {
  return functionsMap[timingFunction];
}

//      

/** */

var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
  switch (pointingDirection) {
    case 'top':
      return '0 ' + width / 2 + 'px ' + height + 'px ' + width / 2 + 'px';
    case 'left':
      return height / 2 + 'px ' + width + 'px ' + height / 2 + 'px 0';
    case 'bottom':
      return height + 'px ' + width / 2 + 'px 0 ' + width / 2 + 'px';
    case 'right':
      return height / 2 + 'px 0 ' + height / 2 + 'px ' + width + 'px';

    default:
      throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
  }
};

// needed for border-color
var reverseDirection = {
  left: 'Right',
  right: 'Left',
  top: 'Bottom',
  bottom: 'Top'

  /**
   * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
   *
   * @example
   * // Styles as object usage
   *
   * const styles = {
   *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
   * }
   *
   *
   * // styled-components usage
   * const div = styled.div`
   *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
   *
   *
   * // CSS as JS Output
   *
   * div: {
   *  'borderColor': 'transparent',
   *  'borderLeftColor': 'red !important',
   *  'borderStyle': 'solid',
   *  'borderWidth': '50px 0 50px 100px',
   *  'height': '0',
   *  'width': '0',
   * }
   */

};function triangle(_ref) {
  var _ref2;

  var pointingDirection = _ref.pointingDirection,
      height = _ref.height,
      width = _ref.width,
      foregroundColor = _ref.foregroundColor,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;

  var unitlessHeight = parseFloat(height);
  var unitlessWidth = parseFloat(width);
  if (isNaN(unitlessHeight) || isNaN(unitlessWidth)) {
    throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
  }

  return _ref2 = {
    borderColor: backgroundColor,
    width: '0',
    height: '0',
    borderWidth: getBorderWidth(pointingDirection, unitlessHeight, unitlessWidth),
    borderStyle: 'solid'
  }, _ref2['border' + reverseDirection[pointingDirection] + 'Color'] = foregroundColor + ' !important', _ref2;
}

//      

/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */

function wordWrap() {
  var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'break-word';

  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
  return {
    overflowWrap: wrap,
    wordWrap: wrap,
    wordBreak: wordBreak
  };
}

//      


function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness) {
  var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : convertToInt;

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  }

  // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
  var huePrime = hue % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));

  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

//      
var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'

  /**
   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
   * @private
   */
};function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? '#' + namedColorMap[normalizedColorName] : color;
}

//      
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var hslRegex = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var hslaRegex = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;

/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */
function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt('' + rgbMatched[1], 10),
      green: parseInt('' + rgbMatched[2], 10),
      blue: parseInt('' + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor);
  if (rgbaMatched) {
    return {
      red: parseInt('' + rgbaMatched[1], 10),
      green: parseInt('' + rgbaMatched[2], 10),
      blue: parseInt('' + rgbaMatched[3], 10),
      alpha: parseFloat('' + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt('' + hslMatched[1], 10);
    var saturation = parseInt('' + hslMatched[2], 10) / 100;
    var lightness = parseInt('' + hslMatched[3], 10) / 100;
    var rgbColorString = 'rgb(' + hslToRgb(hue, saturation, lightness) + ')';
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + rgbColorString + '.');
    }
    return {
      red: parseInt('' + hslRgbMatched[1], 10),
      green: parseInt('' + hslRgbMatched[2], 10),
      blue: parseInt('' + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor);
  if (hslaMatched) {
    var _hue = parseInt('' + hslaMatched[1], 10);
    var _saturation = parseInt('' + hslaMatched[2], 10) / 100;
    var _lightness = parseInt('' + hslaMatched[3], 10) / 100;
    var _rgbColorString = 'rgb(' + hslToRgb(_hue, _saturation, _lightness) + ')';
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + _rgbColorString + '.');
    }
    return {
      red: parseInt('' + _hslRgbMatched[1], 10),
      green: parseInt('' + _hslRgbMatched[2], 10),
      blue: parseInt('' + _hslRgbMatched[3], 10),
      alpha: parseFloat('' + hslaMatched[4])
    };
  }
  throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}

//      


function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;

  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return { hue: 0, saturation: 0, lightness: lightness };
    }
  }

  var hue = void 0;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      hue = (blue - red) / delta + 2;
      break;
    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;
  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }
  return { hue: hue, saturation: saturation, lightness: lightness };
}

//      

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

//      

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};

//      
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue('#' + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue('#' + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return 'rgba(' + rgbValue.red + ',' + rgbValue.green + ',' + rgbValue.blue + ',' + secondValue + ')';
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : 'rgba(' + firstValue + ',' + secondValue + ',' + thirdValue + ',' + fourthValue + ')';
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : 'rgba(' + firstValue.red + ',' + firstValue.green + ',' + firstValue.blue + ',' + firstValue.alpha + ')';
  }

  throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}

//      
function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue('#' + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : 'rgba(' + hslToRgb(value, saturation, lightness) + ',' + alpha + ')';
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : 'rgba(' + hslToRgb(value.hue, value.saturation, value.lightness) + ',' + value.alpha + ')';
  }

  throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}

//      
var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};

var errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';

/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */

function toColorString(color) {
  if (typeof color !== 'object') throw new Error(errMsg);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);

  throw new Error(errMsg);
}

//      

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js


// eslint-disable-next-line no-unused-vars


// eslint-disable-next-line no-unused-vars

// eslint-disable-next-line no-redeclare


function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
}

// eslint-disable-next-line no-redeclare
function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

//      

/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue(180, 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue(180, 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */
function adjustHue(degree, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: (hslColor.hue + degree) % 360
  }));
}

var curriedAdjustHue = /*#__PURE__*/curry(adjustHue);

//      

/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */
function complement(color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: (hslColor.hue + 180) % 360
  }));
}

//      

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

//      

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken(0.2, 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken(0.2, 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */
function darken(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - amount)
  }));
}

var curriedDarken = /*#__PURE__*/curry(darken);

//      

/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */
function desaturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - amount)
  }));
}

var curriedDesaturate = /*#__PURE__*/curry(desaturate);

//      
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */
function getLuminance(color) {
  var rgbColor = parseToRgb(color);

  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
    var channel = rgbColor[key] / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }),
      r = _Object$keys$map[0],
      g = _Object$keys$map[1],
      b = _Object$keys$map[2];

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

//      

/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */
function grayscale(color) {
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: 0
  }));
}

//      

/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */
function invert(color) {
  // parse color string to rgb
  var value = parseToRgb(color);
  return toColorString(_extends({}, value, {
    red: 255 - value.red,
    green: 255 - value.green,
    blue: 255 - value.blue
  }));
}

//      

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */
function lighten(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + amount)
  }));
}

var curriedLighten = /*#__PURE__*/curry(lighten);

//      

/**
 * Mixes two colors together by calculating the average of each of the RGB components.
 *
 * By default the weight is 0.5 meaning that half of the first color and half the second
 * color should be used. Optionally the weight can be modified by providing a number
 * as the first argument. 0.25 means that a quarter of the first color and three quarters
 * of the second color should be used.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */
function mix() {
  var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
  var color = arguments[1];
  var otherColor = arguments[2];

  var parsedColor1 = parseToRgb(color);
  var color1 = _extends({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });

  var parsedColor2 = parseToRgb(otherColor);
  var color2 = _extends({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1

    // The formular is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
  });var alphaDelta = color1.alpha - color2.alpha;
  var x = weight * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;

  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha + (color2.alpha - color1.alpha) * (weight / 1.0)
  };

  return rgba(mixedColor);
}

var curriedMix = /*#__PURE__*/curry(mix);

//      
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify(0.5, 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify(0.5, 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */
function opacify(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + amount * 100) / 100)
  });
  return rgba(colorWithAlpha);
}

var curriedOpacify = /*#__PURE__*/curry(opacify);

//      
/**
 * Selects black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */

function readableColor(color) {
  return getLuminance(color) > 0.179 ? '#000' : '#fff';
}

var curriedReadableColor = /*#__PURE__*/curry(readableColor);

//      

/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */
function saturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + amount)
  }));
}

var curriedSaturate = /*#__PURE__*/curry(saturate);

//      

/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue(244, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue(244, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */
function setHue(hue, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    hue: hue
  }));
}

var curriedSetHue = /*#__PURE__*/curry(setHue);

//      

/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */
function setLightness(lightness, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    lightness: lightness
  }));
}

var curriedSetLightness = /*#__PURE__*/curry(setLightness);

//      

/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */
function setSaturation(saturation, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: saturation
  }));
}

var curriedSetSaturation = /*#__PURE__*/curry(setSaturation);

//      

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */

function shade(percentage, color) {
  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
    throw new Error('Passed an incorrect argument to shade, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
  }
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  return curriedMix(percentage, color, 'rgb(0, 0, 0)');
}

var curriedShade = /*#__PURE__*/curry(shade);

//      

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
    throw new Error('Passed an incorrect argument to tint, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
  }
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  return curriedMix(percentage, color, 'rgb(255, 255, 255)');
}

var curriedTint = /*#__PURE__*/curry(tint);

//      
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize(0.5, 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize(0.5, 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */
function transparentize(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 - amount * 100) / 100)
  });
  return rgba(colorWithAlpha);
}

var curriedTransparentize = /*#__PURE__*/curry(transparentize);

//      

/** */

/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */
function animation() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  // Allow single or multiple animations passed
  var multiMode = Array.isArray(args[0]);
  if (!multiMode && args.length > 8) {
    throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
  }
  var code = args.map(function (arg) {
    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
      throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
    }
    if (Array.isArray(arg) && arg.length > 8) {
      throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
    }

    return Array.isArray(arg) ? arg.join(' ') : arg;
  }).join(', ');

  return {
    animation: code
  };
}

//      

/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */

function backgroundImages() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    backgroundImage: properties.join(', ')
  };
}

//      

/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */
function backgrounds() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    background: properties.join(', ')
  };
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */

function borderColor() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderColor'].concat(values));
}

//      
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */

function borderRadius(side, radius) {
  var uppercaseSide = capitalizeString(side);
  if (!radius && radius !== 0) {
    throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
  }
  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
    var _ref;

    return _ref = {}, _ref['border' + uppercaseSide + 'RightRadius'] = radius, _ref['border' + uppercaseSide + 'LeftRadius'] = radius, _ref;
  }

  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
    var _ref2;

    return _ref2 = {}, _ref2['borderTop' + uppercaseSide + 'Radius'] = radius, _ref2['borderBottom' + uppercaseSide + 'Radius'] = radius, _ref2;
  }

  throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */

function borderStyle() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderStyle'].concat(values));
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */
function borderWidth() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderWidth'].concat(values));
}

//      


function generateSelectors(template, state) {
  var stateSuffix = state ? ':' + state : '';
  return template(stateSuffix);
}

/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */
function statefulSelectors(states, template, stateMap) {
  if (!template) throw new Error('You must provide a template to this method.');
  if (states.length === 0) return generateSelectors(template, null);
  var selectors = [];
  for (var i = 0; i < states.length; i += 1) {
    if (stateMap && stateMap.indexOf(states[i]) < 0) {
      throw new Error('You passed an unsupported selector state to this method.');
    }
    selectors.push(generateSelectors(template, states[i]));
  }
  selectors = selectors.join(',');
  return selectors;
}

//      
var stateMap = [undefined, null, 'active', 'focus', 'hover'];

function template(state) {
  return 'button' + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
}

/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */

function buttons() {
  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template, stateMap);
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */

function margin() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['margin'].concat(values));
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */

function padding() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['padding'].concat(values));
}

//      
var positionMap$1 = ['absolute', 'fixed', 'relative', 'static', 'sticky'];

/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */

function position(positionKeyword) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (positionMap$1.indexOf(positionKeyword) >= 0) {
    return _extends({
      position: positionKeyword
    }, directionalProperty.apply(undefined, [''].concat(values)));
  } else {
    var firstValue = positionKeyword; // in this case position is actually the first value
    return directionalProperty.apply(undefined, ['', firstValue].concat(values));
  }
}

//      

/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */

function size(height) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;

  return {
    height: height,
    width: width
  };
}

//      
var stateMap$1 = [undefined, null, 'active', 'focus', 'hover'];

function template$1(state) {
  return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ',\n    input:not([type])' + state + ',\n    textarea' + state;
}

/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */

function textInputs() {
  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template$1, stateMap$1);
}

//      

/**
 * Shorthand that accepts any number of transition values as parameters for creating a single transition statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 * }
 */

function transitions() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    transition: properties.join(', ')
  };
}

//      
// Helpers
// Mixins
// Color
// Shorthands




/***/ }),

/***/ "./node_modules/rc-calendar/lib/locale/en_US.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  today: 'Today',
  now: 'Now',
  backToToday: 'Back to today',
  ok: 'Ok',
  clear: 'Clear',
  month: 'Month',
  year: 'Year',
  timeSelect: 'Select time',
  dateSelect: 'Select date',
  monthSelect: 'Choose a month',
  yearSelect: 'Choose a year',
  decadeSelect: 'Choose a decade',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Previous month (PageUp)',
  nextMonth: 'Next month (PageDown)',
  previousYear: 'Last year (Control + left)',
  nextYear: 'Next year (Control + right)',
  previousDecade: 'Last decade',
  nextDecade: 'Next decade',
  previousCentury: 'Last century',
  nextCentury: 'Next century'
};
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/rc-pagination/lib/locale/en_US.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Goto',
  jump_to_confirm: 'confirm',
  page: '',

  // Pagination.jsx
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Previous 5 Pages',
  next_5: 'Next 5 Pages',
  prev_3: 'Previous 3 Pages',
  next_3: 'Next 3 Pages'
};
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/redux-define/lib/defineAction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NAMESPACE_SEPARATOR = '/';

var defineAction = function defineAction(type) {
  var subactions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var namespace = arguments[2];

  if (subactions && subactions.ACTION || typeof subactions === 'string') {
    namespace = subactions;
  }

  if (!Array.isArray(subactions)) {
    subactions = [];
  }

  var name = namespace ? [namespace, type].join(NAMESPACE_SEPARATOR) : type;

  var action = subactions.reduce(function (r, i) {
    return _extends({}, r, _defineProperty({}, i, name + '_' + i));
  }, {});

  action.ACTION = name;
  action.defineAction = function (type, subactions) {
    return defineAction(type, subactions, name);
  };

  action.toString = function () {
    return name.toString();
  };
  return action;
};

exports.default = defineAction;

/***/ }),

/***/ "./node_modules/redux-define/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineAction = __webpack_require__("./node_modules/redux-define/lib/defineAction.js");

Object.defineProperty(exports, 'defineAction', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_defineAction).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/redux-thunk/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),

/***/ "./node_modules/regenerator-runtime/runtime-module.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("./node_modules/regenerator-runtime/runtime.js");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ "./node_modules/regenerator-runtime/runtime.js":
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ "./node_modules/styled-components/dist/styled-components.browser.esm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return keyframes; });
/* unused harmony export injectGlobal */
/* unused harmony export isStyledComponent */
/* unused harmony export consolidateStreamedStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThemeProvider; });
/* unused harmony export withTheme */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__("./node_modules/fbjs/lib/hyphenateStyleName.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis__ = __webpack_require__("./node_modules/stylis/stylis.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__ = __webpack_require__("./node_modules/stylis-rule-sheet/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__("./node_modules/styled-components/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__("./node_modules/react-is/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        var nextChunk = chunk(executionContext);
        /* Throw if a React Element was given styles */
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(nextChunk)) {
          var elementName = chunk.displayName || chunk.name;
          throw new StyledComponentsError(11, elementName);
        }
        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ENV":"staging"}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

var warnExtendDeprecated = function warnExtendDeprecated() {};
if (false) {
  warnExtendDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
  });
}

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          warnExtendDeprecated();

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["c"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/process/browser.js"), __webpack_require__("./node_modules/webpack/buildin/harmony-module.js")(module)))

/***/ }),

/***/ "./node_modules/styled-components/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ "./node_modules/stylis-rule-sheet/index.js":
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),

/***/ "./node_modules/stylis/stylis.js":
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),

/***/ "./node_modules/whatwg-fetch/fetch.js":
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ "./src/App.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_layout_style_css__ = __webpack_require__("./node_modules/antd/es/layout/style/css.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_layout__ = __webpack_require__("./node_modules/antd/es/layout/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Routes__ = __webpack_require__("./src/Routes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ducks_auth__ = __webpack_require__("./src/ducks/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Nav_HeaderNav__ = __webpack_require__("./src/components/Nav/HeaderNav/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Nav_SiderNav__ = __webpack_require__("./src/components/Nav/SiderNav/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_es__ = __webpack_require__("./node_modules/lodash-es/lodash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment_timezone__ = __webpack_require__("./node_modules/moment-timezone/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment_timezone__);
var _templateObject=_taggedTemplateLiteral(['\n  min-height: 100vh;\n  @media (min-width: 769px) {\n    padding-left: ',';\n  }\n'],['\n  min-height: 100vh;\n  @media (min-width: 769px) {\n    padding-left: ',';\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  padding: 24px 16px;\n  @media (max-width: 768px) {\n    padding: 48px 10px;\n  }\n'],['\n  padding: 24px 16px;\n  @media (max-width: 768px) {\n    padding: 48px 10px;\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}__WEBPACK_IMPORTED_MODULE_13_moment_timezone___default.a.tz.setDefault('Asia/Bangkok');var Content=__WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */].Content,Footer=__WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */].Footer;var enhance=Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["compose"])(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["withRouter"],Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(function(state){return{isShowMenu:state.router.location.pathname!=='/login'};},Object.assign({},__WEBPACK_IMPORTED_MODULE_8_ducks_auth__["a" /* actions */])),Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["lifecycle"])({componentDidMount:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.getMe();case 2:data=_context.sent;if(data&&data.user&&!data.user.is_admin){this.props.logout();}case 4:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()}));var omitProps=function omitProps(keys){return Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["mapProps"])(function(props){return Object(__WEBPACK_IMPORTED_MODULE_12_lodash_es__["omit"])(props,keys);});};var ContentLayout=Object(__WEBPACK_IMPORTED_MODULE_11_styled_components__["c" /* default */])(omitProps(['hasSider'])(__WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */]))(_templateObject,function(props){return props.hasSider?'200px':'0';});var ContentMain=Object(__WEBPACK_IMPORTED_MODULE_11_styled_components__["c" /* default */])(Content)(_templateObject2);var App=function App(props){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('main',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_es_layout__["a" /* default */],null,props.isShowMenu&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Nav_SiderNav__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ContentLayout,{hasSider:props.isShowMenu},props.isShowMenu&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Nav_HeaderNav__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ContentMain,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Routes__["a" /* default */],null)),props.isShowMenu&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Footer,{style:{textAlign:'center'}},'TakeMeTour Admin powered by Ant Design \xA92017 - ',__WEBPACK_IMPORTED_MODULE_13_moment_timezone___default()().format('YYYY')))));};/* harmony default export */ __webpack_exports__["a"] = (enhance(App));

/***/ }),

/***/ "./src/Routes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_loadable__ = __webpack_require__("./src/utils/loadable.js");
var paths=[{path:'/booking/dashboard',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("booking-dashboard.page").then(__webpack_require__.bind(null, "./src/pages/Booking/BookingDashboard.js"));}})},{path:'/booking/promo-code',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("booking-promo-code.page").then(__webpack_require__.bind(null, "./src/pages/Booking/BookingPromo.js"));}})},{path:'/booking/manual-booking',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("booking-manual-booking.page").then(__webpack_require__.bind(null, "./src/pages/Booking/ManualBookingDashboard.js"));}})},{path:'/booking/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("booking.page").then(__webpack_require__.bind(null, "./src/pages/Booking/index.js"));}})},{path:'/trip/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("trip.page").then(__webpack_require__.bind(null, "./src/pages/Trip/index.js"));}})},{path:'/user/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("user.page").then(__webpack_require__.bind(null, "./src/pages/User/index.js"));}})},{path:'/dashboard',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("dashboard.page").then(__webpack_require__.bind(null, "./src/pages/Dashboard/index.js"));}})},{path:'/login',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("login.page").then(__webpack_require__.bind(null, "./src/pages/Auth/Login.js"));}})},{path:'/logout',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("logout.page").then(__webpack_require__.bind(null, "./src/pages/Auth/Logout.js"));}})},{path:'/search',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("search.page").then(__webpack_require__.bind(null, "./src/pages/Search/index.js"));}})},{path:'/customize',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("customize.page").then(__webpack_require__.bind(null, "./src/pages/Customize/index.js"));}})},{path:'/topic',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("topics.page").then(__webpack_require__.bind(null, "./src/pages/Section/Section/Sections.js"));}})},{path:'/topic/dashboard',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("topic-dashboard.page").then(__webpack_require__.bind(null, "./src/pages/Section/Analytic/TopicDashboard.js"));}})},{path:'/topic/dashboard/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("topic-dashboard-analytic.page").then(__webpack_require__.bind(null, "./src/pages/Section/Analytic/TopicAnalytic.js"));}})},{path:'/topic/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("topic.page").then(__webpack_require__.bind(null, "./src/pages/Section/Section/Section.js"));}})},{path:'/article',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("articles.page").then(__webpack_require__.bind(null, "./src/pages/Section/Article/Articles.js"));}})},{path:'/article/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("article.page").then(__webpack_require__.bind(null, "./src/pages/Section/Article/Article.js"));}})},{path:'/city',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("cities.page").then(__webpack_require__.bind(null, "./src/pages/Section/City/Cities.js"));}})},{path:'/city/:city',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("city.page").then(__webpack_require__.bind(null, "./src/pages/Section/City/City.js"));}})},{path:'/log/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("logs.page").then(__webpack_require__.bind(null, "./src/pages/Log/Lists/index.js"));}})},{path:'/log/detail/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("log.page").then(__webpack_require__.bind(null, "./src/pages/Log/Detail/index.js"));}})},{path:'/redeem',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("redeem.page").then(__webpack_require__.bind(null, "./src/pages/Promo/index.js"));}})},{path:'/calendar',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("calendar.page").then(__webpack_require__.bind(null, "./src/pages/Calendar/index.js"));}})},{path:'/lx-availability',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("lx-availability.page").then(__webpack_require__.bind(null, "./src/pages/LxAvailability/index.js"));}})},{path:'/payment/manual',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("payment-manual.page").then(__webpack_require__.bind(null, "./src/pages/Payment/PaymentManual.js"));}})},{path:'/payment/export',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("payment-payout.page").then(__webpack_require__.bind(null, "./src/pages/Payment/PaymentPayout.js"));}})},{path:'/payment/statement',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("payment-statement.page").then(__webpack_require__.bind(null, "./src/pages/Payment/PaymentStatement.js"));}})},{path:'/payment/history',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("payment-history.page").then(__webpack_require__.bind(null, "./src/pages/Payment/PaymentHistory.js"));}})},{path:'/refund/pending',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("payment-refund.page").then(__webpack_require__.bind(null, "./src/pages/Payment/PaymentRefund.js"));}})},{path:'/trip-group',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("trip-group.page").then(__webpack_require__.bind(null, "./src/pages/TripGroup/TripGroups.js"));}})},{path:'/trip-group/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("trip-group-detail.page").then(__webpack_require__.bind(null, "./src/pages/TripGroup/TripGroup.js"));}})},{path:'/redirect',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("redirect.page").then(__webpack_require__.bind(null, "./src/pages/Redirect/index.js"));}})},{path:'/swap-request',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("swap-request.page").then(__webpack_require__.bind(null, "./src/pages/SwapRequest/index.js"));}})},{path:'/swap-request/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("swap-request-detail.page").then(__webpack_require__.bind(null, "./src/pages/SwapRequest/SwapRequestDetail.js"));}})},{path:'/config',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("config.page").then(__webpack_require__.bind(null, "./src/pages/SiteConfig/Config.js"));}})},{path:'/config-key',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("config-keys.page").then(__webpack_require__.bind(null, "./src/pages/SiteConfig/ConfigKeys.js"));}})},{path:'/translation',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("translation.page").then(__webpack_require__.bind(null, "./src/pages/SiteConfig/Translation.js"));}})},{path:'/testing',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("testings.page").then(__webpack_require__.bind(null, "./src/pages/SiteConfig/ABTesting/index.js"));}})},{path:'/testing/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("testing.page").then(__webpack_require__.bind(null, "./src/pages/SiteConfig/ABTesting/Testing.js"));}})},{path:'/assignee',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("assignee.page").then(__webpack_require__.bind(null, "./src/pages/SiteConfig/Assignee.js"));}})},{path:'/meeting-point',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("meeting-point.page").then(__webpack_require__.bind(null, "./src/pages/SiteConfig/MeetingPoint.js"));}})},{path:'/affiliate/report',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("affiliate-report.page").then(__webpack_require__.bind(null, "./src/pages/Affiliate/Report.js"));}})},{path:'/affiliate/payment',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("affiliate-payment.page").then(__webpack_require__.bind(null, "./src/pages/Affiliate/Payment.js"));}})},{path:'/affiliate/users',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("affiliate-payment.page").then(__webpack_require__.bind(null, "./src/pages/Affiliate/Users.js"));}})},{path:'/affiliate/detail/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("affiliate-payment.page").then(__webpack_require__.bind(null, "./src/pages/Affiliate/UserAffiliateDetail.js"));}})},{path:'/affiliate/transaction-detail/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("affiliate-payment.page").then(__webpack_require__.bind(null, "./src/pages/Affiliate/TransactionDetail.js"));}})},{path:'/influencer/users',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("influencer.page").then(__webpack_require__.bind(null, "./src/pages/Influencer/Users.js"));}})},{path:'/influencer/users/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("influencer.page").then(__webpack_require__.bind(null, "./src/pages/Influencer/InfluencerDetail.js"));}})},{path:'/review',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("review.page").then(__webpack_require__.bind(null, "./src/pages/Review/index.js"));}})},{path:'/review/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("review-detail.page").then(__webpack_require__.bind(null, "./src/pages/Review/ReviewDetail.js"));}})},{path:'/search-n-replace',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("search-n-replace.page").then(__webpack_require__.bind(null, "./src/pages/SearchReplace/index.js"));}})},{path:'/highlight',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("highlight.page").then(__webpack_require__.bind(null, "./src/pages/Highlight/index.js"));}})},{path:'/restaurant',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("restaurants.page").then(__webpack_require__.bind(null, "./src/pages/Restaurant/index.js"));}})},{path:'/restaurant/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("restaurant.page").then(__webpack_require__.bind(null, "./src/pages/Restaurant/Restaurant.js"));}})},{path:'/souvenir',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("souvenirs.page").then(__webpack_require__.bind(null, "./src/pages/Souvenir/index.js"));}})},{path:'/souvenir/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("souvenir.page").then(__webpack_require__.bind(null, "./src/pages/Souvenir/Souvenir.js"));}})},{path:'/biennale/artist',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("biennale-artists.page").then(__webpack_require__.bind(null, "./src/pages/Biennale/Artist/index.js"));}})},{path:'/biennale/artist/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("biennale-artist.page").then(__webpack_require__.bind(null, "./src/pages/Biennale/Artist/Artist.js"));}})},{path:'/biennale/art',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("biennale-arts.page").then(__webpack_require__.bind(null, "./src/pages/Biennale/Art/index.js"));}})},{path:'/biennale/art/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("biennale-art.page").then(__webpack_require__.bind(null, "./src/pages/Biennale/Art/Art.js"));}})},{path:'/biennale/art-plan',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("biennale-art-plans.page").then(__webpack_require__.bind(null, "./src/pages/Biennale/ArtPlan/index.js"));}})},{path:'/biennale/art-plan/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("biennale-art-plan.page").then(__webpack_require__.bind(null, "./src/pages/Biennale/ArtPlan/ArtPlan.js"));}})},{path:'/biennale/art-community',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("biennale-art-communities.page").then(__webpack_require__.bind(null, "./src/pages/Biennale/ArtCommunity/index.js"));}})},{path:'/biennale/art-community/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("biennale-art-community.page").then(__webpack_require__.bind(null, "./src/pages/Biennale/ArtCommunity/ArtCommunity.js"));}})},{path:'/approved-trips',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("approved-trips.page").then(__webpack_require__.bind(null, "./src/pages/ApprovedTrips/index.js"));}})},{path:'/pricing',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("pricing.page").then(__webpack_require__.bind(null, "./src/pages/Pricing/index.js"));}})},{path:'/send-sms',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("approved-trips.page").then(__webpack_require__.bind(null, "./src/pages/SMS/SendSMS.js"));}})},{path:'/partner/availability',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("partner-availability.page").then(__webpack_require__.bind(null, "./src/pages/Partner/Availability.js"));}})},{path:'/fruit-market/recommandation',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("recommandation.page").then(__webpack_require__.bind(null, "./src/pages/FruitMarket/Recommandation/index.js"));}})},{path:'/fruit-market/seller',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("fruit-market.sellers.page").then(__webpack_require__.bind(null, "./src/pages/FruitMarket/Seller/index.js"));}})},{path:'/fruit-market/order',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("fruit-market.orders.page").then(__webpack_require__.bind(null, "./src/pages/FruitMarket/Order/index.js"));}})},{path:'/fruit-market/order/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("fruit-market.order.page").then(__webpack_require__.bind(null, "./src/pages/FruitMarket/Order/Order.js"));}})},{path:'/local-community',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("local-communities.page").then(__webpack_require__.bind(null, "./src/pages/LocalCommunity/index.js"));}})},{path:'/local-community/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("local-community.page").then(__webpack_require__.bind(null, "./src/pages/LocalCommunity/LocalCommunity.js"));}})},{path:'/walking-tour/products/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("walking-tour-product-detail.page").then(__webpack_require__.bind(null, "./src/pages/WalkingTour/ProductDetail.js"));}})},{path:'/walking-tour/products',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("walking-tour-products.page").then(__webpack_require__.bind(null, "./src/pages/WalkingTour/Products.js"));}})},{path:'/walking-tour/bookings/:id',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("walking-tour-booking-detail.page").then(__webpack_require__.bind(null, "./src/pages/WalkingTour/BookingDetail.js"));}})},{path:'/walking-tour/bookings',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("walking-tour-bookings.page").then(__webpack_require__.bind(null, "./src/pages/WalkingTour/Bookings.js"));}})},{path:'/walking-tour/manage-availability',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("ManageAvailability").then(__webpack_require__.bind(null, "./src/pages/WalkingTour/ManageAvailability.js"));}})},{path:'/cx-handoff',component:Object(__WEBPACK_IMPORTED_MODULE_2_utils_loadable__["a" /* loadSingle */])({loader:function loader(){return __webpack_require__.e/* import() */("cx-handoff.page").then(__webpack_require__.bind(null, "./src/pages/CxHandoff/Handoffs.js"));}})}];var Routes=function Routes(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Switch"],null,paths.map(function(path){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Route"],{key:path.path,path:path.path,exact:true,component:path.component});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["Redirect"],{to:'/dashboard'}));};/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),

/***/ "./src/components/Nav/HeaderNav/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_es_layout_style_css__ = __webpack_require__("./node_modules/antd/es/layout/style/css.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_layout__ = __webpack_require__("./node_modules/antd/es/layout/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logo_white_png__ = __webpack_require__("./src/components/Nav/HeaderNav/logo-white.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logo_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__logo_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_theme_colors__ = __webpack_require__("./src/theme/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Nav_Search__ = __webpack_require__("./src/components/Nav/Search/index.js");
var _templateObject=_taggedTemplateLiteral(['\n  background-color: ',' !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 16px !important;\n  @media (max-width: 786px) {\n    padding: 0 10px !important;  \n  }\n'],['\n  background-color: ',' !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 16px !important;\n  @media (max-width: 786px) {\n    padding: 0 10px !important;  \n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 72px;\n  @media (max-width: 786px) {\n    width: 58px;\n  }\n'],['\n  width: 72px;\n  @media (max-width: 786px) {\n    width: 58px;\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  display: inherit;\n'],['\n  display: inherit;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TMTHeader=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1_antd_es_layout__["a" /* default */].Header)(_templateObject,__WEBPACK_IMPORTED_MODULE_6_theme_colors__["a" /* default */].gray2);var Logo=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].img.attrs({src:__WEBPACK_IMPORTED_MODULE_5__logo_white_png___default.a})(_templateObject2);var Link=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["Link"])(_templateObject3);var HeaderNav=function HeaderNav(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TMTHeader,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link,{to:'/dashboard'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Logo,null)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Nav_Search__["a" /* default */],null));};/* harmony default export */ __webpack_exports__["a"] = (HeaderNav);

/***/ }),

/***/ "./src/components/Nav/HeaderNav/logo-white.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAvCAMAAACc9ceUAAAAnFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+TINBkAAAAM3RSTlMA+9z0Fu/4iy/pDcO/gmHgdjfX08i0meSlJq5xTCLsVObNvKpnKhyekIVcuJRFP2x+QlkWJnnHAAAC1ElEQVRIx+2V2XabMBCGZyQkjDFgNoMB4wXiPV7yv/+7Fbl2Gte9qJO7Nt85gDSa8zFCOoK++W+YNslMysDNq6+ayrkGuK4Z0In/FZOVamRpWx3O1XHnQDf9T6vGMdQovPUOueTE+mxVMYLpx4A/Q9L/5AQRHO5D1Qz5k1ObenkzEIr1w9L5Uk+fMC0jJTUAdiTvH0ZzuE+4DkAUF3bZVkOpNw811xz+vasvsL429/pRlmJFf8+Q1W1TrrTOf1s4Hwk9QQGnvDbXkpPqfnU5eGoz7Fim28t8wzXD2S8/jipJT8lWCipYpEnmSAAs7DG9M2N6jm0RGIvKhDuyI+YsLyfXIanoWXrHzcZrw77ZB5tYQmbuaD1s/RIRfQmrbAIFQCslkdJXsbb2ahEFQbA40Df/Mi89w8t7d3x3+vTGPx+9+/Txn13iJ+/d5O7wEVFoTjEhrLv0+M+uWkloVXfvDs1hAIfIsi6l9IlsoOj6GTDpQqZ6dUnPugLDF1OxdbkME4us5Rru0qrmQkTri8uPE6pcIdyzccmQNjCuaSLErmctVyZ9XIhANEtKY6JV/EaLdBTNybzcJfLrwULzuHMdZnpDEQ9cDLqhGYq+UDNMrJnezU2Voy5OObJdjT0JEA0wJIdVHd9cFG79GK8ENecRhYh8v5bd0MBRJzQCky3mvs/i6oqxJQ/uLxeONL65WiElGxc4sKgCuKNvYzGClL3OdbpEnKsrMJPG/IOrE91cc+zP80tdCXJ6hbBt26POZTlIqXOViLvQ8OoS6NEWSffsP7oitFtlXM5Lxp6lVTkdroyLTmnPuEJ22qk3uroS5NMdUoow9IMPrg2bj8msHT4TZ9TK+rDSQNe0eUeGiCeUmlBMtOcFUSkZ7LxSw9AZl++/gJ731t1PRVl5Fg2PRL73Sm954S0p9KZkOJ66W9s0wz5ReEk/j4q12WBecQy9MXlr+uZf4QcmVUmEY0QkRwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "./src/components/Nav/Search/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_es_input_style_css__ = __webpack_require__("./node_modules/antd/es/input/style/css.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_input__ = __webpack_require__("./node_modules/antd/es/input/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ducks_search__ = __webpack_require__("./src/ducks/search.js");
var enhance=Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(null,{push:__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["push"],search:__WEBPACK_IMPORTED_MODULE_6_ducks_search__["a" /* actions */].search}));var Search=function Search(props){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_input__["a" /* default */].Search,{placeholder:'Search...',style:{width:200},onSearch:function onSearch(value){props.search(value);props.push('/search?q='+value);}});};/* harmony default export */ __webpack_exports__["a"] = (enhance(Search));

/***/ }),

/***/ "./src/components/Nav/SiderNav/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_es_icon_style_css__ = __webpack_require__("./node_modules/antd/es/icon/style/css.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_icon__ = __webpack_require__("./node_modules/antd/es/icon/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_layout_style_css__ = __webpack_require__("./node_modules/antd/es/layout/style/css.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_es_layout__ = __webpack_require__("./node_modules/antd/es/layout/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_es_menu_style_css__ = __webpack_require__("./node_modules/antd/es/menu/style/css.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_es_menu__ = __webpack_require__("./node_modules/antd/es/menu/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_helpers__ = __webpack_require__("./src/utils/helpers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose__ = __webpack_require__("./node_modules/recompose/es/Recompose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_theme_images_default_img_png__ = __webpack_require__("./src/theme/images/default-img.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_theme_images_default_img_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_theme_images_default_img_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_media__ = __webpack_require__("./src/utils/media.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_theme_colors__ = __webpack_require__("./src/theme/colors.js");
var _templateObject=_taggedTemplateLiteral(['\n  position: fixed !important;\n  height: 100%;\n  left: 0;\n  z-index: 2;\n  > div {\n    height: 100%;\n    max-height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n'],['\n  position: fixed !important;\n  height: 100%;\n  left: 0;\n  z-index: 2;\n  > div {\n    height: 100%;\n    max-height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 120px;\n  min-height: 120px;\n  width: 100%;\n  > h3 {\n    color: ',';\n  }\n'],['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 120px;\n  min-height: 120px;\n  width: 100%;\n  > h3 {\n    color: ',';\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  width: 80px;\n  height: 80px;\n  min-height: 80px;\n  min-width: 80px;\n  background-image: ',';\n  background-size: cover;\n  background-position: 50%;\n  border-radius: 50%;\n'],['\n  width: 80px;\n  height: 80px;\n  min-height: 80px;\n  min-width: 80px;\n  background-image: ',';\n  background-size: cover;\n  background-position: 50%;\n  border-radius: 50%;\n']),_templateObject4=_taggedTemplateLiteral(['\n  max-height: 100%;\n  overflow-y: auto;\n  flex: 1;\n'],['\n  max-height: 100%;\n  overflow-y: auto;\n  flex: 1;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SubMenu=__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].SubMenu;var enhance=Object(__WEBPACK_IMPORTED_MODULE_11_recompose__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(function(state){return{permissions:state.auth.permissions,user:state.auth.user,isLoggedIn:state.auth.loggedIn};},{}),Object(__WEBPACK_IMPORTED_MODULE_11_recompose__["withProps"])(function(ownProps){return{perm:{topic:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['topic.article.view','topic.city.view','topic.topic.view','topic.highlight.view','topic.search.view'],ownProps.permissions),config:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])('config.view',ownProps.permissions),customize:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])('customize.view',ownProps.permissions),calendar:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['calendar.booking.view','calendar.lxAvailability.view'],ownProps.permissions),payment:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['payment.view'],ownProps.permissions),trip:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['trip.tripGroup.view','trip.approvedTrips.view'],ownProps.permissions),booking:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['booking.view'],ownProps.permissions),partner:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['partner.view'],ownProps.permissions),redeem:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['redeem.view','redeem.edit'],ownProps.permissions),redirect:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['redirect.view','redirect.edit'],ownProps.permissions),affiliate:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['affiliate.view','affiliate.edit'],ownProps.permissions),influencer:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['influencer.vaiew','influencer.edit'],ownProps.permissions),review:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['review.view','review.edit'],ownProps.permissions),localtable:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['localtable.restaurant.view','localtable.restaurant.edit','localtable.souvenir.view','localtable.souvenir.edit'],ownProps.permissions),biennale:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['biennale.view','biennale.edit'],ownProps.permissions),pricing:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['pricing.view','pricing.edit'],ownProps.permissions),sms:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['sms.send'],ownProps.permissions),fruitMarket:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['fruitMarket.recommandation.edit','fruitMarket.sellers.view','fruitMarket.sellers.edit','fruitMarket.orders.view','fruitMarket.orders.edit'],ownProps.permissions),localCommunities:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['localCommunities.view','localCommunities.edit'],ownProps.permissions),walkingTour:Object(__WEBPACK_IMPORTED_MODULE_10_utils_helpers__["h" /* getPerm */])(['walkingTour.view','walkingTour.bookings.view','walkingTour.refunds.approve','walkingTour.refunds.reject'],ownProps.permissions)}};}));var FixedSider=Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_antd_es_layout__["a" /* default */].Sider)(_templateObject);var ProfileContainer=__WEBPACK_IMPORTED_MODULE_8_styled_components__["c" /* default */].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_14_theme_colors__["a" /* default */].white);var ProfilePic=__WEBPACK_IMPORTED_MODULE_8_styled_components__["c" /* default */].div(_templateObject3,function(props){return props.src?'url(\''+Object(__WEBPACK_IMPORTED_MODULE_13_utils_media__["b" /* path */])(props.src,'avatarTripCard')+'\')':'url(\''+__WEBPACK_IMPORTED_MODULE_12_theme_images_default_img_png___default.a+'\')';});var NavScroll=__WEBPACK_IMPORTED_MODULE_8_styled_components__["c" /* default */].div(_templateObject4);var SiderNav=function SiderNav(props){var perm=props.perm,user=props.user,isLoggedIn=props.isLoggedIn;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(FixedSider,{breakpoint:'sm',collapsedWidth:'0'},isLoggedIn&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ProfileContainer,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ProfilePic,{src:user.avatar_image}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h3',null,user.name&&user.name.first)),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(NavScroll,null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */],{theme:'dark',mode:'inline'},perm.topic.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SubMenu,{key:'topic',title:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'switcher'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'Sections & Topics'))},perm.topic.indexOf('topic.topic.view')>=0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'topic.dashboard'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/topic/dashboard'},'Dashboard')),perm.topic.indexOf('topic.topic.view')>=0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'topic.topic'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/topic'},'Topics')),perm.topic.indexOf('topic.article.view')>=0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'topic.article'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/article'},'Articles')),perm.topic.indexOf('topic.city.view')>=0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'topic.city'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/city'},'Cities')),perm.topic.indexOf('topic.highlight.view')>=0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'topic.highlight'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/highlight'},'Highlights')),perm.topic.indexOf('topic.search.view')>=0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'topic.search'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/search-n-replace'},'Search & Replace'))),perm.trip.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SubMenu,{key:'trip',title:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'picture'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'Trip'))},perm.trip.indexOf('trip.tripGroup.view')>=0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'tripGroups'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/trip-group'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'appstore'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Trip Group'))),perm.trip.indexOf('trip.approvedTrips.view')>=0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'approvedTrips'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/approved-trips'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'check-circle-o'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Approved Trips')))),perm.booking.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SubMenu,{key:'bookingDashboard',title:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'inbox'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Booking Dashboard'))},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'booking.dashboard'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/booking/dashboard'},'Booking Dashboard')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'booking.dashboard.promo.code'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/booking/promo-code'},'Booking Promo code')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'booking.dashboard.manual.booking'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/booking/manual-booking'},'Manual Booking'))),perm.partner.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SubMenu,{key:'partner',title:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'fork'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Partner'))},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'partner.availability'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/partner/availability'},'Availability'))),perm.booking.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'swapRequest'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/swap-request'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'retweet'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Swap Request'))),perm.config.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SubMenu,{key:'config',title:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'setting'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'Site Config'))},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'config.redirect'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/redirect'},'Redirect')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'config.config'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/config'},'Configs')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'config.configKey'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/config-key'},'Config Keys')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'config.testing'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/testing'},'A/B Testing')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'config.translation'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/translation'},'Translation')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'config.assignee'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/assignee'},'Assignee')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'config.meetingPoint'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/meeting-point'},'Meeting Points'))),perm.payment.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SubMenu,{key:'payment',title:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'credit-card'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'Payment'))},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'payment.payout'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/payment/export'},'Export Payout')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'payment.statement'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/payment/statement'},'Statement')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'payment.refund'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/refund/pending'},'Pending Refund')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'payment.history'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/payment/history'},'Payment History')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'payment.manual'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/payment/manual'},'Manual Payment'))),perm.calendar.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SubMenu,{key:'calendar',title:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'calendar'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'Calendar'))},perm.calendar.indexOf('calendar.booking.view')>=0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'calendar.booking'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/calendar'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Booking Calendar'))),perm.calendar.indexOf('calendar.lxAvailability.view')>=0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'calendar.lxAvailability'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/lx-availability'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'LX Availability Calendar')))),perm.walkingTour.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SubMenu,{key:'walkingTour',title:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'environment-o'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'Walking Tour'))},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'walkingTour.product'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/walking-tour/products'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Products'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'walkingTour.booking'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/walking-tour/bookings'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Booking'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'walkingTour.manageAvailability'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/walking-tour/manage-availability'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Manage Availability')))),perm.fruitMarket.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SubMenu,{key:'fruitMarket',title:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'shopping-cart'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'Fruit Market'))},perm.fruitMarket.indexOf('fruitMarket.recommandation.edit')>=0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'fruitMarket.recommandation'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/fruit-market/recommandation'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Recommandation'))),perm.fruitMarket.indexOf('fruitMarket.sellers.view')>=0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'fruitMarket.seller'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/fruit-market/seller'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Sellers'))),perm.fruitMarket.indexOf('fruitMarket.orders.view')>=0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'fruitMarket.order'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/fruit-market/order'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Orders')))),perm.localCommunities.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'local-community'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/local-community'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'home'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Local Community'))),perm.redeem.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'redeem'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/redeem'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'gift'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Redeem'))),perm.customize.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'customize'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/customize'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'customer-service'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Customize'))),perm.review.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'review'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/review'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'star'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Review'))),perm.affiliate.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SubMenu,{key:'affiliate',title:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'user'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'Affiliate'))},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'affiliate.report'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/affiliate/report'},'Report')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'affiliate.payment'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/affiliate/payment'},'Payment')),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'affiliate.users'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/affiliate/users'},'Users'))),perm.influencer.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SubMenu,{key:'influencer',title:__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'user'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',null,'Influencer'))},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'influencer.users'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/influencer/users'},'Users'))),perm.pricing.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'pricing'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/pricing'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'pay-circle-o'}),'Pricing')),perm.sms.length>0&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'sms'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/send-sms'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'message'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Send SMS'))),user&&user.is_admin&&__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'cx-handoff'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/cx-handoff'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'customer-service'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'CX Handoff'))),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_es_menu__["a" /* default */].Item,{key:'logout'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["Link"],{to:'/logout'},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'logout'}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span',{className:'nav-text'},'Logout'))))));};SiderNav.__ANT_LAYOUT_SIDER=true;/* harmony default export */ __webpack_exports__["a"] = (enhance(SiderNav));

/***/ }),

/***/ "./src/config.js":
/***/ (function(module, exports, __webpack_require__) {

var environment={production:{apiPath:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ENV":"staging"}).APIPATH||'https://www.takemetour.com/api',mediaPath:'https://d1j7gws94ta18j.cloudfront.net',nonWebPMediaPath:'https://d1j7gws94ta18j.cloudfront.net',webPath:{en:'https://www.takemetour.com',th:'https://pachantiew.takemetour.com',zh:'https://zh.takemetour.com'},// assetPath: 'https://s3-ap-southeast-1.amazonaws.com/takemetour-3-0',
assetPath:'https://d2d3n9ufwugv3m.cloudfront.net',pdfPath:'https://s3-ap-southeast-1.amazonaws.com/takemetour-3-0',uiKitAssetPath:'https://ddhiorx9qbcay.cloudfront.net',s3Bucket:'takemetour-3-0'},staging:{apiPath:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ENV":"staging"}).APIPATH||'https://staging.takemetour.com/api',uiKitAssetPath:'https://takemetour-uikit-asset-dev.storage.googleapis.com'}}["staging"||'development'];// Use relative path in development to leverage proxy, full URL in staging/production
var isDevelopment=!"staging"||"staging"==='development';module.exports=Object.assign({apiPath:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ENV":"staging"}).APIPATH||(isDevelopment?'/api':'https://staging.takemetour.com/api'),pdfPath:'https://s3-ap-southeast-1.amazonaws.com/takemetour-3-0-dev',mediaPath:'https://d3uplctqj7yzf0.cloudfront.net',uiKitAssetPath:'https://takemetour-uikit-asset-dev.storage.googleapis.com',// nonWebPMediaPath: 'https://d17572qoeejomw.cloudfront.net',
nonWebPMediaPath:'https://d3uplctqj7yzf0.cloudfront.net',webPath:{en:'https://staging.takemetour.com',th:'https://pachantiew.staging.takemetour.com',zh:'https://zh.staging.takemetour.com'},assetPath:'https://dja3e86j343dh.cloudfront.net',s3Bucket:'takemetour-3-0-dev'},environment);

/***/ }),

/***/ "./src/ducks/affiliate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('affiliate');var GET_AFFILIATE_REPORT=define('GET_AFFILIATE_REPORT',true);var GET_AFFILIATE_PAYMENT=define('GET_AFFILIATE_PAYMENT',true);var MANAGE_HOLD=define('MANAGE_HOLD',true);var PAID_TRANSACTIONS=define('PAID_TRANSACTIONS',true);var UNAPPROVE_TRANSACTION=define('UNAPPROVE_TRANSACTION',true);var GET_AFFILIATE_USERS=define('GET_AFFILIATE_USERS',true);var SET_AFFILIATE_USERS=define('SET_AFFILIATE_USERS',true);var GET_PAYMENT_ACCOUNT=define('GET_PAYMENT_ACCOUNT',true);var SET_PAYMENT_ACCOUNT=define('SET_PAYMENT_ACCOUNT',true);var GET_TRANSACTION_DETAIL=define('GET_TRANSACTION_DETAIL',true);var SET_ADJUSTMENT=define('SET_ADJUSTMENT',true);var GET_AFFILIATE_DETAIL=define('GET_AFFILIATE_DETAIL',true);var SET_INTERNAL_NOTE=define('SET_INTERNAL_NOTE',true);var SET_WHITE_LABEL=define('SET_WHITE_LABEL',true);var initialState={isLoading:true,reports:[],payments:[],newUsers:[],users:[],affiliateDetail:{},paymentAccount:{},transactionDetail:{}};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_AFFILIATE_REPORT.PENDING:return Object.assign({},state,{isLoading:true});case GET_AFFILIATE_REPORT.RESOLVED:return Object.assign({},state,{isLoading:false,reports:action.data});case GET_AFFILIATE_REPORT.REJECTED:return Object.assign({},state,{isLoading:true});case GET_AFFILIATE_PAYMENT.PENDING:return Object.assign({},state,action.noLoad?{}:{isLoading:true});case GET_AFFILIATE_PAYMENT.RESOLVED:return Object.assign({},state,{isLoading:false,payments:action.data});case GET_AFFILIATE_PAYMENT.REJECTED:return Object.assign({},state,{isLoading:true},action.noLoad?{}:{isLoading:true});case MANAGE_HOLD.PENDING:return Object.assign({},state,{isLoading:true});case MANAGE_HOLD.RESOLVED:return Object.assign({},state,{isLoading:false});case MANAGE_HOLD.REJECTED:return Object.assign({},state,{isLoading:true});case PAID_TRANSACTIONS.PENDING:return Object.assign({},state,{isLoading:true});case PAID_TRANSACTIONS.RESOLVED:return Object.assign({},state,{isLoading:false});case PAID_TRANSACTIONS.REJECTED:return Object.assign({},state,{isLoading:true});case GET_AFFILIATE_USERS.PENDING:return Object.assign({},state,{isLoading:true});case GET_AFFILIATE_USERS.RESOLVED:return Object.assign({},state,{isLoading:false,users:action.data.users,newUsers:action.data.new_users});case GET_AFFILIATE_USERS.REJECTED:return Object.assign({},state,{isLoading:true});case GET_AFFILIATE_DETAIL.PENDING:return Object.assign({},state,{isLoading:true});case GET_AFFILIATE_DETAIL.RESOLVED:return Object.assign({},state,{isLoading:false,affiliateDetail:action.data});case GET_AFFILIATE_DETAIL.REJECTED:return Object.assign({},state,{isLoading:true});case SET_AFFILIATE_USERS.PENDING:return Object.assign({},state,{isLoading:true});case SET_AFFILIATE_USERS.RESOLVED:return Object.assign({},state,{isLoading:false});case SET_AFFILIATE_USERS.REJECTED:return Object.assign({},state,{isLoading:true});case GET_PAYMENT_ACCOUNT.PENDING:return Object.assign({},state,{loading:true,paymentAccount:{}});case GET_PAYMENT_ACCOUNT.RESOLVED:return Object.assign({},state,{paymentAccount:action.data,loading:false});case GET_PAYMENT_ACCOUNT.REJECTED:return Object.assign({},state,{loading:false});case GET_TRANSACTION_DETAIL.PENDING:return Object.assign({},state,{loading:true,transactionDetail:{}});case GET_TRANSACTION_DETAIL.RESOLVED:return Object.assign({},state,{transactionDetail:action.data,loading:false});case GET_TRANSACTION_DETAIL.REJECTED:return Object.assign({},state,{loading:false});case SET_ADJUSTMENT.PENDING:return Object.assign({},state,{loading:true});case SET_ADJUSTMENT.RESOLVED:return Object.assign({},state,{loading:false});case SET_ADJUSTMENT.REJECTED:return Object.assign({},state,{loading:false});case SET_INTERNAL_NOTE.PENDING:return Object.assign({},state,{loading:true});case SET_INTERNAL_NOTE.RESOLVED:return Object.assign({},state,{loading:false});case SET_INTERNAL_NOTE.REJECTED:return Object.assign({},state,{loading:false});case SET_WHITE_LABEL.PENDING:return Object.assign({},state,{loading:true});case SET_WHITE_LABEL.RESOLVED:case SET_WHITE_LABEL.REJECTED:return Object.assign({},state,{loading:false});case SET_PAYMENT_ACCOUNT.PENDING:return Object.assign({},state,{loading:true,paymentAccount:{}});case SET_PAYMENT_ACCOUNT.RESOLVED:return Object.assign({},state,{paymentAccount:action.data,loading:false});case SET_PAYMENT_ACCOUNT.REJECTED:return Object.assign({},state,{loading:false});default:return state;}});var actions={getAffiliateReport:function getAffiliateReport(){var from=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var to=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';return{type:GET_AFFILIATE_REPORT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/affiliate/user?from='+from+'&to='+to)};},// since api does not process req.query.year but it use moment format with year so this is a workaround
getAffiliatePayment:function getAffiliatePayment(){var month=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var year=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var noLoad=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return{type:GET_AFFILIATE_PAYMENT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/affiliate/paid?month='+month+' '+year),noLoad:noLoad};},paidAffiliateTransaction:function paidAffiliateTransaction(){var transactions=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return{type:PAID_TRANSACTIONS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/affiliate/paid',{paid_transactions:transactions}),success:'Paid Transactions',error:'Error Paid Transaction'};},unapproveAffiliateTransaction:function unapproveAffiliateTransaction(id){return{type:UNAPPROVE_TRANSACTION,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/affiliate/unapprove',{transaction_id:id}),success:'Unapprove Transaction Successful',error:'Fail to unapprove transaction'};},manageHold:function manageHold(status,id){return{type:MANAGE_HOLD,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/affiliate/process-hold',{status:status,transaction_id:id}),success:'You '+status+' Transaction ID '+id,error:'Error '+status+' transaction ID '+id};},getAffiliateUsers:function getAffiliateUsers(){return{type:GET_AFFILIATE_USERS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/affiliate/users')};},setAffiliateUsers:function setAffiliateUsers(email,affiliateId){return{type:SET_AFFILIATE_USERS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/affiliate/users',{user_email:email,affiliate_id:affiliateId}),error:'Error set affiliate ID'};},getAffiliateDetail:function getAffiliateDetail(id){return{type:GET_AFFILIATE_DETAIL,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/affiliate/detail/'+id)};},getPaymentAccount:function getPaymentAccount(id){return{type:GET_PAYMENT_ACCOUNT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/affiliate/payment-account/'+id)};},setPaymentAccount:function setPaymentAccount(id,data){return{type:SET_PAYMENT_ACCOUNT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/affiliate/payment-account/'+id,Object.assign({},data))};},getTransactionDetail:function getTransactionDetail(id){return{type:GET_TRANSACTION_DETAIL,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/affiliate/transactions/'+id)};},setAdjustment:function setAdjustment(id,adjustValue){return{type:SET_ADJUSTMENT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/affiliate/transactions/'+id,{data:adjustValue})};},setInternalNote:function setInternalNote(id,internalNote){return{type:SET_INTERNAL_NOTE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/affiliate/internal-note/'+id,{internal_note:internalNote})};},updateWhiteLabel:function updateWhiteLabel(userId,logo){return{// logo --> { logoDesktop: String, logoDesktop2x: String, logoMobile: String, logoMobile2x: String, logoAlt: String }
type:SET_WHITE_LABEL,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/affiliate/white-label/'+userId,logo),success:'White label has been updated',error:'Fail to update white label'};}};

/***/ }),

/***/ "./src/ducks/article.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('article');var GET_ARTICLES=define('GET_ARTICLES',true);var GET_ARTICLE=define('GET_ARTICLE',true);var CREATE_ARTICLE=define('CREATE_ARTICLE',true);var UPDATE_ARTICLE=define('UPDATE_ARTICLE',true);var PUBLISHED_ARTICLE=define('PUBLISHED_ARTICLE',true);var DELETE_ARTICLE=define('DELETE_ARTICLE',true);var initialState={loadingArticles:true,articles:[],loadingArticle:true,article:{}};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_ARTICLES.PENDING:return Object.assign({},state,{loadingArticles:true,articles:[]});case GET_ARTICLES.RESOLVED:return Object.assign({},state,{loadingArticles:false,articles:action.data});case GET_ARTICLES.REJECTED:return Object.assign({},state,{loadingArticles:true});case GET_ARTICLE.PENDING:return Object.assign({},state,{loadingArticle:true,article:{}});case GET_ARTICLE.RESOLVED:return Object.assign({},state,{loadingArticle:false,article:action.data});case GET_ARTICLE.REJECTED:return Object.assign({},state,{loadingArticle:true});default:return state;}});var actions={loadArticles:function loadArticles(){return{type:GET_ARTICLES,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/articles')};},loadArticle:function loadArticle(id){return{type:GET_ARTICLE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/articles/'+id)};},createArticle:function createArticle(data){return{type:CREATE_ARTICLE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/articles',data),success:'Article has been created',error:'Unable to create an article'};},updateArticle:function updateArticle(id,data){return{type:UPDATE_ARTICLE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/articles/'+id,data),success:'Article has been updated',error:'Unable to update an article'};},publishedArticle:function publishedArticle(id,publish){return{type:PUBLISHED_ARTICLE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/articles/'+id+'/publish',{publish:publish}),success:'Article has been published',error:'Unable to publish an article'};},deleteArticle:function deleteArticle(id){return{type:DELETE_ARTICLE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].delete('/articles/'+id),success:'Article has been deleted',error:'Unable to delete the article'};}};

/***/ }),

/***/ "./src/ducks/auth.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_api__ = __webpack_require__("./src/utils/api.js");
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var define=Object(__WEBPACK_IMPORTED_MODULE_1_utils_constantCreator__["a" /* default */])('auth');var LOGIN=define('LOGIN',true);var LOGOUT=define('LOGOUT',true);var GET_ME=define('GET_ME',true);var initialState={loggedIn:false,isCheckedLogin:false,user:{},permissions:[]};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case LOGIN.REJECTED:return Object.assign({},state,{loggedIn:false});case LOGIN.RESOLVED:return Object.assign({},state,{loggedIn:true,user:action.data.user,permissions:action.data.user&&action.data.user.permissions||[]});case LOGOUT.RESOLVED:return Object.assign({},state,{loggedIn:false,user:{}});case GET_ME.RESOLVED:return Object.assign({},state,{loggedIn:action.data.isLoggedIn,user:action.data.user,isCheckedLogin:true,permissions:action.data.user&&action.data.user.permissions||[]});case GET_ME.REJECTED:return Object.assign({},state,{loggedIn:false,user:{},isCheckedLogin:true});default:return state;}});var actions={login:function login(_ref){var email=_ref.email,password=_ref.password;return{type:LOGIN,promise:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var resp;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/session/login',{email:email,password:password});case 2:resp=_context.sent;if(!(resp.data.user&&!resp.data.user.is_admin)){_context.next=5;break;}throw new Error('Not a admin account');case 5:return _context.abrupt('return',resp);case 6:case'end':return _context.stop();}}},_callee,_this);}))(),success:'Logged in successfully',error:'Unable to authenticate'};},logout:function logout(){return{type:LOGOUT,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].delete('/session/logout'),success:'Logged out successfully',error:'Unable to logout'};},getMe:function getMe(){return{type:GET_ME,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/users/me')};}};

/***/ }),

/***/ "./src/ducks/biennale.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('biennale');var GET_ARTS=define('GET_ARTS',true);var GET_ART=define('GET_ART',true);var CREATE_ART=define('CREATE_ART',true);var UPDATE_ART=define('UPDATE_ART',true);var GET_ART_PLANS=define('GET_ART_PLANS',true);var GET_ART_PLAN=define('GET_ART_PLAN',true);var CREATE_ART_PLAN=define('CREATE_ART_PLAN',true);var UPDATE_ART_PLAN=define('UPDATE_ART_PLAN',true);var GET_ARTISTS=define('GET_ARTISTS',true);var GET_ARTIST=define('GET_ARTIST',true);var CREATE_ARTIST=define('CREATE_ARTIST',true);var UPDATE_ARTIST=define('UPDATE_ARTIST',true);var GET_ART_COMMUNITIES=define('GET_ART_COMMUNITIES',true);var GET_ART_COMMUNITY=define('GET_ART_COMMUNITY',true);var CREATE_ART_COMMUNITY=define('CREATE_ART_COMMUNITY',true);var UPDATE_ART_COMMUNITY=define('UPDATE_ART_COMMUNITY',true);var initialState={art:{loadingArts:true,arts:[],loadingArt:true,art:{}},artPlan:{loadingArtPlans:true,artPlans:[],loadingArtPlan:true,artPlan:{}},artist:{loadingArtists:true,artists:[],loadingArtist:true,artist:{}},artCommunity:{loadingArtCommunities:true,artCommunities:[],loadingArtCommunity:true,artCommunity:{}}};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_ARTS.PENDING:return Object.assign({},state,{art:Object.assign({},state.art,{loadingArts:true,arts:[]})});case GET_ARTS.RESOLVED:return Object.assign({},state,{art:Object.assign({},state.art,{loadingArts:false,arts:action.data})});case GET_ART.PENDING:return Object.assign({},state,{art:Object.assign({},state.art,{loadingArt:true,art:{}})});case GET_ART.RESOLVED:return Object.assign({},state,{art:Object.assign({},state.art,{loadingArt:false,art:action.data})});case GET_ART_PLANS.PENDING:return Object.assign({},state,{artPlan:Object.assign({},state.art,{loadingArtPlans:true,artPlans:[]})});case GET_ART_PLANS.RESOLVED:return Object.assign({},state,{artPlan:Object.assign({},state.artPlan,{loadingArtPlans:false,artPlans:action.data})});case GET_ART_PLAN.PENDING:return Object.assign({},state,{artPlan:Object.assign({},state.artPlan,{loadingArtPlan:true,artPlan:{}})});case GET_ART_PLAN.RESOLVED:return Object.assign({},state,{artPlan:Object.assign({},state.artPlan,{loadingArtPlan:false,artPlan:action.data})});case GET_ARTISTS.PENDING:return Object.assign({},state,{artist:Object.assign({},state.artist,{loadingArtists:true,artists:[]})});case GET_ARTISTS.RESOLVED:return Object.assign({},state,{artist:Object.assign({},state.artist,{loadingArtists:false,artists:action.data})});case GET_ARTIST.PENDING:return Object.assign({},state,{artist:Object.assign({},state.artist,{loadingArtist:true,artist:{}})});case GET_ARTIST.RESOLVED:return Object.assign({},state,{artist:Object.assign({},state.artist,{loadingArtist:false,artist:action.data})});case GET_ART_COMMUNITIES.PENDING:return Object.assign({},state,{artC:Object.assign({},state.artCommunity,{loadingArtCommunities:true,artCommunities:[]})});case GET_ART_COMMUNITIES.RESOLVED:return Object.assign({},state,{artCommunity:Object.assign({},state.artCommunity,{loadingArtCommunities:false,artCommunities:action.data})});case GET_ART_COMMUNITY.PENDING:return Object.assign({},state,{artCommunity:Object.assign({},state.artCommunity,{loadingArtCommunity:true,artCommunity:{}})});case GET_ART_COMMUNITY.RESOLVED:return Object.assign({},state,{artCommunity:Object.assign({},state.artCommunity,{loadingArtCommunity:false,artCommunity:action.data})});default:return state;}});var actions={getArts:function getArts(){return{type:GET_ARTS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/biennale/arts'),error:'Unable to get arts'};},getArt:function getArt(id){return{type:GET_ART,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/biennale/arts/'+id),error:'Unable to get art'};},createArt:function createArt(data){return{type:CREATE_ART,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/biennale/arts',data),success:'Art has been created',error:'Unable to create art'};},updateArt:function updateArt(id,data){return{type:UPDATE_ART,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/biennale/arts/'+id,data),success:'Art has been updated',error:'Unable to update art'};},getArtPlans:function getArtPlans(){return{type:GET_ART_PLANS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/biennale/art-plans'),error:'Unable to get art plans'};},getArtPlan:function getArtPlan(id){return{type:GET_ART_PLAN,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/biennale/art-plans/'+id),error:'Unable to get art plan'};},createArtPlan:function createArtPlan(data){return{type:CREATE_ART_PLAN,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/biennale/art-plans',data),success:'Art plan has been created',error:'Unable to create art plan'};},updateArtPlan:function updateArtPlan(id,data){return{type:UPDATE_ART_PLAN,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/biennale/art-plans/'+id,data),success:'Art plan has been updated',error:'Unable to update art plan'};},getArtists:function getArtists(){return{type:GET_ARTISTS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/biennale/artists'),error:'Unable to get artists'};},getArtist:function getArtist(id){return{type:GET_ARTIST,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/biennale/artists/'+id),error:'Unable to get artist'};},createArtist:function createArtist(data){return{type:CREATE_ARTIST,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/biennale/artists',data),success:'Artist has been created',error:'Unable to create artist'};},updateArtist:function updateArtist(id,data){return{type:UPDATE_ARTIST,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/biennale/artists/'+id,data),success:'Artist has been updated',error:'Unable to update artist'};},getArtCommunities:function getArtCommunities(){return{type:GET_ART_COMMUNITIES,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/biennale/art-communities'),error:'Unable to get art communities'};},getArtCommunity:function getArtCommunity(id){return{type:GET_ART_COMMUNITY,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/biennale/art-communities/'+id),error:'Unable to get art community'};},createArtCommunity:function createArtCommunity(data){return{type:CREATE_ART_COMMUNITY,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/biennale/art-communities',data),success:'Artist has been created',error:'Unable to create art community'};},updateArtCommunity:function updateArtCommunity(id,data){return{type:UPDATE_ART_COMMUNITY,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/biennale/art-communities/'+id,data),success:'Artist has been updated',error:'Unable to update art community'};}};

/***/ }),

/***/ "./src/ducks/booking.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__("./node_modules/moment-timezone/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_1_utils_constantCreator__["a" /* default */])('booking');var GET_BOOKING=define('GET_BOOKING',true);var CONFIRM_TRIP=define('CONFIRM_TRIP',true);var UNDO_CONFIRM_TRIP=define('UNDO_CONFIRM_TRIP',true);var CANCEL_TRIP=define('CANCEL_TRIP',true);var UNDO_RESCHEDULING=define('UNDO_RESCHEDULING',true);var SEND_EMAIL=define('SEND_EMAIL',true);var SWAP_LX=define('SWAP_LX',true);var CREATE_SWAP_REQUEST=define('CREATE_SWAP_REQUEST',true);var CHANGE_TRIP_DATE=define('CHANGE_TRIP_DATE',true);var CHANGE_QUANTITY=define('CHANGE_QUANTITY',true);var CHANGE_LISTED_PRICE=define('CHANGE_LISTED_PRICE',true);var UPDATE_BOOKING=define('UPDATE_BOOKING',true);var SAVE_NOTE=define('SAVE_NOTE',true);var CONFIRM_PAYMENT=define('CONFIRM_PAYMENT',true);var REFUND_BOOKING=define('REFUND_BOOKING',true);var ADD_ADDITIONAL_PAYMENT=define('ADD_ADDITIONAL_PAYMENT',true);var MANAGE_ADDITIONAL_PAYMENT=define('MANAGE_ADDITIONAL_PAYMENT',true);var UPDATE_ADDTIONAL_OPTIONS=define('UPDATE_ADDTIONAL_OPTIONS',true);var ACCEPT_HOTEL_PICKUP=define('ACCEPT_HOTEL_PICKUP',true);var REGENERATE_RECEIPT=define('REGENERATE_RECEIPT',true);var RECALCULATE_PRICE=define('RECALCULATE_PRICE',true);var CHARGE_OMISE=define('CHARGE_OMISE',true);var BOOK_GLOBALTIX=define('BOOK_GLOBALTIX',true);var UPDATE_PRICE_CONSTANT=define('UPDATE_PRICE_CONSTANT',true);var REMOVE_LX_IMAGE=define('REMOVE_LX_IMAGE',true);var GET_BOOKING_DASHBOARD=define('GET_BOOKING_DASHBOARD',true);var GET_BOOKING_PROMO=define('GET_BOOKING_PROMO',true);var SAVE_INSURANCE=define('SAVE_INSURANCE',true);var APPEND_SWAP_REQUEST_BY_TIER=define('APPEND_SWAP_REQUEST_BY_TIER',true);var APPEND_SWAP_REQUEST_MANUAL=define('APPEND_SWAP_REQUEST_MANUAL',true);var GET_BOOKING_MANUAL_BOOKING=define('GET_BOOKING_MANUAL_BOOKING',true);var CLEAR_MANUAL_BOOKING=define('CLEAR_MANUAL_BOOKING');var initialState={isLoading:true,booking:{},processing:false,isLoadingDashboard:true,isLoadingBookingPromo:true,isLoadingManualBooking:true,dashboard:[],bookingPromo:[],manualBooking:[]};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_BOOKING.PENDING:return Object.assign({},state,{booking:{},isLoading:true});case GET_BOOKING.RESOLVED:return Object.assign({},state,{isLoading:false,booking:action.data});case GET_BOOKING_DASHBOARD.PENDING:return Object.assign({},state,{isLoadingDashboard:true});case GET_BOOKING_DASHBOARD.RESOLVED:return Object.assign({},state,{isLoadingDashboard:false,dashboard:action.data});case GET_BOOKING_PROMO.PENDING:return Object.assign({},state,{isLoadingBookingPromo:true});case GET_BOOKING_PROMO.RESOLVED:return Object.assign({},state,{isLoadingBookingPromo:false,bookingPromo:action.data});case GET_BOOKING_MANUAL_BOOKING.PENDING:return Object.assign({},state,{isLoadingManualBooking:true});case GET_BOOKING_MANUAL_BOOKING.RESOLVED:return Object.assign({},state,{isLoadingManualBooking:false,manualBooking:action.data});case CLEAR_MANUAL_BOOKING:return Object.assign({},state,{isLoadingManualBooking:false,manualBooking:[]});case CONFIRM_TRIP.PENDING:case UNDO_CONFIRM_TRIP.PENDING:case CANCEL_TRIP.PENDING:case UNDO_RESCHEDULING.PENDING:case SEND_EMAIL.PENDING:case SWAP_LX.PENDING:case CHANGE_TRIP_DATE.PENDING:case CHANGE_QUANTITY.PENDING:case CHANGE_LISTED_PRICE.PENDING:case UPDATE_BOOKING.PENDING:case SAVE_NOTE.PENDING:case CONFIRM_PAYMENT.PENDING:case REFUND_BOOKING.PENDING:case ADD_ADDITIONAL_PAYMENT.PENDING:case MANAGE_ADDITIONAL_PAYMENT.PENDING:case UPDATE_ADDTIONAL_OPTIONS.PENDING:case ACCEPT_HOTEL_PICKUP.PENDING:case REGENERATE_RECEIPT.PENDING:case RECALCULATE_PRICE.PENDING:case CHARGE_OMISE.PENDING:case UPDATE_PRICE_CONSTANT.PENDING:case REMOVE_LX_IMAGE.PENDING:case BOOK_GLOBALTIX.PENDING:case CREATE_SWAP_REQUEST.PENDING:case SAVE_INSURANCE.PENDING:case APPEND_SWAP_REQUEST_BY_TIER.PENDING:case APPEND_SWAP_REQUEST_MANUAL.PENDING:return Object.assign({},state,{processing:true});case CONFIRM_TRIP.RESOLVED:case UNDO_CONFIRM_TRIP.RESOLVED:case CANCEL_TRIP.RESOLVED:case UNDO_RESCHEDULING.RESOLVED:case SEND_EMAIL.RESOLVED:case SWAP_LX.RESOLVED:case CHANGE_TRIP_DATE.RESOLVED:case CHANGE_QUANTITY.RESOLVED:case CHANGE_LISTED_PRICE.RESOLVED:case UPDATE_BOOKING.RESOLVED:case SAVE_NOTE.RESOLVED:case CONFIRM_PAYMENT.RESOLVED:case REFUND_BOOKING.RESOLVED:case ADD_ADDITIONAL_PAYMENT.RESOLVED:case MANAGE_ADDITIONAL_PAYMENT.RESOLVED:case UPDATE_ADDTIONAL_OPTIONS.RESOLVED:case ACCEPT_HOTEL_PICKUP.RESOLVED:case REGENERATE_RECEIPT.RESOLVED:case RECALCULATE_PRICE.RESOLVED:case CHARGE_OMISE.RESOLVED:case UPDATE_PRICE_CONSTANT.RESOLVED:case REMOVE_LX_IMAGE.RESOLVED:case BOOK_GLOBALTIX.RESOLVED:case CREATE_SWAP_REQUEST.RESOLVED:case SAVE_INSURANCE.RESOLVED:case APPEND_SWAP_REQUEST_BY_TIER.RESOLVED:case APPEND_SWAP_REQUEST_MANUAL.RESOLVED:return Object.assign({},state,{processing:false});case CONFIRM_TRIP.REJECTED:case UNDO_CONFIRM_TRIP.REJECTED:case CANCEL_TRIP.REJECTED:case UNDO_RESCHEDULING.REJECTED:case SEND_EMAIL.REJECTED:case SWAP_LX.REJECTED:case CHANGE_TRIP_DATE.REJECTED:case CHANGE_QUANTITY.REJECTED:case CHANGE_LISTED_PRICE.REJECTED:case UPDATE_BOOKING.REJECTED:case SAVE_NOTE.REJECTED:case CONFIRM_PAYMENT.REJECTED:case REFUND_BOOKING.REJECTED:case ADD_ADDITIONAL_PAYMENT.REJECTED:case MANAGE_ADDITIONAL_PAYMENT.REJECTED:case UPDATE_ADDTIONAL_OPTIONS.REJECTED:case ACCEPT_HOTEL_PICKUP.REJECTED:case REGENERATE_RECEIPT.REJECTED:case RECALCULATE_PRICE.REJECTED:case CHARGE_OMISE.REJECTED:case UPDATE_PRICE_CONSTANT.REJECTED:case REMOVE_LX_IMAGE.REJECTED:case BOOK_GLOBALTIX.REJECTED:case CREATE_SWAP_REQUEST.REJECTED:case SAVE_INSURANCE.REJECTED:case APPEND_SWAP_REQUEST_BY_TIER.REJECTED:case APPEND_SWAP_REQUEST_MANUAL.REJECTED:return Object.assign({},state,{processing:false});default:return state;}});var actions={loadBooking:function loadBooking(id){return{type:GET_BOOKING,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/bookings/'+id),error:'Unable to load booking data'};},confirmTrip:function confirmTrip(id){return{type:CONFIRM_TRIP,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/confirm'),success:'Trip has been confirmed',error:'Unable to confirm trip'};},chargeOmise:function chargeOmise(id){return{type:CHARGE_OMISE,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/charge-omise'),success:'Charged by omise',error:'Unable to charge the booking'};},bookGlobaltix:function bookGlobaltix(id){return{type:BOOK_GLOBALTIX,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/book-globaltix'),success:'Booked to GlobalTix success',error:'Unable to book to globaltix'};},undoConfirmTrip:function undoConfirmTrip(id){return{type:UNDO_CONFIRM_TRIP,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/undo-confirm'),success:'Confirmation has been undone.',error:'Unable to undo confirm'};},cancelTrip:function cancelTrip(id){return{type:CANCEL_TRIP,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/cancel'),success:'Trip has been canceled',error:'Unable to cancel trip'};},undoRescheduling:function undoRescheduling(id){return{type:UNDO_RESCHEDULING,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/undo-send7'),success:'Rescheduling has been undone.',error:'Unable to undo rescheduling'};},sendEmail:function sendEmail(id,type){return{type:SEND_EMAIL,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/mail/booking/'+id+'/'+type),success:'Email has been sent',error:'Unable to send email'};},swapLx:function swapLx(id,lxId,isSkipConfirm){return{type:SWAP_LX,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/swap',{lx_id:lxId,is_skip_confirm:isSkipConfirm}),success:'Local Expert has been swapped to new one',error:'Unable to swap to new Local Expert'};},changeTripDate:function changeTripDate(id,newDate){return{type:CHANGE_TRIP_DATE,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/change-date',{trip_date:newDate}),success:'Trip date has been changed',error:'Unable to change trip date'};},changeQuantity:function changeQuantity(id,quantity){return{type:CHANGE_QUANTITY,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/change-quantity',{quantity:quantity}),success:'Trip number of guest(s) has been changed',error:'Unable to change number of guest(s)'};},changeListedPrice:function changeListedPrice(id,price){return{type:CHANGE_LISTED_PRICE,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/change-price',{price:price}),success:'Trip listed price has been changed',error:'Unable to change listed price'};},saveNote:function saveNote(id,note){return{type:SAVE_NOTE,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].put('/bookings/'+id+'/note',{note:note}),success:'Note has been saved',error:'Unable to save note'};},confirmPayment:function confirmPayment(id,type,date){return{type:CONFIRM_PAYMENT,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/confirm-payment',{charged_type:type,charged_date:date}),success:'Payment for this booking has been confirmed',error:'Unable to confirmed payment'};},refund:function refund(id,amount,isDeductFromLx,note){return{type:REFUND_BOOKING,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/refund',{amount:amount,is_deduct_from_lx:isDeductFromLx,note:note}),success:'Booking has been refunded',error:'Unable to refund booking'};},addAdditionalPayment:function addAdditionalPayment(id,text,amount){return{type:ADD_ADDITIONAL_PAYMENT,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/additional-payment',{text:text,amount:amount}),success:'Additional Payment has been added',error:'Unable to add new additional payment'};},manageAdditionalPayment:function manageAdditionalPayment(id,toBeStatus,paymentId,approvalNote){return{type:MANAGE_ADDITIONAL_PAYMENT,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/manage-additional-payment',{toBeStatus:toBeStatus,paymentId:paymentId,approvalNote:approvalNote}),success:'Additional Payment updated',error:'Unable to update additional payment'};},addAdditionalOption:function addAdditionalOption(id,data){return{type:UPDATE_ADDTIONAL_OPTIONS,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/change-additional-options',{selected_options:data}),success:'Addtional Option has been updated',error:'Unable to update new additional option'};},acceptHotelPickup:function acceptHotelPickup(id,isAccept){return{type:ACCEPT_HOTEL_PICKUP,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/lx-accept-hotel',{isAccept:isAccept}),success:'Accept hotel pickup',error:'Unable to accept hotel pickup'};},regenerateReceipt:function regenerateReceipt(id){return{type:REGENERATE_RECEIPT,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/generate-receipt'),success:'Booking receipt has been regenerated',error:'Unable to regenerate receipt'};},regeneratePrice:function regeneratePrice(id){return{type:RECALCULATE_PRICE,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/generate-price'),success:'Price has been recalculated',error:'Unable to recalculate price'};},updatePriceConstant:function updatePriceConstant(id,data){return{type:UPDATE_PRICE_CONSTANT,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/change-price-const',{price_const:data}),success:'Price constant has been updated',error:'Unable to update price constant'};},removeLxImage:function removeLxImage(id){return{type:REMOVE_LX_IMAGE,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/remove-lx-image'),success:'LX Image has been removed',error:'Unable to remove LX Image'};},getBookingDashboard:function getBookingDashboard(){var from=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().subtract(2,'days').startOf('days').format('YYYY-MM-DD');var to=arguments.length>1&&arguments[1]!==undefined?arguments[1]:__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().endOf('days').format('YYYY-MM-DD');return{type:GET_BOOKING_DASHBOARD,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/bookings/dashboard?from='+from+'&to='+to),error:'Fail to load booking dashboard'};},getBookingPromo:function getBookingPromo(){var month=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().format('YYYY-MM');return{type:GET_BOOKING_PROMO,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/bookings/redeem?month='+month),error:'Fail to load booking promo'};},getBookingManualBook:function getBookingManualBook(type){var monthYear=arguments.length>1&&arguments[1]!==undefined?arguments[1]:__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().format('YYYY-MM');var dateType=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'tripDate';return{type:GET_BOOKING_MANUAL_BOOKING,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/bookings/admin/booking-manual-book-type?type='+type+'&monthYear='+monthYear+'&dateType='+dateType),error:'Fail to load bookings'};},clearManualBooking:function clearManualBooking(){return{type:CLEAR_MANUAL_BOOKING};},saveInsuranceData:function saveInsuranceData(id,data){return{type:SAVE_INSURANCE,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/insurance',data),success:'Insurance info submitted!',error:'Fail to submit insurance'};},// swap actions
createSwapRequest:function createSwapRequest(id,lxIds){return{type:CREATE_SWAP_REQUEST,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/swap-request',{local_experts:lxIds}),success:'Swap request has been created and sent',error:'Unable to create swap request'};},createSwapRequestByTier:function createSwapRequestByTier(id,tier){var isPartner=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return{type:CREATE_SWAP_REQUEST,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/swap-request-tier',{tier:tier,isPartner:isPartner}),success:'Tier swap request has been created and sent',error:'Unable to create tier swap request'};},appendLxByTier:function appendLxByTier(id,tier){return{type:APPEND_SWAP_REQUEST_BY_TIER,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/swap-request/'+id+'/append-swap-request',{tier:tier}),success:'Swap Request list sent by tier '+tier,error:'Fail to append swap request'};},manualAppend:function manualAppend(id,lxs){return{type:APPEND_SWAP_REQUEST_MANUAL,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/swap-request/'+id+'/append-swap-request',{tier:0,local_expert_ids:lxs}),success:'Swap Request list sent manually',error:'Fail to append swap request'};},updateBooking:function updateBooking(id,data){return{type:UPDATE_BOOKING,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/update',data),success:'Booking has been updated',error:'Fail to update booking'};}};

/***/ }),

/***/ "./src/ducks/calendar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__("./node_modules/moment-timezone/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_1_utils_constantCreator__["a" /* default */])('calendar');var GET_CALENDAR=define('GET_CALENDAR',true);var GET_LX_AVAILABILITY=define('GET_LX_AVAILABILITY',true);var initialState={isLoading:true,isLoadingLxAvailability:true,bookings:[],lxAvailability:[]};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_CALENDAR.PENDING:return Object.assign({},state,{isLoading:true,bookings:[]});case GET_CALENDAR.RESOLVED:return Object.assign({},state,{isLoading:false,bookings:action.data});case GET_LX_AVAILABILITY.PENDING:return Object.assign({},state,{isLoadingLxAvailability:true,lxAvailability:[]});case GET_LX_AVAILABILITY.RESOLVED:return Object.assign({},state,{isLoadingLxAvailability:false,lxAvailability:action.data});default:return state;}});var actions={loadCalendar:function loadCalendar(){var month=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().get('month')+1;var year=arguments.length>1&&arguments[1]!==undefined?arguments[1]:__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().get('year');return{type:GET_CALENDAR,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/bookings/calendar?month='+month+'&year='+year),error:'Unable to load calendar'};},getLxAvailability:function getLxAvailability(userIds,month){return{type:GET_LX_AVAILABILITY,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/info/check-lx-availability',{user_ids:userIds,month:month}),error:'Error load LX availability'};}};

/***/ }),

/***/ "./src/ducks/city.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('city');var GET_CITIES=define('GET_CITIES',true);var GET_CITY=define('GET_CITY',true);var CREATE_CITY=define('CREATE_CITY',true);var UPDATE_CITY=define('UPDATE_CITY',true);var PUBLISH_CITY=define('PUBLISH_CITY',true);var initialState={loadingCities:true,cities:[],loadingCity:true,city:{}};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_CITIES.PENDING:return Object.assign({},state,{loadingCities:true,cities:[]});case GET_CITIES.RESOLVED:return Object.assign({},state,{loadingCities:false,cities:action.data});case GET_CITIES.REJECTED:return Object.assign({},state,{cities:true});case GET_CITY.PENDING:return Object.assign({},state,{loadingCity:true,city:{}});case GET_CITY.RESOLVED:return Object.assign({},state,{loadingCity:false,city:action.data});case GET_CITY.REJECTED:return Object.assign({},state,{loadingCity:true});default:return state;}});var actions={loadCities:function loadCities(){return{type:GET_CITIES,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/cities')};},loadCity:function loadCity(city){return{type:GET_CITY,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/cities/'+city)};},updateCity:function updateCity(city,data){return{type:UPDATE_CITY,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/cities/'+city,data),success:'City has been updated',error:'Unable to update city'};},createCity:function createCity(data){return{type:CREATE_CITY,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/cities',data),success:'City has been created',error:'Unable to create city'};},publishedCity:function publishedCity(city,publish){return{type:PUBLISH_CITY,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/cities/'+city+'/publish',{publish:publish}),success:'City has been published',error:'Unable to published city page'};}};

/***/ }),

/***/ "./src/ducks/config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('config');var LOAD_CONFIG=define('LOAD_CONFIG',true);var LOAD_USER_CONFIG=define('LOAD_USER_CONFIG',true);var UPDATE_CONFIG=define('UPDATE_CONFIG',true);var LOAD_TRANSLATION=define('LOAD_TRANSLATION',true);var UPDATE_TRANSLATION_SPREADSHEET=define('UPDATE_TRANSLATION_SPREADSHEET',true);var LOAD_CONFIG_KEYS=define('LOAD_CONFIG_KEYS',true);var LOAD_MEETING_POINTS=define('LOAD_MEETING_POINTS',true);var LOAD_ASSIGNEE=define('LOAD_ASSIGNEE',true);var LOAD_MANUAL_BOOKING_TYPE=define('LOAD_MANUAL_BOOKING_TYPE',true);var initialState={isLoading:true,configs:{},isLoadUserConfig:true,userConfig:{},isLoadingTranslation:true,updatingSpreadsheet:false,translations:[],isLoadingConfigKey:true,configKeys:[],isLoadingMeetingPoint:true,meetingPoints:[],isLoadingAssignee:true,assignees:[],isLoadmanualBookingType:true,manualBookingType:[],processing:false};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case LOAD_CONFIG.PENDING:return Object.assign({},state,{isLoading:true});case LOAD_CONFIG.RESOLVED:return Object.assign({},state,{isLoading:false,configs:action.data});case LOAD_USER_CONFIG.PENDING:return Object.assign({},state,{isLoadUserConfig:true});case LOAD_USER_CONFIG.RESOLVED:return Object.assign({},state,{isLoadUserConfig:false,userConfig:action.data});case LOAD_TRANSLATION.PENDING:return Object.assign({},state,{isLoadingTranslation:true});case LOAD_TRANSLATION.RESOLVED:return Object.assign({},state,{isLoadingTranslation:false,translations:action.data});case UPDATE_TRANSLATION_SPREADSHEET.PENDING:return Object.assign({},state,{updatingSpreadsheet:true});case UPDATE_TRANSLATION_SPREADSHEET.RESOLVED:return Object.assign({},state,{updatingSpreadsheet:false});case UPDATE_CONFIG.PENDING:return Object.assign({},state,{processing:true});case UPDATE_CONFIG.RESOLVED:return Object.assign({},state,{processing:false});case LOAD_CONFIG_KEYS.PENDING:return Object.assign({},state,{isLoadingConfigKey:true});case LOAD_CONFIG_KEYS.RESOLVED:return Object.assign({},state,{isLoadingConfigKey:false,configKeys:action.data});case LOAD_MANUAL_BOOKING_TYPE.PENDING:return Object.assign({},state,{isLoadmanualBookingType:true});case LOAD_MANUAL_BOOKING_TYPE.RESOLVED:return Object.assign({},state,{isLoadmanualBookingType:false,manualBookingType:action.data.manualBookingType||[]});case LOAD_MEETING_POINTS.PENDING:return Object.assign({},state,{isLoadingMeetingPoint:true});case LOAD_MEETING_POINTS.RESOLVED:return Object.assign({},state,{isLoadingMeetingPoint:false,meetingPoints:action.data});case LOAD_ASSIGNEE.PENDING:return Object.assign({},state,{isLoadingAssignee:true});case LOAD_ASSIGNEE.RESOLVED:return Object.assign({},state,{isLoadingAssignee:false,assignees:action.data});default:return state;}});var actions={loadAllConfig:function loadAllConfig(){return{type:LOAD_CONFIG,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/configs/all')};},loadConfigByKeys:function loadConfigByKeys(keys){return{type:LOAD_CONFIG,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/configs?keys='+keys)};},loadUserConfig:function loadUserConfig(id){return{type:LOAD_USER_CONFIG,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/configs/'+id)};},updateConfig:function updateConfig(id,value){return{type:UPDATE_CONFIG,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/configs/'+id,value),success:'Update config successfully',error:'Unable to update config'};},loadTranslation:function loadTranslation(){return{type:LOAD_TRANSLATION,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/translation/admin')};},updateTranslationSpreadsheet:function updateTranslationSpreadsheet(){return{type:UPDATE_TRANSLATION_SPREADSHEET,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/translation/csv'),success:'Update translation from spreadsheet successfully',error:'Unable to update translation from spreadsheet'};},getConfigKeys:function getConfigKeys(){return{type:LOAD_CONFIG_KEYS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/info/config_key'),error:'Unable to load config keys'};},getManualBookingType:function getManualBookingType(){return{type:LOAD_MANUAL_BOOKING_TYPE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/configs?keys=manualBookingType')};},getMeetingPoints:function getMeetingPoints(){return{type:LOAD_MEETING_POINTS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/info/meeting_point'),error:'Unable to load meeting point'};},getAssignee:function getAssignee(){return{type:LOAD_ASSIGNEE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/configs/all').then(function(_ref){var data=_ref.data;return{data:data.filter(function(d){return d.key==='assignee';})};})};}};

/***/ }),

/***/ "./src/ducks/customize.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('customize');var SUBMIT_MAN_CUSTOMIZE=define('SUBMIT_MAN_CUSTOMIZE',true);var initialState={};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){default:return state;}});var actions={submitManualCustomize:function submitManualCustomize(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{type:SUBMIT_MAN_CUSTOMIZE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/customize/admin',data),success:'Manual Customize has been submitted',error:'Unable to submit customize'};}};

/***/ }),

/***/ "./src/ducks/cx-handoff.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
/**
 * The human-handoff queue for the Mastra CX agent ("Kate").
 *
 * Kate answers WhatsApp and Messenger on her own, but when a conversation needs
 * a person she flags it and goes quiet. This duck talks to api-backend's
 * `chatbot.handoff:list` / `chatbot.handoff:resolve` — and resolving a case is
 * what makes her start answering that customer again, so these are not
 * read-only admin screens.
 */var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('cxHandoff');var GET_HANDOFFS=define('GET_HANDOFFS',true);var RESOLVE_HANDOFF=define('RESOLVE_HANDOFF',true);var SET_FILTERS=define('SET_FILTERS');// Kate is silent in the first two; `human_notified` only means the team was
// pinged. All three are "nobody has closed this yet", which is the queue.
var OPEN_STATUSES=['human_required','human_active','human_notified'];var initialState={isLoading:false,processing:false,handoffs:[],total:0,filters:{status:OPEN_STATUSES,// Customer name or phone number. Matched server-side: the list is paged, so
// filtering in the browser would only ever search the page on screen.
search:'',platform:undefined,sort:'oldest',page:1,limit:20},error:null};/* harmony default export */ __webpack_exports__["c"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_HANDOFFS.PENDING:return Object.assign({},state,{isLoading:true,error:null});case GET_HANDOFFS.RESOLVED:return Object.assign({},state,{isLoading:false,handoffs:action.data.handoffs||[],total:action.data.total||0});case GET_HANDOFFS.REJECTED:return Object.assign({},state,{isLoading:false,error:action.error});case RESOLVE_HANDOFF.PENDING:return Object.assign({},state,{processing:true,error:null});case RESOLVE_HANDOFF.RESOLVED:{var updated=action.data.handoff;if(!updated)return Object.assign({},state,{processing:false});return Object.assign({},state,{processing:false,// Patch the row in place rather than refetching: the list is sorted by
// how long someone has waited, and a refetch would reshuffle the table
// under the cursor of whoever just clicked.
handoffs:state.handoffs.map(function(h){return h._id===updated._id?updated:h;})});}case RESOLVE_HANDOFF.REJECTED:return Object.assign({},state,{processing:false,error:action.error});case SET_FILTERS:return Object.assign({},state,{filters:Object.assign({},state.filters,action.filters)});default:return state;}});/** Filters as the API wants them: `status` is comma-separated, blanks omitted. */var toQuery=function toQuery(filters){var params={sort:filters.sort||'oldest',page:filters.page||1,limit:filters.limit||20};if(filters.status&&filters.status.length>0){params.status=filters.status.join(',');}if(filters.platform)params.platform=filters.platform;if(filters.search&&filters.search.trim())params.search=filters.search.trim();return new URLSearchParams(params).toString();};var actions={getHandoffs:function getHandoffs(){var filters=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState.filters;return{type:GET_HANDOFFS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/mastra/handoffs?'+toQuery(filters))};},/**
   * `status` is what the agent reads on the customer's next message:
   * `human_active` keeps her quiet while an admin replies, `resolved` hands the
   * conversation back to her, `human_required` puts it back in the queue.
   */resolveHandoff:function resolveHandoff(handoffId,body){return{type:RESOLVE_HANDOFF,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/mastra/handoffs/'+handoffId,body),success:'Handoff updated'};},setFilters:function setFilters(filters){return{type:SET_FILTERS,filters:filters};},// Changing a filter always resets to page 1 — staying on page 4 of a
// narrower result set shows an empty table and looks like a broken screen.
applyFiltersAndFetch:function applyFiltersAndFetch(changes){return function(dispatch,getState){var resetPage=Object.keys(changes).indexOf('page')===-1;var filters=Object.assign({},getState().cxHandoff.filters,changes,resetPage?{page:1}:{});dispatch(actions.setFilters(filters));return dispatch(actions.getHandoffs(filters));};}};

/***/ }),

/***/ "./src/ducks/dashboard.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('dashboard');var GET_DASHBOARD_ITEM=define('GET_DASHBOARD_ITEM',true);var MARK_AS_SEEN=define('MARK_AS_SEEN',true);var initialState={isLoading:true,data:{},processing:false};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_DASHBOARD_ITEM.PENDING:return Object.assign({},state,{isLoading:true});case GET_DASHBOARD_ITEM.RESOLVED:return Object.assign({},state,{isLoading:false,data:action.data});case MARK_AS_SEEN.PENDING:return Object.assign({},state,{processing:true});case MARK_AS_SEEN.RESOLVED:case MARK_AS_SEEN.REJECTED:return Object.assign({},state,{processing:false});default:return state;}});var actions={loadDashboardData:function loadDashboardData(){return{type:GET_DASHBOARD_ITEM,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/dashboard'),error:'Unable to load dashboard data'};},markAsSeenLxImage:function markAsSeenLxImage(id){return{type:MARK_AS_SEEN,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/lx-image-mark-as-seen'),success:'LX Selfie has been mark as seen',error:'Unable to mark as seen LX Selfie'};}};

/***/ }),

/***/ "./src/ducks/fruit-market.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('fruit-market');var GET_SELLERS=define('GET_SELLERS',true);var GET_ORDERS=define('GET_ORDERS',true);var GET_ORDER=define('GET_ORDER',true);var GET_ORDER_MESSAGES=define('GET_ORDER_MESSAGES',true);var ADD_NEW_PRODUCT=define('ADD_NEW_PRODUCT',true);var UPDATE_NEW_PRODUCT=define('UPDATE_NEW_PRODUCT',true);var GET_CATEGORIES=define('GET_CATEGORIES',true);var GET_RECOMMENDATION=define('GET_RECOMMENDATION',true);var CREATE_RECOMMENDATION=define('CREATE_RECOMMENDATION',true);var initialState={seller:{loadingSellers:true,sellers:[]},order:{loadingOrders:true,orders:[],loadingOrder:true,order:{},loadingOrderMessage:true,orderMessages:[]},product:{updating:false},categories:{categories:[],loading:true},recommandation:{products:null,farm:null,loading:true}};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_SELLERS.PENDING:return Object.assign({},state,{seller:Object.assign({},state.seller,{loadingSellers:true,sellers:[]})});case GET_SELLERS.RESOLVED:return Object.assign({},state,{seller:Object.assign({},state.seller,{loadingSellers:false,sellers:action.data})});case GET_ORDERS.PENDING:return Object.assign({},state,{order:Object.assign({},state.order,{loadingOrders:true,orders:[]})});case GET_ORDERS.RESOLVED:return Object.assign({},state,{order:Object.assign({},state.order,{loadingOrders:false,orders:action.data})});case GET_ORDER.PENDING:return Object.assign({},state,{order:Object.assign({},state.order,{loadingOrder:true,order:{}})});case GET_ORDER.RESOLVED:return Object.assign({},state,{order:Object.assign({},state.order,{loadingOrder:false,order:action.data})});case GET_ORDER_MESSAGES.PENDING:return Object.assign({},state,{order:Object.assign({},state.order,{loadingOrderMessage:true,orderMessages:{}})});case GET_ORDER_MESSAGES.RESOLVED:return Object.assign({},state,{order:Object.assign({},state.order,{loadingOrderMessage:false,orderMessages:action.data})});case ADD_NEW_PRODUCT.PENDING:return Object.assign({},state,{product:{updating:true}});case ADD_NEW_PRODUCT.RESOLVED:return Object.assign({},state,{product:{updating:false}});case GET_CATEGORIES.PENDING:return Object.assign({},state,{categories:{loading:true,categories:[]}});case GET_CATEGORIES.RESOLVED:return Object.assign({},state,{categories:{loading:false,categories:action.data}});case GET_RECOMMENDATION.PENDING:return Object.assign({},state,{recommandation:{products:null,farm:null,loading:true}});case GET_RECOMMENDATION.RESOLVED:return Object.assign({},state,{recommandation:Object.assign({},action.data,{loading:false})});default:return state;}});var actions={getSellers:function getSellers(){return{type:GET_SELLERS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/fruit-market/sellers'),error:'Unable to get fruit market sellers'};},getOrders:function getOrders(type){return{type:GET_ORDERS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/fruit-market/orders?statuses='+type),error:'Unable to get fruit market orders'};},getOrder:function getOrder(id){return{type:GET_ORDER,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/fruit-market/orders/'+id),error:'Unable to get fruit market orders'};},getOrderMessages:function getOrderMessages(roomId){return{type:GET_ORDER_MESSAGES,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/fruit-market/chat/'+roomId),error:'Unable to get chat messages'};},addNewProduct:function addNewProduct(body){return{type:ADD_NEW_PRODUCT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/fruit-market/products',body),error:'Unable to create product'};},updateProduct:function updateProduct(productId,body){return{type:UPDATE_NEW_PRODUCT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/fruit-market/products/'+productId,body),error:'Unable to create product'};},getCategories:function getCategories(){return{type:GET_CATEGORIES,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/fruit-market/categories'),error:'Unable to get product categories'};},getRecommendation:function getRecommendation(){return{type:GET_RECOMMENDATION,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/fruit-market/recommendation'),error:'Unable to get recommendation'};},createRecommendation:function createRecommendation(body){return{type:CREATE_RECOMMENDATION,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/fruit-market/recommendation',body),success:'Success',error:'Unable to create recommendation'};},updateRecommendation:function updateRecommendation(id,body){return{type:CREATE_RECOMMENDATION,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/fruit-market/recommendation/'+id,body),success:'Success',error:'Unable to update recommendation'};}};

/***/ }),

/***/ "./src/ducks/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reducers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__("./src/ducks/auth.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user__ = __webpack_require__("./src/ducks/user.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trip__ = __webpack_require__("./src/ducks/trip.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__booking__ = __webpack_require__("./src/ducks/booking.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__message__ = __webpack_require__("./src/ducks/message.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__payment__ = __webpack_require__("./src/ducks/payment.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mail__ = __webpack_require__("./src/ducks/mail.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__("./src/ducks/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__search__ = __webpack_require__("./src/ducks/search.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__customize__ = __webpack_require__("./src/ducks/customize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__section__ = __webpack_require__("./src/ducks/section.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__article__ = __webpack_require__("./src/ducks/article.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__city__ = __webpack_require__("./src/ducks/city.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__topic_analytic__ = __webpack_require__("./src/ducks/topic-analytic.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__promo__ = __webpack_require__("./src/ducks/promo.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__calendar__ = __webpack_require__("./src/ducks/calendar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__dashboard__ = __webpack_require__("./src/ducks/dashboard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__redirect__ = __webpack_require__("./src/ducks/redirect.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__trip_group__ = __webpack_require__("./src/ducks/trip-group.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__swap_request__ = __webpack_require__("./src/ducks/swap-request.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__affiliate__ = __webpack_require__("./src/ducks/affiliate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__testing__ = __webpack_require__("./src/ducks/testing.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__influencer__ = __webpack_require__("./src/ducks/influencer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__review__ = __webpack_require__("./src/ducks/review.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__replace__ = __webpack_require__("./src/ducks/replace.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__restaurant__ = __webpack_require__("./src/ducks/restaurant.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__souvenir__ = __webpack_require__("./src/ducks/souvenir.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__biennale__ = __webpack_require__("./src/ducks/biennale.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pricing__ = __webpack_require__("./src/ducks/pricing.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__sms__ = __webpack_require__("./src/ducks/sms.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__partner__ = __webpack_require__("./src/ducks/partner.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__fruit_market__ = __webpack_require__("./src/ducks/fruit-market.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__local_community__ = __webpack_require__("./src/ducks/local-community.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__walking_tour__ = __webpack_require__("./src/ducks/walking-tour.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__cx_handoff__ = __webpack_require__("./src/ducks/cx-handoff.js");
/* eslint-disable */var reducers={auth:__WEBPACK_IMPORTED_MODULE_0__auth__["b" /* default */],user:__WEBPACK_IMPORTED_MODULE_1__user__["b" /* default */],trip:__WEBPACK_IMPORTED_MODULE_2__trip__["b" /* default */],booking:__WEBPACK_IMPORTED_MODULE_3__booking__["b" /* default */],message:__WEBPACK_IMPORTED_MODULE_4__message__["b" /* default */],payment:__WEBPACK_IMPORTED_MODULE_5__payment__["b" /* default */],mail:__WEBPACK_IMPORTED_MODULE_6__mail__["b" /* default */],config:__WEBPACK_IMPORTED_MODULE_7__config__["b" /* default */],search:__WEBPACK_IMPORTED_MODULE_8__search__["b" /* default */],customize:__WEBPACK_IMPORTED_MODULE_9__customize__["b" /* default */],section:__WEBPACK_IMPORTED_MODULE_10__section__["b" /* default */],article:__WEBPACK_IMPORTED_MODULE_11__article__["b" /* default */],city:__WEBPACK_IMPORTED_MODULE_12__city__["b" /* default */],topicAnalytic:__WEBPACK_IMPORTED_MODULE_13__topic_analytic__["b" /* default */],promo:__WEBPACK_IMPORTED_MODULE_14__promo__["b" /* default */],calendar:__WEBPACK_IMPORTED_MODULE_15__calendar__["b" /* default */],dashboard:__WEBPACK_IMPORTED_MODULE_16__dashboard__["b" /* default */],redirect:__WEBPACK_IMPORTED_MODULE_17__redirect__["b" /* default */],tripGroup:__WEBPACK_IMPORTED_MODULE_18__trip_group__["b" /* default */],swapRequest:__WEBPACK_IMPORTED_MODULE_19__swap_request__["b" /* default */],affiliate:__WEBPACK_IMPORTED_MODULE_20__affiliate__["b" /* default */],influencer:__WEBPACK_IMPORTED_MODULE_22__influencer__["b" /* default */],testing:__WEBPACK_IMPORTED_MODULE_21__testing__["b" /* default */],review:__WEBPACK_IMPORTED_MODULE_23__review__["b" /* default */],replace:__WEBPACK_IMPORTED_MODULE_24__replace__["b" /* default */],restaurant:__WEBPACK_IMPORTED_MODULE_25__restaurant__["b" /* default */],souvenir:__WEBPACK_IMPORTED_MODULE_26__souvenir__["b" /* default */],biennale:__WEBPACK_IMPORTED_MODULE_27__biennale__["b" /* default */],sms:__WEBPACK_IMPORTED_MODULE_29__sms__["b" /* default */],partner:__WEBPACK_IMPORTED_MODULE_30__partner__["b" /* default */],pricing:__WEBPACK_IMPORTED_MODULE_28__pricing__["b" /* default */],fruitMarket:__WEBPACK_IMPORTED_MODULE_31__fruit_market__["b" /* default */],localCommunity:__WEBPACK_IMPORTED_MODULE_32__local_community__["b" /* default */],walkingTour:__WEBPACK_IMPORTED_MODULE_33__walking_tour__["b" /* default */],cxHandoff:__WEBPACK_IMPORTED_MODULE_34__cx_handoff__["c" /* default */]};

/***/ }),

/***/ "./src/ducks/influencer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_api__ = __webpack_require__("./src/utils/api.js");
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var define=Object(__WEBPACK_IMPORTED_MODULE_1_utils_constantCreator__["a" /* default */])('influencer');var GET_INFLUENCER_USERS=define('GET_INFLUENCER_USERS',true);var GET_INFLUENCER_USER=define('GET_INFLUENCER_USER',true);var SET_INFLUENCER_DETAIL_BY_TYPE=define('SET_INFLUENCER_DETAIL_BY_TYPE',true);var initialState={loading:false,users:[],user:{}};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_INFLUENCER_USERS.PENDING:return Object.assign({},state,{loading:true,users:{}});case GET_INFLUENCER_USERS.RESOLVED:return Object.assign({},state,{users:action.data,loading:false});case GET_INFLUENCER_USERS.REJECTED:return Object.assign({},state,{loading:false});case GET_INFLUENCER_USER.PENDING:return Object.assign({},state,{loading:true,user:{}});case GET_INFLUENCER_USER.RESOLVED:return Object.assign({},state,{user:action.data,loading:false});case GET_INFLUENCER_USER.REJECTED:return Object.assign({},state,{loading:false});case SET_INFLUENCER_DETAIL_BY_TYPE.PENDING:return Object.assign({},state,{loading:true,user:{}});case SET_INFLUENCER_DETAIL_BY_TYPE.RESOLVED:return Object.assign({},state,{user:action.data,loading:false});case SET_INFLUENCER_DETAIL_BY_TYPE.REJECTED:return Object.assign({},state,{loading:false});default:return state;}});var actions={getInfluencerUsers:function getInfluencerUsers(){return{type:GET_INFLUENCER_USERS,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/influencer/users')};},getInfluencerUser:function getInfluencerUser(id){return{type:GET_INFLUENCER_USER,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/influencer/users/'+id)};},setInfluencerDetailByType:function setInfluencerDetailByType(data){return{type:SET_INFLUENCER_DETAIL_BY_TYPE,promise:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var user;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].put('/influencer/detail',data);case 2:_context.next=4;return __WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/influencer/users/'+data.user_id);case 4:user=_context.sent;return _context.abrupt('return',user);case 6:case'end':return _context.stop();}}},_callee,_this);}))()};}};

/***/ }),

/***/ "./src/ducks/local-community.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('localCommunity');var GET_COMMUNITIES=define('GET_COMMUNITIES',true);var GET_COMMUNITY=define('GET_COMMUNITY',true);var CREATE_COMMUNITY=define('CREATE_COMMUNITY',true);var UPDATE_COMMUNITY=define('UPDATE_COMMUNITY',true);var initialState={loading:true,communities:[],community:{}};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_COMMUNITIES.PENDING:return Object.assign({},state,{loading:true,communities:[]});case GET_COMMUNITIES.RESOLVED:return Object.assign({},state,{communities:action.data,loading:false});case GET_COMMUNITIES.REJECTED:return Object.assign({},state,{loading:false});case GET_COMMUNITY.PENDING:return Object.assign({},state,{loading:true,community:{}});case GET_COMMUNITY.RESOLVED:return Object.assign({},state,{community:action.data,loading:false});case GET_COMMUNITY.REJECTED:return Object.assign({},state,{loading:false});default:return state;}});var actions={getAllCommunity:function getAllCommunity(){return{type:GET_COMMUNITIES,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/local-communities')};},getCommunityById:function getCommunityById(id){return{type:GET_COMMUNITY,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/local-communities/'+id)};},createCommunity:function createCommunity(data){return{type:CREATE_COMMUNITY,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/local-communities',data),success:'New community has been created',error:'Unable to create a community page'};},updateCommunity:function updateCommunity(id,data){return{type:UPDATE_COMMUNITY,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/local-communities/'+id,data),success:'Community has been updated',error:'Unable to update a community page'};}};

/***/ }),

/***/ "./src/ducks/mail.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('mail');var SEND_MAIL=define('SEND_MAIL',true);var initialState={};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){default:return state;}});var actions={sendMail:function sendMail(type,id,template){var data=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};return{type:SEND_MAIL,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/mail/'+type+'/'+id+'/'+template,data),success:'Email has been sent',error:'Unable to send email'};}};

/***/ }),

/***/ "./src/ducks/message.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('message');var GET_MESSAGES=define('GET_MESSAGES',true);var SELECT_MESSAGE=define('SELECT_MESSAGE');var ADD_MESSAGE=define('ADD_MESSAGE',true);var UPDATE_MESSAGE=define('UPDATE_MESSAGE',true);var DELETE_MESSAGE=define('DELETE_MESSAGE',true);var initialState={isLoading:true,messages:[],selectedMessage:null,updating:false};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_MESSAGES.PENDING:return Object.assign({},state,{isLoading:true,messages:[],selectedMessage:null});case GET_MESSAGES.RESOLVED:return Object.assign({},state,{isLoading:false,messages:action.data});case SELECT_MESSAGE:return Object.assign({},state,{selectedMessage:action.message});case ADD_MESSAGE.PENDING:case UPDATE_MESSAGE.PENDING:case DELETE_MESSAGE.PENDING:return Object.assign({},state,{updating:true});case ADD_MESSAGE.RESOLVED:case UPDATE_MESSAGE.RESOLVED:case DELETE_MESSAGE.RESOLVED:return Object.assign({},state,{updating:false});case ADD_MESSAGE.REJECTED:case UPDATE_MESSAGE.REJECTED:case DELETE_MESSAGE.REJECTED:return Object.assign({},state,{updating:false});default:return state;}});var actions={loadMessages:function loadMessages(bookingId){return{type:GET_MESSAGES,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/bookings/'+bookingId+'/messages?skip=0&limit=100'),error:'Unable to load messages'};},selectMessage:function selectMessage(message){return{type:SELECT_MESSAGE,message:message};},addMessage:function addMessage(bookingId,message){return{type:ADD_MESSAGE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/bookings/'+bookingId+'/messages/add',message),success:'Message has been added',error:'Unable to add new message'};},updateMessage:function updateMessage(bookingId,messageId,original,text,isCensored){return{type:UPDATE_MESSAGE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/bookings/'+bookingId+'/messages/'+messageId,{is_censored:isCensored,original_text:original,text:text}),success:'Message has been updated',error:'Unable to update a message'};},deleteMessage:function deleteMessage(bookingId,messageId){return{type:DELETE_MESSAGE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].delete('/bookings/'+bookingId+'/messages/'+messageId),success:'Message has been deleted',error:'Unable to delete a message'};}};

/***/ }),

/***/ "./src/ducks/partner.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('article');var GET_PARTNER_TRIPS=define('GET_PARTNER_TRIPS',true);var CLEAR_LOCAL_EXPERT_STATUS_LIST=define('CLEAR_LOCAL_EXPERT_STATUS_LIST');var GET_LOCAL_EXPERT_STATUS_LIST=define('GET_LOCAL_EXPERT_STATUS_LIST',true);var initialState={isLoadingTrips:false,trips:[],isLoadingLocalExpertStatusList:false,localExpertStatusList:[]};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_PARTNER_TRIPS.PENDING:return Object.assign({},state,{isLoadingTrips:true});case GET_PARTNER_TRIPS.RESOLVED:return Object.assign({},state,{isLoadingTrips:false,trips:action.data});case GET_PARTNER_TRIPS.REJECTED:return Object.assign({},state,{isLoadingTrips:false,trips:[]});case GET_LOCAL_EXPERT_STATUS_LIST.PENDING:return Object.assign({},state,{isLoadingLocalExpertStatusList:true});case GET_LOCAL_EXPERT_STATUS_LIST.RESOLVED:return Object.assign({},state,{isLoadingLocalExpertStatusList:false,localExpertStatusList:action.data});case GET_LOCAL_EXPERT_STATUS_LIST.REJECTED:return Object.assign({},state,{isLoadingLocalExpertStatusList:false,localExpertStatusList:[]});case CLEAR_LOCAL_EXPERT_STATUS_LIST:return Object.assign({},state,{localExpertStatusList:[]});default:return state;}});var actions={getPartnerTrips:function getPartnerTrips(type){return{type:GET_PARTNER_TRIPS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/trips/business-partner?type='+type),success:'Load trips successfully',error:'Fail to load trips'};},getLocalExpertStatusList:function getLocalExpertStatusList(tripId,date){return{type:GET_LOCAL_EXPERT_STATUS_LIST,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/users/business-partner?trip_id='+tripId+'&date='+date),success:'Load local expert data successfully',error:'Fail to load local expert data'};},clearLocalExpertStatusList:function clearLocalExpertStatusList(){return{type:CLEAR_LOCAL_EXPERT_STATUS_LIST};}};

/***/ }),

/***/ "./src/ducks/payment.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__("./node_modules/moment-timezone/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_1_utils_constantCreator__["a" /* default */])('payment');var ARPPROVE_LX_PAYMENT=define('ARPPROVE_LX_PAYMENT',true);var HOLD_PAYMENT=define('HOLD_PAYMENT',true);var GET_PAYOUT_LIST=define('GET_PAYOUT_LIST',true);var PAID_BILL=define('PAID_BILL',true);var GET_STATEMENT=define('GET_STATEMENT',true);var GET_REFUNDS=define('GET_REFUNDS',true);var APPROVE_REFUND=define('APPROVE_REFUND',true);var VOID_REFUND=define('VOID_REFUND',true);var GET_HISTORY=define('GET_HISTORY',true);var DOWNLOAD_MANUAL_PAYMENT_FILE=define('DOWNLOAD_MANUAL_PAYMENT_FILE',true);var initialState={isLoadingPayoutList:true,payoutList:[],isLoadingStatement:true,statements:[],isLoadingRefund:true,refunds:[],isLoadingHistory:true,history:[]};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_PAYOUT_LIST.RESOLVED:return Object.assign({},state,{isLoadingPayoutList:false,payoutList:action.data});case GET_STATEMENT.PENDING:return Object.assign({},state,{isLoadingStatement:true});case GET_STATEMENT.RESOLVED:return Object.assign({},state,{isLoadingStatement:false,statements:action.data});case GET_REFUNDS.PENDING:return Object.assign({},state,{isLoadingRefund:true});case GET_REFUNDS.RESOLVED:return Object.assign({},state,{isLoadingRefund:false,refunds:action.data});case GET_HISTORY.PENDING:return Object.assign({},state,{isLoadingHistory:true});case GET_HISTORY.RESOLVED:return Object.assign({},state,{isLoadingHistory:false,history:action.data});default:return state;}});var actions={approvedLxPayment:function approvedLxPayment(id){return{type:ARPPROVE_LX_PAYMENT,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/payments/'+id+'/approve'),success:'LX Payment has been approved',error:'Unable to approve LX payment'};},holdPayment:function holdPayment(id){return{type:HOLD_PAYMENT,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/hold-payment',{is_hold:true}),success:'LX Payment has been holded',error:'Unable to hold LX payment'};},unholdPayment:function unholdPayment(id){return{type:HOLD_PAYMENT,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/bookings/'+id+'/admin/hold-payment',{is_hold:false}),success:'LX Payment has been unholded',error:'Unable to unhold LX payment'};},getPayoutList:function getPayoutList(){return{type:GET_PAYOUT_LIST,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/payments/bills'),error:'Unable to load payout list'};},paidBill:function paidBill(hash){return{type:PAID_BILL,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/payments/'+hash+'/paid-bill'),success:hash+' has been paid',error:'Unable to paid bill'};},getStatement:function getStatement(){var from=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().add(-1,'month').format('YYYY-MM-DD');var to=arguments.length>1&&arguments[1]!==undefined?arguments[1]:__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().format('YYYY-MM-DD');var lx=arguments[2];return{type:GET_STATEMENT,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/payments/statement?from='+from+'&to='+to+(lx?'&user_id='+lx:'')),error:'Unable to load statement'};},getRefund:function getRefund(){return{type:GET_REFUNDS,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/refunds/pending'),error:'Unable to get pending refund'};},approveRefund:function approveRefund(refundId){return{type:APPROVE_REFUND,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/refunds/'+refundId+'/approve'),success:'Refund has been approved',error:'Unable to approve refund'};},voidRefund:function voidRefund(refundId){return{type:VOID_REFUND,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].delete('/refunds/'+refundId+'/void'),success:'Refund has been voided',error:'Unable to void refund'};},getHistory:function getHistory(){var from=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().add(-1,'month').format('YYYY-MM-DD');var to=arguments.length>1&&arguments[1]!==undefined?arguments[1]:__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().format('YYYY-MM-DD');return{type:GET_HISTORY,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/payments/history?from='+from+'&to='+to),error:'Unable to load payment history'};},downloadManualPaymentFile:function downloadManualPaymentFile(date,users){return{type:DOWNLOAD_MANUAL_PAYMENT_FILE,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/files/kbank/manual',{date:date,users:users}),success:'Downloaded',error:'Unable to load a file'};}};

/***/ }),

/***/ "./src/ducks/pricing.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('pricing');var GET_TAGS=define('GET_TAGS',true);var GET_BOOKING_LOCATION_DATA=define('GET_BOOKING_LOCATION_DATA',true);var CLEAR_TAGS=define('CLEAR_TAGS');var CLEAR_BOOKING_DATA_LIST=define('CLEAR_BOOKING_DATA_LIST');var ADD_CUSTOM_TAG=define('ADD_CUSTOM_TAG');var initialState={tags:[],bookingDataList:[]};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_TAGS.RESOLVED:return Object.assign({},state,{tags:action.data});case CLEAR_TAGS:return Object.assign({},state,{tags:[]});case ADD_CUSTOM_TAG:return Object.assign({},state,{tags:[].concat(_toConsumableArray(state.tags),[action.tag])});case GET_BOOKING_LOCATION_DATA.RESOLVED:return Object.assign({},state,{bookingDataList:action.data});case CLEAR_BOOKING_DATA_LIST:return Object.assign({},state,{bookingDataList:[]});default:return state;}});var actions={getTags:function getTags(txt){return{type:GET_TAGS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/bookings/get-tags',{txt:txt})};},clearTags:function clearTags(){return{type:CLEAR_TAGS};},getBookingLocationData:function getBookingLocationData(){var tags=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var matchExactly=arguments[1];return{type:GET_BOOKING_LOCATION_DATA,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/bookings/get-booking-location-data',{tags:tags,matchExactly:matchExactly})};},clearBookingDataList:function clearBookingDataList(){return{type:CLEAR_BOOKING_DATA_LIST};},addCustomTag:function addCustomTag(tag){return{type:ADD_CUSTOM_TAG,tag:tag};}};

/***/ }),

/***/ "./src/ducks/promo.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('promo');var GET_PROMO=define('GET_PROMO',true);var GET_ARC_PROMO=define('GET_ARC_PROMO',true);var ARCHIVE_PROMO=define('ARCHIVE_PROMO',true);var DELETE_PROMO=define('DELETE_PROMO',true);var UPDATE_PROMO=define('UPDATE_PROMO',true);var CREATE_PROMO=define('CREATE_PROMO',true);var initialState={promos:[],archived:[],isLoading:true,isLoadingArchived:true};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_PROMO.PENDING:return Object.assign({},state,{isLoading:true});case GET_PROMO.RESOLVED:return Object.assign({},state,{isLoading:false,promos:action.data});case GET_PROMO.REJECTED:return Object.assign({},state,{isLoading:false});case GET_ARC_PROMO.PENDING:return Object.assign({},state,{isLoadingArchived:true});case GET_ARC_PROMO.RESOLVED:return Object.assign({},state,{isLoadingArchived:false,archived:action.data});case GET_ARC_PROMO.REJECTED:return Object.assign({},state,{isLoadingArchived:false});default:return state;}});var actions={getPromo:function getPromo(){return{type:GET_PROMO,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/redeems'),error:'Unable to load promo code'};},getArchivedPromo:function getArchivedPromo(){return{type:GET_ARC_PROMO,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/redeems/archive'),error:'Unable to load archived promo code'};},archivePromo:function archivePromo(id){return{type:ARCHIVE_PROMO,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/redeems/'+id+'/archive')};},deletePromo:function deletePromo(id){return{type:DELETE_PROMO,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].delete('/redeems/'+id)};},updatePromo:function updatePromo(id,data){return{type:UPDATE_PROMO,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/redeems/'+id,data),success:'Promo code has been updated',error:'Unable to update promo code'};},createPromo:function createPromo(data){return{type:CREATE_PROMO,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/redeems',data),success:'Promo code has been created',error:'Unable to create promo code'};}// createSection: data => ({
//   type: CREATE_SECTION,
//   promise: api.post('/topics', data),
//   success: 'Section has been created',
//   error: 'Unable to create new section'
// }),
// editSection: (id, data) => ({
//   type: EDIT_SECTION,
//   promise: api.put(`/topics/${id}`, data),
//   success: 'Section has been edited',
//   error: 'Unable to edited section'
// }),
};

/***/ }),

/***/ "./src/ducks/redirect.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('redirect');var GET_REDIRECT=define('GET_REDIRECT',true);var CREATE_REDIRECT=define('CREATE_REDIRECT',true);var DELETE_REDIRECT=define('DELETE_REDIRECT',true);var UPDATE_REDIRECT=define('UPDATE_REDIRECT',true);var initialState={redirects:[],isLoading:true};function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case GET_REDIRECT.PENDING:return Object.assign({},state,{isLoading:true});case GET_REDIRECT.RESOLVED:return Object.assign({},state,{redirects:action.data,isLoading:false});case GET_REDIRECT.REJECTED:return Object.assign({},state,{isLoading:false});default:return state;}}var actions={getRedirect:function getRedirect(){return{type:GET_REDIRECT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/redirects'),error:'Unable to load redirects'};},deleteRedirect:function deleteRedirect(id){return{type:DELETE_REDIRECT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].delete('/redirects/'+id)};},updateRedirect:function updateRedirect(id,data){return{type:UPDATE_REDIRECT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/redirects/'+id,data),success:'Redirect has been updated',error:'Unable to update redirect'};},createRedirect:function createRedirect(data){return{type:CREATE_REDIRECT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/redirects',data),success:'Redirect has been created',error:'Unable to create redirect'};}};

/***/ }),

/***/ "./src/ducks/replace.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('search');var SEARCH=define('SEARCH',true);var REPLACE=define('REPLACE',true);var initialState={results:[],isCaseSensitive:false,isRegex:false,isStripLink:false,searching:false,replacing:false,keyword:'',replaceText:''};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case SEARCH.PENDING:return Object.assign({},state,{searching:true,keyword:action.keyword,isCaseSensitive:action.isCaseSensitive,isRegex:action.isRegex,isStripLink:action.isStripLink});case SEARCH.RESOLVED:return Object.assign({},state,{results:action.data,searching:false});case SEARCH.REJECTED:return Object.assign({},state,{searching:false});case REPLACE.PENDING:return Object.assign({},state,{replacing:true,replaceText:action.replaceText,isCaseSensitive:action.isCaseSensitive,isRegex:action.isRegex,isStripLink:action.isStripLink});case REPLACE.RESOLVED:return Object.assign({},state,{replacing:false,results:[]});case REPLACE.REJECTED:return Object.assign({},state,{replacing:false});default:return state;}});var actions={search:function search(keyword,isCaseSensitive,isRegex,isStripLink){return{type:SEARCH,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/info/search?is_case_sensitive='+(isCaseSensitive?'true':'false')+'&is_regex='+(isRegex?'true':'false')+'&is_strip_link='+(isStripLink?'true':'false'),{keyword:keyword}),success:'Search done',error:'Search fail'};},replace:function replace(keyword,replaceText,locations,isCaseSensitive,isRegex,isStripLink){return{type:REPLACE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/info/replace?is_case_sensitive='+(isCaseSensitive?'true':'false')+'&is_regex='+(isRegex?'true':'false')+'&is_strip_link='+(isStripLink?'true':'false'),{keyword:keyword,replace_text:replaceText,locations:locations}),success:'Replace done',error:'Replace fail'};}};

/***/ }),

/***/ "./src/ducks/restaurant.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('restaurant');var GET_RESTAURANTS=define('GET_RESTAURANTS',true);var GET_RESTAURANT=define('GET_RESTAURANT',true);var CREATE_RESTAURANT=define('CREATE_RESTAURANT',true);var UPDATE_RESTAURANT=define('UPDATE_RESTAURANT',true);var DELETE_RESTAURANT=define('DELETE_RESTAURANT',true);var initialState={isLoading:true,restaurants:[],restaurant:{},processing:false};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_RESTAURANTS.PENDING:case GET_RESTAURANTS.REJECTED:case GET_RESTAURANT.PENDING:case GET_RESTAURANT.REJECTED:return Object.assign({},state,{isLoading:true});case GET_RESTAURANTS.RESOLVED:return Object.assign({},state,{isLoading:false,restaurants:action.data});case GET_RESTAURANT.RESOLVED:return Object.assign({},state,{isLoading:false,restaurant:action.data});case UPDATE_RESTAURANT.PENDING:case DELETE_RESTAURANT.PENDING:return Object.assign({},state,{processing:true});case UPDATE_RESTAURANT.RESOLVED:case UPDATE_RESTAURANT.REJECTED:case DELETE_RESTAURANT.RESOLVED:case DELETE_RESTAURANT.REJECTED:return Object.assign({},state,{processing:false});default:return state;}});var actions={getRestaurants:function getRestaurants(){return{type:GET_RESTAURANTS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/restaurant'),error:'Unable to get restaurants'};},getRestaurant:function getRestaurant(id){return{type:GET_RESTAURANT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/restaurant/'+id),error:'Unable to get restaurants'};},createRestaurant:function createRestaurant(data){return{type:CREATE_RESTAURANT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/restaurant',data),success:'Restaurant has been created',error:'Unable to create restaurant'};},updateRestaurant:function updateRestaurant(id,data){return{type:UPDATE_RESTAURANT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/restaurant/'+id,data),success:'Restaurant has been updated',error:'Unable to update restaurant'};},deleteRestaurant:function deleteRestaurant(id){return{type:DELETE_RESTAURANT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].delete('/restaurant/'+id),success:'Restaurant has been deleted',error:'Unable to delete restaurant'};}};

/***/ }),

/***/ "./src/ducks/review.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('review');var GET_REVIEWS=define('GET_REVIEWS',true);var GET_REVIEW=define('GET_REVIEW',true);var SET_CHANGE_REVIEW=define('SET_CHANGE_REVIEW',true);var GET_SKIP_REVIEWS=define('GET_SKIP_REVIEWS',true);var DELETE_REVIEW=define('DELETE_REVIEW',true);var ADD_REVIEW=define('ADD_REVIEW',true);var initialState={reviews:[],review:{},isLoading:true,processing:false};function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case GET_REVIEWS.PENDING:return Object.assign({},state,{isLoading:true});case GET_REVIEWS.RESOLVED:return Object.assign({},state,{reviews:action.data,isLoading:false});case GET_REVIEW.PENDING:return Object.assign({},state,{isLoading:true});case GET_REVIEW.RESOLVED:return Object.assign({},state,{review:action.data,isLoading:false});case SET_CHANGE_REVIEW.PENDING:return Object.assign({},state,{isLoading:true});case SET_CHANGE_REVIEW.RESOLVED:return Object.assign({},state,{isLoading:false});case GET_SKIP_REVIEWS.PENDING:return Object.assign({},state,{isLoading:true});case GET_SKIP_REVIEWS.RESOLVED:return Object.assign({},state,{reviews:action.data,isLoading:false});case DELETE_REVIEW.PENDING:case ADD_REVIEW.PENDING:return Object.assign({},state,{processing:true});case DELETE_REVIEW.RESOLVED:case ADD_REVIEW.RESOLVED:return Object.assign({},state,{processing:false});default:return state;}}var actions={getReviews:function getReviews(){return{type:GET_REVIEWS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/reviews'),error:'Unable to load reviews'};},getReview:function getReview(id){return{type:GET_REVIEW,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/reviews/'+id+'/view'),error:'Unable to load review'};},getSkipReviews:function getSkipReviews(){var skip=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;return{type:GET_SKIP_REVIEWS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/reviews?skip='+skip)};},setChangeReview:function setChangeReview(_ref){var id=_ref.id,lxId=_ref.lxId;return{type:SET_CHANGE_REVIEW,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/reviews/'+id+'/change-review',{lx_id:lxId}),error:'Something went wrong'};},deleteReview:function deleteReview(id){return{type:DELETE_REVIEW,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].delete('/reviews/'+id),success:'Review has been deleted',error:'Unable to delete review'};},addReview:function addReview(review,shouldSendEmailToLocalExpert){return{type:ADD_REVIEW,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/reviews',{review:review,shouldSendEmailToLocalExpert:shouldSendEmailToLocalExpert}),success:'Review has been added',error:'Unable to add review'};}};

/***/ }),

/***/ "./src/ducks/search.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_api__ = __webpack_require__("./src/utils/api.js");
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var define=Object(__WEBPACK_IMPORTED_MODULE_1_utils_constantCreator__["a" /* default */])('search');var SEARCH=define('SEARCH',true);var CLEAR=define('CLEAR');var initialState={searching:false,searchingMore:false,text:'',results:{},isShowAll:false};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case SEARCH.PENDING:return Object.assign({},state,{searching:!action.isShowAll&&true,searchingMore:action.isShowAll,text:action.text});case SEARCH.RESOLVED:return Object.assign({},state,{searching:false,searchingMore:false,isShowAll:action.isShowAll,results:action.data});case SEARCH.REJECTED:return Object.assign({},state,{searching:false,searchingMore:false});case CLEAR:return initialState;default:return state;}});var getPaginationKeys=function getPaginationKeys(){var skip=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var limit=arguments.length>1&&arguments[1]!==undefined?arguments[1]:10;var pagination={skip:skip,limit:limit};return{user:pagination,listing:pagination,booking:pagination,topic:pagination};};var actions={search:function search(text){var isShowAll=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return{type:SEARCH,promise:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var emailRegEx,apiPromise,resp;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:emailRegEx=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;// eslint-disable-line
apiPromise=emailRegEx.test(text)?__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/users/email-search',Object.assign({email:text},isShowAll?{}:{limit:10})).then(function(data){return{data:{user:data.data||[],booking:[],listing:[],topic:[]}};}):__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].post('/elasticsearch/search',{text:text,keys:isShowAll?getPaginationKeys(0,0):getPaginationKeys()});_context.next=4;return apiPromise;case 4:resp=_context.sent;return _context.abrupt('return',resp);case 6:case'end':return _context.stop();}}},_callee,_this);}))(),success:'Search done',error:'Search fail',text:text,isShowAll:isShowAll};},clear:function clear(){return{type:CLEAR};}};

/***/ }),

/***/ "./src/ducks/section.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('section');var SEARCH=define('SEARCH',true);var GET_SECTION=define('GET_SECTION',true);var CREATE_SECTION=define('CREATE_SECTION',true);var EDIT_SECTION=define('EDIT_SECTION',true);var initialState={searching:false,sections:[],isLoading:true,section:{}};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case SEARCH.PENDING:return Object.assign({},state,{searching:true,sections:[]});case SEARCH.RESOLVED:return Object.assign({},state,{searching:false,sections:action.data?action.data.topic:[]});case SEARCH.REJECTED:return Object.assign({},state,{searching:false});case GET_SECTION.PENDING:return Object.assign({},state,{isLoading:true,section:{}});case GET_SECTION.RESOLVED:return Object.assign({},state,{isLoading:false,section:action.data});case GET_SECTION.REJECTED:return Object.assign({},state,{isLoading:false});default:return state;}});var actions={searchSection:function searchSection(text){return{type:SEARCH,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/elasticsearch/search',{text:text,keys:{topic:{skip:0,limit:0}}}),success:'Search section done',error:'Search section fail'};},getSection:function getSection(id){return{type:GET_SECTION,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/topics/'+id),error:'Unable to load section data'};},createSection:function createSection(data){return{type:CREATE_SECTION,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/topics',data),success:'Section has been created',error:'Unable to create new section'};},editSection:function editSection(id,data){return{type:EDIT_SECTION,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/topics/'+id,data),success:'Section has been edited',error:'Unable to edited section'};}};

/***/ }),

/***/ "./src/ducks/sms.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('sms');var SEND_SMS=define('SEND_SMS',true);var initialState={loading:false};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case SEND_SMS.PENDING:return Object.assign({},state,{loading:true});case SEND_SMS.REJECTED:case SEND_SMS.RESOLVED:return Object.assign({},state,{loading:false});default:return state;}});var actions={sendSMS:function sendSMS(_ref){var mobile=_ref.mobile,text=_ref.text;return{type:SEND_SMS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/sms',{mobile:mobile,text:text}),success:'SMS Sent',error:'Fail to Sent SMS'};}};

/***/ }),

/***/ "./src/ducks/souvenir.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('souvenir');var GET_SOUVENIRS=define('GET_SOUVENIRS',true);var GET_SOUVENIR=define('GET_SOUVENIR',true);var CREATE_SOUVENIR=define('CREATE_SOUVENIR',true);var UPDATE_SOUVENIR=define('UPDATE_SOUVENIR',true);var DELETE_SOUVENIR=define('DELETE_SOUVENIR',true);var initialState={isLoading:true,souvenirs:[],souvenir:{},processing:false};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_SOUVENIRS.PENDING:case GET_SOUVENIRS.REJECTED:case GET_SOUVENIR.PENDING:case GET_SOUVENIR.REJECTED:return Object.assign({},state,{isLoading:true});case GET_SOUVENIRS.RESOLVED:return Object.assign({},state,{isLoading:false,souvenirs:action.data});case GET_SOUVENIR.RESOLVED:return Object.assign({},state,{isLoading:false,souvenir:action.data});case UPDATE_SOUVENIR.PENDING:case DELETE_SOUVENIR.PENDING:return Object.assign({},state,{processing:true});case UPDATE_SOUVENIR.RESOLVED:case UPDATE_SOUVENIR.REJECTED:case DELETE_SOUVENIR.RESOLVED:case DELETE_SOUVENIR.REJECTED:return Object.assign({},state,{processing:false});default:return state;}});var actions={getSouvenirs:function getSouvenirs(){return{type:GET_SOUVENIRS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/souvenir'),error:'Unable to get souvenirs'};},getSouvenir:function getSouvenir(id){return{type:GET_SOUVENIR,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/souvenir/'+id),error:'Unable to get souvenir'};},createSouvenir:function createSouvenir(data){return{type:CREATE_SOUVENIR,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/souvenir',data),success:'Souvenir has been created',error:'Unable to create souvenir'};},updateSouvenir:function updateSouvenir(id,data){return{type:UPDATE_SOUVENIR,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/souvenir/'+id,data),success:'Souvenir has been updated',error:'Unable to update souvenir'};},deleteSouvenir:function deleteSouvenir(id){return{type:DELETE_SOUVENIR,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].delete('/souvenir/'+id),success:'Souvenir has been deleted',error:'Unable to delete souvenir'};}};

/***/ }),

/***/ "./src/ducks/swap-request.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('swap-request');var GET_ALL_REQUEST=define('GET_ALL_REQUEST',true);var GET_SWAP_REQUEST=define('GET_SWAP_REQUEST',true);var CANCEL_SWAP_REQUEST=define('CANCEL_SWAP_REQUEST',true);var initialState={isLoading:true,swapRequest:{},isLoadingList:true,list:[],processing:false};function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case GET_ALL_REQUEST.PENDING:return Object.assign({},state,{isLoadingList:true});case GET_ALL_REQUEST.RESOLVED:return Object.assign({},state,{isLoadingList:false,list:action.data});case GET_SWAP_REQUEST.PENDING:return Object.assign({},state,{isLoading:true});case GET_SWAP_REQUEST.RESOLVED:return Object.assign({},state,{isLoading:false,swapRequest:action.data});case CANCEL_SWAP_REQUEST.PENDING:return Object.assign({},state,{processing:true});case CANCEL_SWAP_REQUEST.RESOLVED:return Object.assign({},state,{processing:false});default:return state;}}var actions={getAllSwapRequest:function getAllSwapRequest(){return{type:GET_ALL_REQUEST,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/swap-request'),error:'Unable to load swap request list'};},getSwapRequest:function getSwapRequest(id){return{type:GET_SWAP_REQUEST,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/swap-request/'+id),error:'Unable to load swap request'};},cancelSwapRequest:function cancelSwapRequest(id){return{type:CANCEL_SWAP_REQUEST,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/swap-request/'+id+'/cancel'),success:'Swap request canceled successfully',error:'Unable to cancel swap request'};}};

/***/ }),

/***/ "./src/ducks/testing.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = reducer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('testing');var GET_ALL_TESTING=define('GET_ALL_TESTING',true);var CREATE_TESTING=define('CREATE_TESTING',true);var GET_TESTING=define('GET_TESTING',true);var UPDATE_TESTING=define('UPDATE_TESTING',true);var DELETE_TESTING=define('DELETE_TESTING',true);var initialState={isLoadingList:true,tests:[],isLoadingTest:true,test:null,processing:false};function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case GET_ALL_TESTING.PENDING:return Object.assign({},state,{isLoadingList:true});case GET_ALL_TESTING.RESOLVED:return Object.assign({},state,{isLoadingList:false,tests:action.data});case GET_TESTING.PENDING:return Object.assign({},state,{isLoadingTest:true});case GET_TESTING.RESOLVED:return Object.assign({},state,{isLoadingTest:false,test:action.data});case CREATE_TESTING.PENDING:case UPDATE_TESTING.PENDING:case DELETE_TESTING.PENDING:return Object.assign({},state,{processing:true});case CREATE_TESTING.RESOLVED:case UPDATE_TESTING.RESOLVED:case DELETE_TESTING.RESOLVED:return Object.assign({},state,{processing:false});default:return state;}}var actions={loadAllTesting:function loadAllTesting(){return{type:GET_ALL_TESTING,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/configs/user'),error:'Unable to load A/B Testing list'};},createNewTesting:function createNewTesting(data){return{type:CREATE_TESTING,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/configs/user',data),success:'New Testing has been created',error:'Unable to create new testing'};},loadTesting:function loadTesting(id){return{type:GET_TESTING,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/configs/user/'+id),error:'Unable to load testing detail'};},updateTesting:function updateTesting(id,data){return{type:UPDATE_TESTING,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/configs/user/'+id,data),success:'Update testing config successfully',error:'Unable to update testing config'};},deleteTesting:function deleteTesting(id){return{type:DELETE_TESTING,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].delete('/configs/user/'+id),success:'Delete testing config successfully',error:'Unable to delete testing config'};}};

/***/ }),

/***/ "./src/ducks/topic-analytic.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__("./node_modules/moment-timezone/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_1_utils_constantCreator__["a" /* default */])('topicAnalytic');var GET_TOPIC_LIST=define('GET_TOPIC_LIST',true);var GET_TOPIC_ANALYTIC_ITEM=define('GET_TOPIC_ANALYTIC_ITEM',true);var initialState={firstLoad:true,loading:true,data:{},isLoadingList:true,isShowAll:false,topics:[]// isLoadingMore: false,
};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_TOPIC_LIST.PENDING:return Object.assign({},state,{isLoadingList:true// isLoadingMore: action.showAll
// isLoadingList: true,
// topics: []
});case GET_TOPIC_LIST.RESOLVED:return Object.assign({},state,{isLoadingList:false,topics:action.data,isShowAll:action.showAll// isLoadingMore: false
});case GET_TOPIC_ANALYTIC_ITEM.PENDING:return Object.assign({},state,{loading:true});case GET_TOPIC_ANALYTIC_ITEM.RESOLVED:return Object.assign({},state,{loading:false,data:action.data,firstLoad:false});default:return state;}});var actions={getTopicList:function getTopicList(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'tags=all';return{type:GET_TOPIC_LIST,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/warehouses/topic?'+query),error:'Unable to get topic list'};},getTopicAnalyticItem:function getTopicAnalyticItem(topicId){var from=arguments.length>1&&arguments[1]!==undefined?arguments[1]:__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().subtract(1,'months').startOf('days').format('YYYY-MM-DD');var to=arguments.length>2&&arguments[2]!==undefined?arguments[2]:__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().endOf('days').format('YYYY-MM-DD');var userType=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'unknown';return{type:GET_TOPIC_ANALYTIC_ITEM,promise:__WEBPACK_IMPORTED_MODULE_2_utils_api__["a" /* default */].get('/warehouses/topic/'+topicId+'?from='+from+'&to='+to+'&userType='+userType),error:'Unable to get topic analytic data'};}};

/***/ }),

/***/ "./src/ducks/trip-group.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('tripGroup');var GET_GROUPS=define('GET_GROUPS',true);var GET_GROUP=define('GET_GROUP',true);var CREATE_GROUP=define('CREATE_GROUP',true);var UPDATE_GROUP=define('UPDATE_GROUP',true);var REMOVE_GROUP=define('REMOVE_GROUP',true);var initialState={loadingGroups:true,groups:[],loadingGroup:true,group:{}};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_GROUPS.PENDING:return Object.assign({},state,{loadingGroups:true});case GET_GROUPS.RESOLVED:return Object.assign({},state,{loadingGroups:false,groups:action.data});case GET_GROUP.PENDING:return Object.assign({},state,{loadingGroup:true});case GET_GROUP.RESOLVED:return Object.assign({},state,{loadingGroup:false,group:action.data});default:return state;}});var actions={getTripGroups:function getTripGroups(){return{type:GET_GROUPS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/trip-group'),error:'Unable to get all trip group'};},getTripGroup:function getTripGroup(groupId){return{type:GET_GROUP,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/trip-group/'+groupId),error:'Unable to get trip group item'};},createGroup:function createGroup(data){return{type:CREATE_GROUP,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/trip-group',data),success:'Trip group has been created',error:'Unable to create new group'};},updateGroup:function updateGroup(id,data){return{type:UPDATE_GROUP,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/trip-group/'+id,data),success:'Trip group has been updated',error:'Unable to update group'};},deleteGroup:function deleteGroup(id){return{type:REMOVE_GROUP,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].delete('/trip-group/'+id),success:'Trip group has been deleted',error:'Unable to delete group'};}};

/***/ }),

/***/ "./src/ducks/trip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('trip');var GET_TRIP=define('GET_TRIP',true);var GET_APPROVED_TRIPS=define('GET_APPROVED_TRIPS',true);var UPDATE_TRIP=define('UPDATE_TRIP',true);var UPDATE_TRIP_KEYWORDS=define('UPDATE_TRIP_KEYWORDS',true);var LOAD_DIFF_TRIP=define('LOAD_DIFF_TRIP',true);var GET_LOGS=define('GET_LOGS',true);var MANUAL_BOOKING=define('MANUAL_BOOKING',true);var DUPLICATE_TRIP=define('DUPLICATE_TRIP',true);var GET_SUBSTITUTABLE_LX=define('GET_SUBSTITUTABLE_LX',true);var UPDATE_SUBSTITUTABLE_LX=define('UPDATE_SUBSTITUTABLE_LX',true);var UPDATE_TRIP_RESTAURANT=define('UPDATE_TRIP_RESTAURANT',true);var UPDATE_TRIP_SEASONAL=define('UPDATE_TRIP_SEASONAL',true);var initialState={isLoading:true,trip:{},isLoadingApprovedTrips:true,cityFlag:null,approvedTrips:[],diff:{},logs:[],isLoadingSubstitutableLx:true,recommendSubstitutableLxs:[],updating:false,isLoadingManualBook:false};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_APPROVED_TRIPS.PENDING:return Object.assign({},state,{isLoadingApprovedTrips:true});case GET_APPROVED_TRIPS.RESOLVED:return Object.assign({},state,{isLoadingApprovedTrips:false,cityFlag:action.flag,approvedTrips:action.data});case GET_TRIP.PENDING:return Object.assign({},state,{isLoading:true});case GET_TRIP.RESOLVED:return Object.assign({},state,{isLoading:false,trip:action.data});case LOAD_DIFF_TRIP.RESOLVED:return Object.assign({},state,{diff:action.data});case GET_LOGS.RESOLVED:return Object.assign({},state,{logs:action.data});case GET_SUBSTITUTABLE_LX.PENDING:return Object.assign({},state,{isLoadingSubstitutableLx:true});case GET_SUBSTITUTABLE_LX.RESOLVED:return Object.assign({},state,{isLoadingSubstitutableLx:false,recommendSubstitutableLxs:action.data});case UPDATE_TRIP_RESTAURANT.PENDING:return Object.assign({},state,{updating:true});case UPDATE_TRIP_RESTAURANT.RESOLVED:case UPDATE_TRIP_RESTAURANT.REJECTED:return Object.assign({},state,{updating:false});case MANUAL_BOOKING.PENDING:return Object.assign({},state,{isLoadingManualBook:true});case MANUAL_BOOKING.RESOLVED:case MANUAL_BOOKING.REJECTED:return Object.assign({},state,{isLoadingManualBook:false});default:return state;}});var actions={loadTrip:function loadTrip(id){return{type:GET_TRIP,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/trips/'+id),error:'Unable to load trip data'};},getApprovedTrips:function getApprovedTrips(city,keywords,productType){var queryKeywords=keywords?'&keywords='+keywords:'';var queryProductType=productType?'&product_type='+productType:'';return{type:GET_APPROVED_TRIPS,flag:city,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/trips/approved?city='+city+queryKeywords+queryProductType),error:'Unable to load approved trips'};},searchApprovedTrip:function searchApprovedTrip(keywords,city){return{type:GET_APPROVED_TRIPS,flag:city,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/trips/approved?city='+city+'&keywords='+keywords),error:'Unable to load approved trips'};},updateTrip:function updateTrip(id){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return{type:UPDATE_TRIP,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/trips/'+id,data),success:'Trip data has been updated',error:'Unable to update trip data'};},updateTripSeasonalPercentage:function updateTripSeasonalPercentage(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{type:UPDATE_TRIP_SEASONAL,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/trips/updateSeasonalPercentage',data),success:'Trip seasonal percentage has been updated',error:'Unable to update trip seasonal percentage'};},updateTripKeywords:function updateTripKeywords(id){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return{type:UPDATE_TRIP_KEYWORDS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/trips/updateKeywords/'+id,data),success:'Trip keywords has been updated',error:'Unable to update trip keywords'};},loadDiffTrip:function loadDiffTrip(originalId,resubmittedId){return{type:LOAD_DIFF_TRIP,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/trips/diff/'+originalId+'/'+resubmittedId),error:'Unable to load diff trip data'};},manualBooking:function manualBooking(data){return{type:MANUAL_BOOKING,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/bookings/admin',data),success:'Booking has been created',error:'Unable to create booking'};},duplicateTrip:function duplicateTrip(tripId,lxId,isNotCopyOriginalId,isNotGenerateTrelloCard){return{type:DUPLICATE_TRIP,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/trips/'+tripId+'/duplicate',{lx_id:lxId,is_not_copy_original_id:isNotCopyOriginalId,is_not_generate_trello_card:isNotGenerateTrelloCard}),success:'Trip has been duplicated',error:'Unable to duplicate trip'};},getLogs:function getLogs(tripId){return{type:GET_LOGS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/trips/'+tripId+'/logs'),error:'Unable to trip logs'};},loadSubstitutableLx:function loadSubstitutableLx(tripId){return{type:GET_SUBSTITUTABLE_LX,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/trips/'+tripId+'/substitutable-lx')};},updateSubstitutableLx:function updateSubstitutableLx(tripId,lxIds){return{type:UPDATE_SUBSTITUTABLE_LX,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/trips/'+tripId+'/substitutable-lx',{lxIds:lxIds}),success:'Substitutable Lx has been updated',error:'Unable to update substitutable lx'};},updateTripRestaurant:function updateTripRestaurant(tripId,restaurantIds){return{type:UPDATE_TRIP_RESTAURANT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/trips/'+tripId+'/restaurant',{restaurant_ids:restaurantIds}),success:'Restaurant in Trip has been updated',error:'Unable to update Restaurant in Trip'};}};

/***/ }),

/***/ "./src/ducks/user.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('user');var GET_USER=define('GET_USER',true);var GET_LOGS=define('GET_LOGS',true);var UPDATE_USER=define('UPDATE_USER',true);var UPDATE_USER_DEDUCTION_RATE=define('UPDATE_USER_DEDUCTION_RATE',true);var UPDATE_USER_TRAVEL_AGENCY_COMMISSION=define('UPDATE_USER_TRAVEL_AGENCY_COMMISSION',true);var UPDATE_FRUIT_MARKET_USER=define('UPDATE_FRUIT_MARKET_USER',true);var VERIFY_USER=define('VERIFY_USER',true);var REVERIFY_USER=define('REVERIFY_USER',true);var BAN_MESSAGE=define('BAN_MESSAGE',true);var SUSPEND_USER=define('SUSPEND_USER',true);var SEND_SMS=define('SEND_SMS',true);var SEND_NOTI=define('SEND_NOTI',true);var SEND_WEB_NOTI=define('SEND_WEB_NOTI',true);var GENERATE_ACCESS_TOKEN=define('GENERATE_ACCESS_TOKEN',true);var GET_SESSION_DATA=define('GET_SESSION_DATA',true);var GET_LOG_DETAIL=define('GET_LOG_DETAIL',true);var ADD_PARTNER_CREDIT=define('ADD_PARTNER_CREDIT',true);var UPDATE_COMMISSION_FACTOR=define('UPDATE_COMMISSION_FACTOR',true);var CONVERT_ROLE=define('CONVERT_ROLE',true);var GET_USER_TRIP_SWAPS=define('GET_USER_TRIP_SWAPS',true);var ADD_USER_TO_TRIP_SWAPS=define('ADD_USER_TO_TRIP_SWAPS',true);var REMOVE_USER_TO_TRIP_SWAPS=define('REMOVE_USER_TO_TRIP_SWAPS',true);var UPDATE_TRIP_SWAPS=define('UPDATE_TRIP_SWAPS',true);var initialState={isLoading:true,user:{},isLoadingLog:true,logs:[],logCount:0,sessionData:{},isLoadingSessionData:true,animalHash:'',logDetail:{},isLoadingLogDetail:false,submitting:false};/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var user=void 0;switch(action.type){case GET_USER.PENDING:return Object.assign({},state,{isLoading:true});case GET_USER.RESOLVED:user=action.data;if(!user.user.verification)user.user.verification={};return Object.assign({},state,{user:user,isLoading:false});case GET_LOGS.PENDING:return Object.assign({},state,{isLoadingLog:true});case GET_LOGS.RESOLVED:return Object.assign({},state,{logs:[].concat(_toConsumableArray(state.logs),_toConsumableArray(action.data.logMessages)),isLoadingLog:false,logCount:action.data.count,animalHash:action.data.animalHash});case GET_SESSION_DATA.PENDING:return Object.assign({},state,{isLoadingSessionData:true});case GET_SESSION_DATA.RESOLVED:return Object.assign({},state,{sessionData:action.data,isLoadingSessionData:false});case GET_LOG_DETAIL.PENDING:return Object.assign({},state,{isLoadingLogDetail:true});case GET_LOG_DETAIL.RESOLVED:return Object.assign({},state,{logDetail:action.data,isLoadingLogDetail:false});case UPDATE_COMMISSION_FACTOR.PENDING:case UPDATE_COMMISSION_FACTOR.REJECTED:return Object.assign({},state,{submitting:true});case UPDATE_COMMISSION_FACTOR.RESOLVED:return Object.assign({},state,{submitting:false});default:return state;}});var actions={getUser:function getUser(id){return{type:GET_USER,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/users/'+id),error:'Unable to load user data'};},getUserLogs:function getUserLogs(id){var skip=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var limit=arguments.length>2&&arguments[2]!==undefined?arguments[2]:20;return{type:GET_LOGS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/users/'+id+'/logs?skip='+skip+'&limit='+limit),error:'Unable to load user logs'};},updateUser:function updateUser(id,data){return{type:UPDATE_USER,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/users/'+id,data),success:'User data has been updated',error:'Unable to update user data'};},convertRole:function convertRole(id,role){return{type:CONVERT_ROLE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/users/'+id+'/convert-role',{role:role}),success:'User role has been converted',error:'Unable to convert user role'};},verifyUser:function verifyUser(id,type){return{type:VERIFY_USER,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/users/'+id+'/verify/'+type),success:'User verification item has been verified',error:'Unable to verify'};},reverifyUser:function reverifyUser(id,type){return{type:REVERIFY_USER,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/users/'+id+'/reverify/'+type),success:'User verification item has been reverified',error:'Unable to reverify'};},banMessage:function banMessage(id,isBan){return{type:BAN_MESSAGE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/users/'+id,{is_suspicious:isBan}),success:isBan?'User has been banned for chat':'User has been unbanned fot chat',error:isBan?'Unable to ban user':'Unable to unban user'};},suspendUser:function suspendUser(id,isSuspend){return{type:SUSPEND_USER,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/users/'+id,{is_suspended:isSuspend}),success:isSuspend?'User has been suspended':'User has been unsuspended',error:isSuspend?'Unable to suspend user':'Unable to unsuspend user'};},sendSms:function sendSms(mobile,text){return{type:SEND_SMS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/sms',{mobile:mobile,text:text}),success:'SMS has been sent',error:'Unable to send SMS'};},sendNoti:function sendNoti(message,userId){var title=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'Message from TakeMeTour';return{type:SEND_NOTI,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/push/send',{message:message,userId:userId,title:title}),success:'Push Notification has been sent',error:'Unable to send push notification'};},sendWebNoti:function sendWebNoti(message,userId){var title=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'Message from TakeMeTour';var link=arguments[3];return{type:SEND_WEB_NOTI,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/push/send/web',{message:message,recipient_id:userId,label:title,path:link}),success:'Web Notification has been sent',error:'Unable to send web notification'};},generateAccessToken:function generateAccessToken(id){return{type:GENERATE_ACCESS_TOKEN,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/users/'+id+'/generate-access-token')};},getSessionData:function getSessionData(id){return{type:GET_SESSION_DATA,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/session/data/'+id)};},getLogDetail:function getLogDetail(id){return{type:GET_LOG_DETAIL,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/logs/id/'+id)};},addPartnerCredit:function addPartnerCredit(id,amount){return{type:ADD_PARTNER_CREDIT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/partner/credit',{partner_id:id,amount:amount}),success:'Partner credit has been updated',error:'Unable to add partner credit'};},updateDeductionRate:function updateDeductionRate(id,rate){return{type:UPDATE_USER_DEDUCTION_RATE,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/users/'+id,{travel_agency_deduct_rate:rate}),success:'Deduction rate updated successfully',error:'Unable to update deduction rate'};},updateTravelAgencyCommission:function updateTravelAgencyCommission(id,commission){return{type:UPDATE_USER_TRAVEL_AGENCY_COMMISSION,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/users/'+id,{travel_agency_commission:commission}),success:'Travel agency commission updated successfully',error:'Unable to update travel agency commission'};},updateCommissionFactor:function updateCommissionFactor(id,factor){return{type:UPDATE_COMMISSION_FACTOR,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/users/'+id+'/affiliate-factor',factor),success:'Update Commission Factor success',enable:'Unable to update commission factor'};},getUserTripSwaps:function getUserTripSwaps(userId){return{type:GET_USER_TRIP_SWAPS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/users/'+userId+'/trip-swap'),error:'Unable to load trip swaps'};},addUserToTripSwaps:function addUserToTripSwaps(userId,swaps){return{type:ADD_USER_TO_TRIP_SWAPS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/users/'+userId+'/add-to-swap',{swaps:swaps}),success:'This user has been added to the swap',error:'Unable to add this user to the swap'};},removeUserFromTripSwaps:function removeUserFromTripSwaps(userId,tripIds){return{type:REMOVE_USER_TO_TRIP_SWAPS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].delete('/users/'+userId+'/remove-from-swap',{tripIds:tripIds}),success:'This user has been remove from the swap',error:'Unable to remove this user to the swap'};},updateTripSwaps:function updateTripSwaps(userId,swaps){return{type:UPDATE_TRIP_SWAPS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/users/'+userId+'/update-swap',{swaps:swaps}),success:'The swap has been updated',error:'Unable to update the swap'};},updateFruitMarketSeller:function updateFruitMarketSeller(id,data){return{type:UPDATE_FRUIT_MARKET_USER,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/users/'+id+'/fruit-market',data),success:'User data has been updated',error:'Unable to update user data'};}};

/***/ }),

/***/ "./src/ducks/walking-tour.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__ = __webpack_require__("./src/utils/constantCreator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_api__ = __webpack_require__("./src/utils/api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__("./node_modules/moment-timezone/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz.setDefault('Asia/Bangkok');var define=Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantCreator__["a" /* default */])('walkingTour');// Constants for async actions (Bookings)
var GET_BOOKINGS=define('GET_BOOKINGS',true);var GET_BOOKING_DETAIL=define('GET_BOOKING_DETAIL',true);var APPROVE_REFUND=define('APPROVE_REFUND',true);var REJECT_REFUND=define('REJECT_REFUND',true);var GET_AVAILABILITY=define('GET_AVAILABILITY',true);var GET_PRODUCT=define('GET_PRODUCT',true);var POST_AVAILABILITY=define('POST_AVAILABILITY',true);// Constants for async actions (CMS Products)
var GET_PRODUCTS_ADMIN=define('GET_PRODUCTS_ADMIN',true);var GET_PRODUCT_ADMIN=define('GET_PRODUCT_ADMIN',true);var CREATE_PRODUCT=define('CREATE_PRODUCT',true);var UPDATE_PRODUCT=define('UPDATE_PRODUCT',true);var APPROVE_PRODUCT=define('APPROVE_PRODUCT',true);// Constants for filter actions
var SET_FILTERS=define('SET_FILTERS');var CLEAR_FILTERS=define('CLEAR_FILTERS');var SET_SEARCH_TERM=define('SET_SEARCH_TERM');// Constants for CMS actions
var CLEAR_CURRENT_PRODUCT=define('CLEAR_CURRENT_PRODUCT');// Initial state
var initialState={isLoading:false,isLoadingDetail:false,processing:false,bookings:{data:[],pagination:{page:1,limit:20,total:0,totalPages:0},filters:{fromDate:__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().subtract(7,'days').startOf('day'),toDate:__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().add(7,'days').endOf('day'),status:undefined,search_term:''},sorting:{sortBy:'',sortOrder:''}},currentBooking:null,unavailable_dates:[],products:[],error:null,postAvailabilityResult:null,isPostingAvailability:false,// CMS Products State
cmsProducts:{data:[],isLoading:false,error:null},currentProduct:null,isLoadingProduct:false,isSaving:false,saveError:null};// Reducer
/* harmony default export */ __webpack_exports__["b"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case GET_BOOKINGS.PENDING:return Object.assign({},state,{isLoading:true,error:null});case GET_BOOKINGS.RESOLVED:return Object.assign({},state,{isLoading:false,bookings:Object.assign({},state.bookings,{data:action.data.bookings||[],pagination:Object.assign({},state.bookings.pagination,action.data.pagination)})});case GET_BOOKINGS.REJECTED:return Object.assign({},state,{isLoading:false,error:action.error});case SET_FILTERS:return Object.assign({},state,{bookings:Object.assign({},state.bookings,{filters:Object.assign({},state.bookings.filters,action.filters)})});case CLEAR_FILTERS:return Object.assign({},state,{bookings:Object.assign({},state.bookings,{filters:Object.assign({},initialState.bookings.filters)})});case SET_SEARCH_TERM:return Object.assign({},state,{bookings:Object.assign({},state.bookings,{filters:Object.assign({},state.bookings.filters,{search_term:action.searchTerm})})});case GET_AVAILABILITY.PENDING:return Object.assign({},state,{isLoading:true,error:null});case GET_AVAILABILITY.RESOLVED:return Object.assign({},state,{isLoading:false,unavailable_dates:action.data.unavailable_dates||[]});case GET_AVAILABILITY.REJECTED:return Object.assign({},state,{isLoading:false,error:action.error});case GET_PRODUCT.PENDING:return Object.assign({},state,{isLoading:true,error:null});case GET_PRODUCT.RESOLVED:return Object.assign({},state,{isLoading:false,products:Object.assign({},state.products,{data:action.data.products||[]})});case GET_PRODUCT.REJECTED:return Object.assign({},state,{isLoading:false,error:action.error});case GET_BOOKING_DETAIL.PENDING:return Object.assign({},state,{isLoadingDetail:true,error:null});case GET_BOOKING_DETAIL.RESOLVED:return Object.assign({},state,{isLoadingDetail:false,currentBooking:action.data.booking});case GET_BOOKING_DETAIL.REJECTED:return Object.assign({},state,{isLoadingDetail:false,error:action.error});case APPROVE_REFUND.PENDING:case REJECT_REFUND.PENDING:return Object.assign({},state,{processing:true,error:null});case APPROVE_REFUND.RESOLVED:case REJECT_REFUND.RESOLVED:return Object.assign({},state,{processing:false,// Update the current booking if it exists
currentBooking:state.currentBooking&&state.currentBooking.id===action.data.id?action.data:state.currentBooking});case APPROVE_REFUND.REJECTED:case REJECT_REFUND.REJECTED:return Object.assign({},state,{processing:false,error:action.error});case POST_AVAILABILITY.PENDING:return Object.assign({},state,{processing:true,postAvailabilityResult:null,error:null});case POST_AVAILABILITY.RESOLVED:return Object.assign({},state,{processing:false,postAvailabilityResult:action.data});case POST_AVAILABILITY.REJECTED:return Object.assign({},state,{processing:false,postAvailabilityResult:null,error:action.error});// CMS Products - Get All Products
case GET_PRODUCTS_ADMIN.PENDING:return Object.assign({},state,{cmsProducts:Object.assign({},state.cmsProducts,{isLoading:true,error:null})});case GET_PRODUCTS_ADMIN.RESOLVED:return Object.assign({},state,{cmsProducts:{data:action.data.products||[],isLoading:false,error:null}});case GET_PRODUCTS_ADMIN.REJECTED:return Object.assign({},state,{cmsProducts:Object.assign({},state.cmsProducts,{isLoading:false,error:action.error})});// CMS Products - Get Single Product
case GET_PRODUCT_ADMIN.PENDING:return Object.assign({},state,{isLoadingProduct:true,currentProduct:null,saveError:null});case GET_PRODUCT_ADMIN.RESOLVED:return Object.assign({},state,{isLoadingProduct:false,currentProduct:action.data.product});case GET_PRODUCT_ADMIN.REJECTED:return Object.assign({},state,{isLoadingProduct:false,saveError:action.error});// CMS Products - Create Product
case CREATE_PRODUCT.PENDING:return Object.assign({},state,{isSaving:true,saveError:null});case CREATE_PRODUCT.RESOLVED:return Object.assign({},state,{isSaving:false,currentProduct:action.data.product,cmsProducts:Object.assign({},state.cmsProducts,{data:[action.data.product].concat(_toConsumableArray(state.cmsProducts.data))})});case CREATE_PRODUCT.REJECTED:return Object.assign({},state,{isSaving:false,saveError:action.error});// CMS Products - Update Product
case UPDATE_PRODUCT.PENDING:return Object.assign({},state,{isSaving:true,saveError:null});case UPDATE_PRODUCT.RESOLVED:return Object.assign({},state,{isSaving:false,currentProduct:action.data.product,cmsProducts:Object.assign({},state.cmsProducts,{data:state.cmsProducts.data.map(function(p){return p._id===action.data.product._id?action.data.product:p;})})});case UPDATE_PRODUCT.REJECTED:return Object.assign({},state,{isSaving:false,saveError:action.error});// CMS Products - Approve Product
case APPROVE_PRODUCT.PENDING:return Object.assign({},state,{isSaving:true,saveError:null});case APPROVE_PRODUCT.RESOLVED:return Object.assign({},state,{isSaving:false,currentProduct:action.data.product,cmsProducts:Object.assign({},state.cmsProducts,{data:state.cmsProducts.data.map(function(p){return p._id===action.data.product._id?action.data.product:p;})})});case APPROVE_PRODUCT.REJECTED:return Object.assign({},state,{isSaving:false,saveError:action.error});// CMS Products - Clear Current Product
case CLEAR_CURRENT_PRODUCT:return Object.assign({},state,{currentProduct:null,saveError:null});default:return state;}});var actions={getBookings:function getBookings(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var query=new URLSearchParams(params).toString();return{type:GET_BOOKINGS,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/walking-tour/bookings/admin'+(query?'?'+query:''))};},getBookingDetail:function getBookingDetail(bookingId){return{type:GET_BOOKING_DETAIL,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/walking-tour/bookings/admin/'+bookingId)};},approveRefund:function approveRefund(bookingId){return{type:APPROVE_REFUND,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/walking-tour/bookings/admin/refund/'+bookingId,{action:'approve'})};},rejectRefund:function rejectRefund(bookingId,reason){return{type:REJECT_REFUND,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/walking-tour/bookings/admin/refund/'+bookingId,{action:'reject',reason:reason})};},getAvailability:function getAvailability(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var query=new URLSearchParams(params).toString();return{type:GET_AVAILABILITY,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/walking-tour/bookings/availability'+(query?'?'+query:''))};},getProducts:function getProducts(){return{type:GET_PRODUCT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/walking-tour/products')};},postAvailability:function postAvailability(payload){return{type:POST_AVAILABILITY,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/walking-tour/bookings/availability',payload)};},setFilters:function setFilters(filters){return{type:SET_FILTERS,filters:filters};},clearFilters:function clearFilters(){return{type:CLEAR_FILTERS};},setSearchTerm:function setSearchTerm(searchTerm){return{type:SET_SEARCH_TERM,searchTerm:searchTerm};},applyFiltersAndFetch:function applyFiltersAndFetch(filters){var updateURL=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return function(dispatch){// Set filters in state
dispatch(actions.setFilters(filters));// Prepare API parameters
var params={limit:9999,from_date:filters.fromDate.clone().startOf('day').toISOString(),to_date:filters.toDate.clone().endOf('day').toISOString()};if(filters.status)params.status=filters.status;if(filters.search_term)params.reference_number=filters.search_term;// Update URL if updateURL function is provided
if(updateURL&&typeof updateURL==='function'){updateURL(params);}// Fetch bookings with filters
return dispatch(actions.getBookings(params));};},clearAllFiltersAndFetch:function clearAllFiltersAndFetch(){var updateURL=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;return function(dispatch){// Clear filters in state
dispatch(actions.clearFilters());// Clear URL if updateURL function is provided
if(updateURL&&typeof updateURL==='function'){updateURL({});}// Fetch bookings without filters
return dispatch(actions.getBookings({limit:9999}));};},// CMS Product Actions
getProductsAdmin:function getProductsAdmin(){return{type:GET_PRODUCTS_ADMIN,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/walking-tour/products/admin')};},getProductAdmin:function getProductAdmin(id){return{type:GET_PRODUCT_ADMIN,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].get('/walking-tour/products/admin/'+id)};},createProduct:function createProduct(data){return{type:CREATE_PRODUCT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].post('/walking-tour/products/admin',data)};},updateProduct:function updateProduct(id,data){return{type:UPDATE_PRODUCT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/walking-tour/products/admin/'+id,data)};},approveProduct:function approveProduct(id,status){return{type:APPROVE_PRODUCT,promise:__WEBPACK_IMPORTED_MODULE_1_utils_api__["a" /* default */].put('/walking-tour/products/admin/'+id+'/approval',{status:status})};},clearCurrentProduct:function clearCurrentProduct(){return{type:CLEAR_CURRENT_PRODUCT};}};

/***/ }),

/***/ "./src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_es_locale_provider_style_css__ = __webpack_require__("./node_modules/antd/es/locale-provider/style/css.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_locale_provider__ = __webpack_require__("./node_modules/antd/es/locale-provider/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__("./node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__("./node_modules/styled-components/dist/styled-components.browser.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_timezone__ = __webpack_require__("./node_modules/moment-timezone/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_locale_provider_en_US__ = __webpack_require__("./node_modules/antd/lib/locale-provider/en_US.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_lib_locale_provider_en_US___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_lib_locale_provider_en_US__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_wildcard__ = __webpack_require__("./node_modules/wildcard/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_wildcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_wildcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_createStore__ = __webpack_require__("./src/utils/createStore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_history_createBrowserHistory__ = __webpack_require__("./node_modules/history/createBrowserHistory.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App__ = __webpack_require__("./src/App.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__theme_colors__ = __webpack_require__("./src/theme/colors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_whatwg_fetch__ = __webpack_require__("./node_modules/whatwg-fetch/fetch.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_dist_antd_css__ = __webpack_require__("./node_modules/antd/dist/antd.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_dist_antd_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_dist_antd_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_font_awesome_css_font_awesome_min_css__ = __webpack_require__("./node_modules/font-awesome/css/font-awesome.min.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_draft_js_dist_Draft_css__ = __webpack_require__("./node_modules/draft-js/dist/Draft.css");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_draft_js_dist_Draft_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_draft_js_dist_Draft_css__);
// import registerServiceWorker from './registerServiceWorker';
__WEBPACK_IMPORTED_MODULE_7_moment_timezone___default.a.tz.setDefault('Asia/Bangkok');window.wildcard=__WEBPACK_IMPORTED_MODULE_9_wildcard___default.a;var history=__WEBPACK_IMPORTED_MODULE_11_history_createBrowserHistory___default()();var store=Object(__WEBPACK_IMPORTED_MODULE_10_utils_createStore__["a" /* default */])(history);var rootElement=document.getElementById('root');__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux__["Provider"],{store:store},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["ConnectedRouter"],{history:history},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_locale_provider__["a" /* default */],{locale:__WEBPACK_IMPORTED_MODULE_8_antd_lib_locale_provider_en_US___default.a},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_styled_components__["a" /* ThemeProvider */],{theme:__WEBPACK_IMPORTED_MODULE_13__theme_colors__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__App__["a" /* default */],null))))),rootElement);// registerServiceWorker();
if(false){module.hot.accept('./App',function(){var NextApp=require('./App').default;ReactDOM.render(React.createElement(Provider,{store:store},React.createElement(ConnectedRouter,{history:history},React.createElement(_LocaleProvider,{locale:enUS},React.createElement(ThemeProvider,{theme:colors},React.createElement(NextApp,null))))),rootElement);});}

/***/ }),

/***/ "./src/theme/colors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({darkOrange:'#e86a1a',lightOrange:'#e86b24',white:'#ffffff',lightGray:'#9b9b9b',lightGray2:'#cccccc',superLightGray:'#fafafa',superLightGray2:'#f2f2f2',gray:'#4a4a4a',gray2:'#5e5e5e',gainsboro:'#dcdcdc',darkRed:'#d0021b',borderGray:'#d8d8d8',// yellow: '#eada1b,
warningYellow:'#f5a623',// darkYellow: '#ecdf38',
tagLightBlue:'#f2f9fc',tagBlue:'#4a90e2',tagBorderBlue:'#cae6f3',black:'#000000',lineGray:'#d0d0d0',lineGray2:'#ededed',bgGray:'#ebebeb',inputLabel:'#4a4a4a',inputBorder:'#8e8e8e',cyan:'#00cfa7',// yellow: '#f8e71c',
yellow:'#f39c12',borderButtonGray:'#979797',green:'#00af8d',darkGreen:'#0b6416',lightGreen:'#00a65a',superLightBlue:'#f2f9fc',lightBlue:'#cae6f3',blue:'#1cb6e6',darkBlue:'#4a90e2',red:'#d0021b'});

/***/ }),

/***/ "./src/theme/images/default-img.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/default-img.6ae6aba6.png";

/***/ }),

/***/ "./src/theme/images/default-pdf.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/default-pdf.a12936e8.png";

/***/ }),

/***/ "./src/utils/api.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./src/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__("./node_modules/moment-timezone/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var baseURL=__WEBPACK_IMPORTED_MODULE_1_config___default.a.apiPath;var processFetch=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res){var createAt,fileName,contentDisposition,filenameRegex,matches,a,blob;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!res.headers.get('Content-Type').includes('application/zip')){_context.next=14;break;}createAt=__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().format('DD-MM-YYYY');fileName='Download_'+createAt+'.zip';contentDisposition=res.headers.get('Content-Disposition');if(contentDisposition){filenameRegex=/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;matches=filenameRegex.exec(contentDisposition);if(matches!=null&&matches[1]){fileName=matches[1].replace(/['"]/g,'');}}if(!(window.URL&&document)){_context.next=14;break;}a=document.createElement('a');_context.next=9;return res.blob();case 9:blob=_context.sent;a.href=window.URL.createObjectURL(blob);a.download=fileName;a.click();return _context.abrupt('return',{});case 14:return _context.abrupt('return',Promise.all([res.ok,res.json()]).then(function(_ref2){var _ref3=_slicedToArray(_ref2,2),ok=_ref3[0],response=_ref3[1];if(!ok){return Promise.reject(response);}return{data:response};}));case 15:case'end':return _context.stop();}}},_callee,_this);}));return function processFetch(_x){return _ref.apply(this,arguments);};}();/* harmony default export */ __webpack_exports__["a"] = ({get:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(url){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:return _context2.abrupt('return',fetch(''+baseURL+url,{method:'GET',credentials:'include',headers:{'Content-Type':'application/json'//  'x-access-token': '3y3eOjYqQJyY21dyfY7WqWUwGG9lQJMj'
}}).then(processFetch));case 1:case'end':return _context2.stop();}}},_callee2,_this);}));function get(_x2){return _ref4.apply(this,arguments);}return get;}(),post:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(url){var body=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:return _context3.abrupt('return',fetch(''+baseURL+url,{method:'POST',credentials:'include',headers:{'Content-Type':'application/json'// TODO: PLEASE REMOVE THIS BEFORE DEPLOYING
//  'x-access-token': '3y3eOjYqQJyY21dyfY7WqWUwGG9lQJMj'
},body:JSON.stringify(body)}).then(processFetch));case 1:case'end':return _context3.stop();}}},_callee3,_this);}));function post(_x4){return _ref5.apply(this,arguments);}return post;}(),put:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(url){var body=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:return _context4.abrupt('return',fetch(''+baseURL+url,{method:'PUT',credentials:'include',headers:{'Content-Type':'application/json'//  'x-access-token': '3y3eOjYqQJyY21dyfY7WqWUwGG9lQJMj'
},body:JSON.stringify(body)}).then(processFetch));case 1:case'end':return _context4.stop();}}},_callee4,_this);}));function put(_x6){return _ref6.apply(this,arguments);}return put;}(),delete:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(url){var body=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:return _context5.abrupt('return',fetch(''+baseURL+url,{method:'DELETE',credentials:'include',headers:{'Content-Type':'application/json'//  'x-access-token': '3y3eOjYqQJyY21dyfY7WqWUwGG9lQJMj'
},body:JSON.stringify(body)}).then(processFetch));case 1:case'end':return _context5.stop();}}},_callee5,_this);}));function _delete(_x8){return _ref7.apply(this,arguments);}return _delete;}()});

/***/ }),

/***/ "./src/utils/constantCreator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export promiseStates */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_define__ = __webpack_require__("./node_modules/redux-define/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_define___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_define__);
var rootCreator=Object(__WEBPACK_IMPORTED_MODULE_0_redux_define__["defineAction"])('takemetour-admin');var promiseStates=['PENDING','RESOLVED','REJECTED'];/* harmony default export */ __webpack_exports__["a"] = (function(namespace){return function(action,isContainPromiseStates){return isContainPromiseStates?rootCreator.defineAction(namespace).defineAction(action,promiseStates):rootCreator.defineAction(namespace).defineAction(action).toString();};});

/***/ }),

/***/ "./src/utils/createStore.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ducks__ = __webpack_require__("./src/ducks/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__("./node_modules/redux-thunk/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlewares_promiseMiddleware__ = __webpack_require__("./src/utils/middlewares/promiseMiddleware.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__("./node_modules/react-router-redux/es/index.js");
var composeEnhancers="production"!=='production'&&window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||__WEBPACK_IMPORTED_MODULE_1_redux__["compose"];var createStore=function createStore(history){var middleware=Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["routerMiddleware"])(history);return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["createStore"])(Object(__WEBPACK_IMPORTED_MODULE_1_redux__["combineReducers"])(Object.assign({},__WEBPACK_IMPORTED_MODULE_0_ducks__["a" /* reducers */],{router:__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["routerReducer"]})),composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_1_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_2_redux_thunk__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux__["applyMiddleware"])(__WEBPACK_IMPORTED_MODULE_3__middlewares_promiseMiddleware__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux__["applyMiddleware"])(middleware)));};/* harmony default export */ __webpack_exports__["a"] = (createStore);

/***/ }),

/***/ "./src/utils/helpers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkPerm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPerm; });
/* harmony export (immutable) */ __webpack_exports__["d"] = commaize;
/* harmony export (immutable) */ __webpack_exports__["f"] = getDateString;
/* harmony export (immutable) */ __webpack_exports__["b"] = capitalize;
/* unused harmony export lightenColor */
/* unused harmony export tripDateDiffString */
/* harmony export (immutable) */ __webpack_exports__["c"] = checkIdCardNumber;
/* harmony export (immutable) */ __webpack_exports__["m"] = removeArrayItem;
/* harmony export (immutable) */ __webpack_exports__["i"] = insertArrayItem;
/* harmony export (immutable) */ __webpack_exports__["l"] = randomUniqueString;
/* harmony export (immutable) */ __webpack_exports__["g"] = getDefaultNearestEffDate;
/* harmony export (immutable) */ __webpack_exports__["k"] = moveArray;
/* unused harmony export pickupOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return airportPickupOptions; });
/* unused harmony export basicPickupOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return joinedTransferPickupOptions; });
/* harmony export (immutable) */ __webpack_exports__["e"] = formatAMPM;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_wildcard__ = __webpack_require__("./node_modules/wildcard/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_wildcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_wildcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__("./node_modules/moment-timezone/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__("./node_modules/polished/dist/polished.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es__ = __webpack_require__("./node_modules/lodash-es/lodash.js");
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var checkPerm=function checkPerm(permission,permissions){var p=permission;if(typeof p==='string'){p=[permission];}return permissions.some(function(perm){return __WEBPACK_IMPORTED_MODULE_0_wildcard___default()(perm,permission).length>0;});};var getPerm=function getPerm(permission,permissions){var p=permission;if(typeof p==='string'){p=[permission];}return permissions.reduce(function(acc,cur){return[].concat(_toConsumableArray(acc),_toConsumableArray(__WEBPACK_IMPORTED_MODULE_0_wildcard___default()(cur,p)));},[]);};function commaize(num){return(num?num:0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');// eslint-disable-line
}function getDateString(date){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'all';if(!date)return'---';var momentParsed=__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(date);var dateFormat='DD-MMM-YYYY';var timeFormat='HH:mm';if(type==='all')return momentParsed.format(dateFormat+' '+timeFormat);else if(type==='date')return momentParsed.format(dateFormat);return momentParsed.format(timeFormat);}function capitalize(){var str=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return''+str.charAt(0).toUpperCase()+str.slice(1);}function lightenColor(date,color){var dateDiff=Math.abs(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(date).startOf('day').diff(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().startOf('day'),'day'));var maxRatio=60;var ratio=Math.abs(1-(maxRatio+10-(dateDiff>maxRatio?maxRatio:dateDiff))/maxRatio);return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* transparentize */])(ratio,color);}function tripDateDiffString(date){if(!date)return'';var dateDiff=__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(date).startOf('day').diff(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().startOf('day'),'day');if(dateDiff===0){return'Today';}else if(dateDiff>0){return'In '+dateDiff+' days';}return'Trip has passed';}function checkIdCardNumber(id){if(id.length!==13)return false;var sum=0;for(var i=0;i<12;i+=1){sum+=parseFloat(id.charAt(i))*(13-i);}if((11-sum%11)%10!==parseFloat(id.charAt(12)))return false;return true;}function removeArrayItem(arr,index){var cloneArr=Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["cloneDeep"])(arr);return[].concat(_toConsumableArray(cloneArr.slice(0,index)),_toConsumableArray(cloneArr.slice(index+1)));}function insertArrayItem(arr,item,where,index){var cloneArr=Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es__["cloneDeep"])(arr);if(where==='top'){return[].concat(_toConsumableArray(cloneArr.slice(0,index)),[item],_toConsumableArray(cloneArr.slice(index)));}else if(where==='bottom'){return[].concat(_toConsumableArray(cloneArr.slice(0,index+1)),[item],_toConsumableArray(cloneArr.slice(index+1)));}return cloneArr;}function randomUniqueString(){var randNum=Math.random().toString(36).substr(2);return randNum;}function getDefaultNearestEffDate(){var asString=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var startOfDay=__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().startOf('day');var deadlineHour=__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().hour(10).minute(0);var returnMoment=__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().add(1,'day');if(__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().isBefore(deadlineHour)&&__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().isSameOrAfter(startOfDay)){returnMoment=__WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()();}return asString?returnMoment.format('DD-MM-YYYY'):returnMoment;}function moveArray(arr,idx,direction){if(direction==='up'){return[].concat(_toConsumableArray(arr.slice(0,idx-1)),[arr[idx],arr[idx-1]],_toConsumableArray(arr.slice(idx+1)));}return[].concat(_toConsumableArray(arr.slice(0,idx)),[arr[idx+1],arr[idx]],_toConsumableArray(arr.slice(idx+2)));}var pickupOptions=['08:00','08:15','08:30','08:45','09:00','09:15','09:30','09:45','10:00','10:15','10:30','10:45','11:00','11:15','11:30','11:45','12:00','12:15','12:30','12:45','13:00','13:15','13:30','13:45','14:00','14:15','14:30','14:45','15:00','15:15','15:30','15:45','16:00','16:15','16:30','16:45','17:00','17:15','17:30','17:45','18:00'];var airportPickupOptions=['00:00','00:15','00:30','00:45','01:00','01:15','01:30','01:45','02:00','02:15','02:30','02:45','03:00','03:15','03:30','03:45','04:00','04:15','04:30','04:45','05:00','05:15','05:30','05:45','06:00','06:15','06:30','06:45','07:00','07:15','07:30','07:45','08:00','08:15','08:30','08:45','09:00','09:15','09:30','09:45','10:00','10:15','10:30','10:45','11:00','11:15','11:30','11:45','12:00','12:15','12:30','12:45','13:00','13:15','13:30','13:45','14:00','14:15','14:30','14:45','15:00','15:15','15:30','15:45','16:00','16:15','16:30','16:45','17:00','17:15','17:30','17:45','18:00','18:15','18:30','18:45','19:00','19:15','19:30','19:45','20:00','20:15','20:30','20:45','21:00','21:15','21:30','21:45','22:00','22:15','22:30','22:45','23:00','23:15','23:30','23:45'];var basicPickupOptions=['09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00'];var joinedTransferPickupOptions=['10:00','14:00','18:00'];function formatAMPM(momentDate){return momentDate.format('h:mm A');}

/***/ }),

/***/ "./src/utils/loadable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadSingle; });
/* unused harmony export loadMultiple */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_es_icon_style_css__ = __webpack_require__("./node_modules/antd/es/icon/style/css.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_icon__ = __webpack_require__("./node_modules/antd/es/icon/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_loadable__ = __webpack_require__("./node_modules/react-loadable/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_loadable__);
var LoadingComponent=function LoadingComponent(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_es_icon__["a" /* default */],{type:'loading'});};var loadSingle=function loadSingle(options){return __WEBPACK_IMPORTED_MODULE_3_react_loadable___default()(Object.assign({loading:LoadingComponent},options));};var loadMultiple=function loadMultiple(options){return __WEBPACK_IMPORTED_MODULE_3_react_loadable___default.a.Map(Object.assign({loading:LoadingComponent},options));};

/***/ }),

/***/ "./src/utils/media.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = path;
/* harmony export (immutable) */ __webpack_exports__["a"] = assetPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = upload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__("./src/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_theme_images_default_img_png__ = __webpack_require__("./src/theme/images/default-img.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_theme_images_default_img_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_theme_images_default_img_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_theme_images_default_pdf_png__ = __webpack_require__("./src/theme/images/default-pdf.png");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_theme_images_default_pdf_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_theme_images_default_pdf_png__);
var encodeBase64UrlSafe=function encodeBase64UrlSafe(str){return btoa(unescape(encodeURIComponent(str))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');};var convertPresetToImgproxy=function convertPresetToImgproxy(presetStr){if(!presetStr)return'';var parts=presetStr.split('-');var options=[];var width='';var height='';var fill=false;parts.forEach(function(part){if(part.startsWith('w'))width=part.substring(1);if(part.startsWith('h'))height=part.substring(1);if(part==='cfill')fill=true;if(part.startsWith('q'))options.push('q:'+part.substring(1));});if(width||height){options.unshift('rs:'+(fill?'fill':'fit')+':'+width+':'+height);}return options.join('/');};function path(image){var preset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'thumbnail';var style=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var original=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var nonWebP=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;// eslint-disable-line
var presets={thumbnail:'w400-h300-cfill-q80',listingThumbnail:'w580-h580-cfill-q80',profileAvatar:'w340-h340-cfill-q80',profileCover:'w2600-h800-cfill',avatarNavMini:'w74-h74-cfill',avatarTripCard:'w100-h100-cfill',coverTripCard:'w640-h576-cfill-q80',featureCover:'w800-h370-cfill-q80',inspCol1:'w660-h440-cfill-q80',inspCol2:'w1320-h440-cfill-q80',gallery:'w2560-h1440-q80',mobileGallery:'w720-h1280-q80',modalImage:'w500-h500-q80',profileNoti:'w40-h40',tripCover:'w1600-h1200-cfill','rectangle-310-233':'w310-h233-cfill-q80','rectangle-620-466':'w620-h466-cfill-q80'};if((!image||!image.match(/\.(jpg|jpeg|png|gif|bmp|JPG|JPEG|PNG|GIF|BMP)$/))&&!original){var isPDF=image?!!image.match(/\.(pdf|PDF)$/):false;if(style){return{backgroundImage:'url(\''+(isPDF?__WEBPACK_IMPORTED_MODULE_2_theme_images_default_pdf_png___default.a:__WEBPACK_IMPORTED_MODULE_1_theme_images_default_img_png___default.a)+'\')'};}return isPDF?__WEBPACK_IMPORTED_MODULE_2_theme_images_default_pdf_png___default.a:__WEBPACK_IMPORTED_MODULE_1_theme_images_default_img_png___default.a;}var baseUrl=nonWebP?__WEBPACK_IMPORTED_MODULE_0_config___default.a.nonWebPMediaPath:__WEBPACK_IMPORTED_MODULE_0_config___default.a.mediaPath;var options=preset!=='fullSize'&&presets[preset]?convertPresetToImgproxy(presets[preset]):'';var s3Path='s3://'+__WEBPACK_IMPORTED_MODULE_0_config___default.a.s3Bucket+'/'+image;var encodedUrl=encodeBase64UrlSafe(s3Path);var url=baseUrl+'/insecure/'+(options?options+'/':'')+encodedUrl;if(style){return{backgroundImage:'url(\''+url+'\')'};}return url;}function assetPath(file){var isPDF=!!file.match(/\.(pdf|PDF)$/);return(isPDF?__WEBPACK_IMPORTED_MODULE_0_config___default.a.pdfPath:__WEBPACK_IMPORTED_MODULE_0_config___default.a.assetPath)+'/'+file;// return  `${config.assetPath}/${file}`;
}function upload(file,type){var isPublic=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return fetch(__WEBPACK_IMPORTED_MODULE_0_config___default.a.apiPath+'/files/upload/'+type+'?filename='+file.name+'&public='+isPublic,{method:'GET',credentials:'include'}).then(function(res){return res.json();}).then(function(data){var formData=new FormData();Object.keys(data.params).forEach(function(key){formData.append(key,data.params[key]);});formData.append('file',file);return fetch(data.form_url,{method:'POST',body:formData,credentials:'include',header:{'Content-Type':'multipart/form-data'}}).then(function(res){if(res.ok)return Promise.resolve(data.params.key);return Promise.reject(res);});});}

/***/ }),

/***/ "./src/utils/middlewares/promiseMiddleware.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("./node_modules/babel-runtime/regenerator/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_es_message_style_css__ = __webpack_require__("./node_modules/antd/es/message/style/css.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_es_message__ = __webpack_require__("./node_modules/antd/es/message/index.js");
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/* harmony default export */ __webpack_exports__["a"] = (function(){return function(next){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(action){var data,resp;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(action.promise){_context.next=2;break;}return _context.abrupt('return',next(action));case 2:next(Object.assign({},action,{type:action.type.PENDING}));data=void 0;_context.prev=4;_context.next=7;return action.promise;case 7:resp=_context.sent;data=resp.data;if(action.success){__WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].success(action.success);}_context.next=18;break;case 12:_context.prev=12;_context.t0=_context['catch'](4);if(action.error){__WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].error(action.error);}__WEBPACK_IMPORTED_MODULE_2_antd_es_message__["a" /* default */].error(_context.t0.message,5);next(Object.assign({},action,{type:action.type.REJECTED,error:_context.t0}));throw _context.t0;case 18:next(Object.assign({},action,{type:action.type.RESOLVED,data:data}));return _context.abrupt('return',data);case 20:case'end':return _context.stop();}}},_callee,_this,[[4,12]]);}));return function(_x){return _ref.apply(this,arguments);};}();};});

/***/ })

},["./src/index.js"]);


// WEBPACK FOOTER //
// static/js/1.7efd5578.js